import { jsx as re, jsxs as xe } from "react/jsx-runtime";
import * as g from "react";
import we, { forwardRef as Ut, createElement as $e, isValidElement as tr, cloneElement as es, Children as zs, Fragment as Ks, createContext as Ws, useContext as ts, useState as rs, useRef as Xr, useEffect as ht, useCallback as Zr, useMemo as Gt, useId as ns } from "react";
export * from "@canvas-logic/clp-localization/react";
function Js(t, e) {
  for (var r = 0; r < e.length; r++) {
    const n = e[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const s in n)
        if (s !== "default" && !(s in t)) {
          const i = Object.getOwnPropertyDescriptor(n, s);
          i && Object.defineProperty(t, s, i.get ? i : {
            enumerable: !0,
            get: () => n[s]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
var Et = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Lr = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var pn;
function Xs() {
  return pn || (pn = 1, (function(t) {
    (function() {
      var e = {}.hasOwnProperty;
      function r() {
        for (var n = [], s = 0; s < arguments.length; s++) {
          var i = arguments[s];
          if (i) {
            var a = typeof i;
            if (a === "string" || a === "number")
              n.push(i);
            else if (Array.isArray(i)) {
              if (i.length) {
                var o = r.apply(null, i);
                o && n.push(o);
              }
            } else if (a === "object") {
              if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
                n.push(i.toString());
                continue;
              }
              for (var l in i)
                e.call(i, l) && i[l] && n.push(l);
            }
          }
        }
        return n.join(" ");
      }
      t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
    })();
  })(Lr)), Lr.exports;
}
var Gs = Xs();
const de = /* @__PURE__ */ Gr(Gs), Ys = "_icon_1gwry_1", Qs = "_svg_1gwry_12", ei = "_colored_1gwry_15", kr = {
  icon: Ys,
  svg: Qs,
  colored: ei
}, ti = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.94871 8.68377C9.8126 8.27543 9.43046 8 9.00003 8C8.5696 8 8.18746 8.27543 8.05134 8.68377L6.05134 14.6838C5.8767 15.2077 6.15986 15.774 6.6838 15.9487C7.20774 16.1233 7.77406 15.8402 7.94871 15.3162L8.05412 15H9.94593L10.0513 15.3162C10.226 15.8402 10.7923 16.1233 11.3163 15.9487C11.8402 15.774 12.1234 15.2077 11.9487 14.6838L9.94871 8.68377ZM9.00003 12.1623L9.27927 13H8.72079L9.00003 12.1623Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 8C13.4477 8 13 8.44772 13 9V15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15V14L16.2 15.6C16.5314 16.0418 17.1582 16.1314 17.6 15.8C18.0418 15.4686 18.1314 14.8418 17.8 14.4L16.5701 12.7601C17.4154 12.3591 18 11.4978 18 10.5C18 9.11929 16.8807 8 15.5 8H14ZM15 10V11H15.5C15.7761 11 16 10.7761 16 10.5C16 10.2239 15.7761 10 15.5 10H15Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 8C2 4.68629 4.68629 2 8 2H16C19.3137 2 22 4.68629 22 8V16C22 19.3137 19.3137 22 16 22H8C4.68629 22 2 19.3137 2 16V8ZM8 4H16C18.2091 4 20 5.79086 20 8V16C20 18.2091 18.2091 20 16 20H8C5.79086 20 4 18.2091 4 16V8C4 5.79086 5.79086 4 8 4Z" })), ri = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L13.7071 18.7071C13.3166 19.0976 12.6834 19.0976 12.2929 18.7071C11.9024 18.3166 11.9024 17.6834 12.2929 17.2929L16.5858 13H5C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11H16.5858L12.2929 6.70711Z" })), ni = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L4.29289 11.2929C3.90237 11.6834 3.90237 12.3166 4.29289 12.7071L10.2929 18.7071C10.6834 19.0976 11.3166 19.0976 11.7071 18.7071C12.0976 18.3166 12.0976 17.6834 11.7071 17.2929L7.41421 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H7.41421L11.7071 6.70711Z" })), si = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M11.7071 8.70711C12.0976 8.31658 12.0976 7.68342 11.7071 7.29289C11.3166 6.90237 10.6834 6.90237 10.2929 7.29289L6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L10.2929 16.7071C10.6834 17.0976 11.3166 17.0976 11.7071 16.7071C12.0976 16.3166 12.0976 15.6834 11.7071 15.2929L9.41421 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H9.41421L11.7071 8.70711Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), ii = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12.2929 6.70711C11.9024 6.31658 11.9024 5.68342 12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071L13.7071 18.7071C13.3166 19.0976 12.6834 19.0976 12.2929 18.7071C11.9024 18.3166 11.9024 17.6834 12.2929 17.2929L16.5858 13H5C4.44771 13 4 12.5523 4 12C4 11.4477 4.44771 11 5 11H16.5858L12.2929 6.70711Z" })), ai = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289C12.6834 6.90237 13.3166 6.90237 13.7071 7.29289L17.7071 11.2929C18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L13.7071 16.7071C13.3166 17.0976 12.6834 17.0976 12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929L14.5858 13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H14.5858L12.2929 8.70711Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), oi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M5 0L0 2L5 4L10 2L5 0Z", fill: "white" }), /* @__PURE__ */ g.createElement("path", { d: "M5 5L2.5 4L0 5L5 7L10 5L7.5 4L5 5Z", fill: "white" }), /* @__PURE__ */ g.createElement("path", { d: "M5 8L2.5 7L0 8L5 10L10 8L7.5 7L5 8Z", fill: "white" })), li = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8C9.23858 8 7 10.2386 7 13C7 15.7614 9.23858 18 12 18C14.7614 18 17 15.7614 17 13C17 10.2386 14.7614 8 12 8ZM9 13C9 11.3431 10.3431 10 12 10C13.6569 10 15 11.3431 15 13C15 14.6569 13.6569 16 12 16C10.3431 16 9 14.6569 9 13Z", fill: "white" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0704 2C9.06731 2 8.13061 2.5013 7.57422 3.3359L6.46482 5H3C2.20435 5 1.44129 5.31607 0.87868 5.87868C0.316071 6.44129 0 7.20435 0 8V19C0 19.7957 0.316071 20.5587 0.87868 21.1213C1.44129 21.6839 2.20435 22 3 22H21C21.7957 22 22.5587 21.6839 23.1213 21.1213C23.6839 20.5587 24 19.7957 24 19V8C24 7.20435 23.6839 6.44129 23.1213 5.87868C22.5587 5.31607 21.7957 5 21 5H17.5352L16.4258 3.3359C15.8694 2.5013 14.9327 2 13.9296 2H10.0704ZM9.23832 4.4453C9.42378 4.1671 9.73601 4 10.0704 4H13.9296C14.264 4 14.5762 4.1671 14.7617 4.4453L16.1679 6.5547C16.3534 6.8329 16.6656 7 17 7H21C21.2652 7 21.5196 7.10536 21.7071 7.29289C21.8946 7.48043 22 7.73478 22 8V19C22 19.2652 21.8946 19.5196 21.7071 19.7071C21.5196 19.8946 21.2652 20 21 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V8C2 7.73478 2.10536 7.48043 2.29289 7.29289C2.48043 7.10536 2.73478 7 3 7H7C7.33435 7 7.64658 6.8329 7.83205 6.5547L9.23832 4.4453Z", fill: "white" })), ci = (t) => /* @__PURE__ */ g.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "#000000", ...t }, /* @__PURE__ */ g.createElement("path", { d: "m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" })), ui = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" })), di = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C8.10536 12.5196 8 12.2652 8 12C8 11.7348 8.10536 11.4804 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z" })), fi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M8.29289 5.29289C7.90237 5.68342 7.90237 6.31658 8.29289 6.70711L13.5858 12L8.29289 17.2929C7.90237 17.6834 7.90237 18.3166 8.29289 18.7071C8.68342 19.0976 9.31658 19.0976 9.70711 18.7071L15.7071 12.7071C15.8946 12.5196 16 12.2652 16 12C16 11.7348 15.8946 11.4804 15.7071 11.2929L9.70711 5.29289C9.31658 4.90237 8.68342 4.90237 8.29289 5.29289Z" })), hi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.29289 15.7071C5.68342 16.0976 6.31658 16.0976 6.70711 15.7071L12 10.4142L17.2929 15.7071C17.6834 16.0976 18.3166 16.0976 18.7071 15.7071C19.0976 15.3166 19.0976 14.6834 18.7071 14.2929L12.7071 8.29289C12.5196 8.10536 12.2652 8 12 8C11.7348 8 11.4804 8.10536 11.2929 8.29289L5.29289 14.2929C4.90237 14.6834 4.90237 15.3166 5.29289 15.7071Z" })), pi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("g", { clipPath: "url(#clip0_11031_191177)" }, /* @__PURE__ */ g.createElement("g", { clipPath: "url(#clip1_11031_191177)" }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C12.5523 21.5 13 21.9477 13 22.5C13 23.0523 12.5523 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 12.5523 23.0523 13 22.5 13C21.9477 13 21.5 12.5523 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5Z", fill: "#2B2B2B", fillOpacity: 0.88 }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 18.75C14 16.1266 16.1266 14 18.75 14C21.3734 14 23.5 16.1266 23.5 18.75C23.5 21.3734 21.3734 23.5 18.75 23.5C16.1266 23.5 14 21.3734 14 18.75Z", fill: "#7E9F5A" }))), /* @__PURE__ */ g.createElement("defs", null, /* @__PURE__ */ g.createElement("clipPath", { id: "clip0_11031_191177" }, /* @__PURE__ */ g.createElement("rect", { width: 24, height: 24, fill: "white" })), /* @__PURE__ */ g.createElement("clipPath", { id: "clip1_11031_191177" }, /* @__PURE__ */ g.createElement("rect", { width: 24, height: 24, fill: "white" })))), gi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M18.6768 6.59968C19.0674 6.20916 19.0674 5.576 18.6768 5.18547C18.2863 4.79495 17.6531 4.79495 17.2626 5.18547L11.9697 10.4784L6.67683 5.18547C6.28631 4.79495 5.65314 4.79495 5.26262 5.18547C4.8721 5.576 4.8721 6.20916 5.26262 6.59968L10.5555 11.8926L5.26262 17.1855C4.8721 17.576 4.8721 18.2092 5.26262 18.5997C5.65314 18.9902 6.28631 18.9902 6.67683 18.5997L11.9697 13.3068L17.2626 18.5997C17.6531 18.9902 18.2863 18.9902 18.6768 18.5997C19.0674 18.2092 19.0674 17.576 18.6768 17.1855L13.3839 11.8926L18.6768 6.59968Z" })), mi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M15.5355 9.87868C15.9261 9.48816 15.9261 8.85499 15.5355 8.46447C15.145 8.07394 14.5118 8.07394 14.1213 8.46447L12 10.5858L9.87868 8.46447C9.48816 8.07394 8.85499 8.07394 8.46447 8.46447C8.07394 8.85499 8.07394 9.48816 8.46447 9.87868L10.5858 12L8.46447 14.1213C8.07394 14.5118 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 9.48816 15.9261 9.87868 15.5355L12 13.4142L14.1213 15.5355C14.5118 15.9261 15.145 15.9261 15.5355 15.5355C15.9261 15.145 15.9261 14.5118 15.5355 14.1213L13.4142 12L15.5355 9.87868Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), yi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM15.5355 9.87868C15.9261 9.48816 15.9261 8.85499 15.5355 8.46447C15.145 8.07394 14.5118 8.07394 14.1213 8.46447L12 10.5858L9.87868 8.46447C9.48816 8.07394 8.85499 8.07394 8.46447 8.46447C8.07394 8.85499 8.07394 9.48816 8.46447 9.87868L10.5858 12L8.46447 14.1213C8.07394 14.5118 8.07394 15.145 8.46447 15.5355C8.85499 15.9261 9.48816 15.9261 9.87868 15.5355L12 13.4142L14.1213 15.5355C14.5118 15.9261 15.145 15.9261 15.5355 15.5355C15.9261 15.145 15.9261 14.5118 15.5355 14.1213L13.4142 12L15.5355 9.87868Z" })), vi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M10 4C10 3.44772 9.55228 3 9 3C8.44772 3 8 3.44772 8 4V6.58579L3.70711 2.29289C3.31658 1.90237 2.68342 1.90237 2.29289 2.29289C1.90237 2.68342 1.90237 3.31658 2.29289 3.70711L6.58579 8H4C3.44772 8 3 8.44772 3 9C3 9.55228 3.44772 10 4 10H9C9.55228 10 10 9.55228 10 9V4Z" }), /* @__PURE__ */ g.createElement("path", { d: "M14 20C14 20.5523 14.4477 21 15 21C15.5523 21 16 20.5523 16 20V17.4142L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L17.4142 16H20C20.5523 16 21 15.5523 21 15C21 14.4477 20.5523 14 20 14H15C14.4477 14 14 14.4477 14 15V20Z" })), Ci = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("rect", { x: 6, y: 8, width: 12, height: 8, rx: 4 })), bi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 6C5.68629 6 3 8.68629 3 12C3 15.3137 5.68629 18 9 18C10.8055 18 12.4191 17.1781 13.5 15.8912C13.0358 15.333 12.6609 14.6953 12.3984 14H11C10.4477 14 10 13.5523 10 13C10 12.4477 10.4477 12 11 12H12.0236C12.008 11.6698 12 11.3362 12 11C12 10.3424 12.0659 9.7 12.1911 9.08003C12.4211 7.88523 12.911 6.7874 13.5875 5.83847C12.4879 4.69261 10.8273 4 9 4V6ZM15 6C18.3137 6 21 8.68629 21 12C21 15.3137 18.3137 18 15 18C13.1945 18 11.5809 17.1781 10.5 15.8912C10.9642 15.333 11.3391 14.6953 11.6016 14H13C13.5523 14 14 13.5523 14 13C14 12.4477 13.5523 12 13 12H11.9764C11.992 11.6698 12 11.3362 12 11C12 10.3424 11.9341 9.7 11.8089 9.08003C11.5789 7.88523 11.089 6.7874 10.4125 5.83847C11.5121 4.69261 13.1727 4 15 4V6Z" })), _i = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("circle", { cx: 10, cy: 9, r: 4.5 }), /* @__PURE__ */ g.createElement("circle", { cx: 14, cy: 9, r: 4.5 }), /* @__PURE__ */ g.createElement("circle", { cx: 12, cy: 14, r: 4.5 })), wi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("circle", { cx: 12, cy: 5, r: 2.5 }), /* @__PURE__ */ g.createElement("circle", { cx: 18, cy: 9.5, r: 2.5 }), /* @__PURE__ */ g.createElement("circle", { cx: 15.5, cy: 17, r: 2.5 }), /* @__PURE__ */ g.createElement("circle", { cx: 8.5, cy: 17, r: 2.5 }), /* @__PURE__ */ g.createElement("circle", { cx: 6, cy: 9.5, r: 2.5 })), xi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M4 3C3.44772 3 3 3.44772 3 4V9C3 9.55228 3.44772 10 4 10C4.55228 10 5 9.55228 5 9V6.41421L9.29289 10.7071C9.68342 11.0976 10.3166 11.0976 10.7071 10.7071C11.0976 10.3166 11.0976 9.68342 10.7071 9.29289L6.41421 5H9C9.55228 5 10 4.55228 10 4C10 3.44772 9.55228 3 9 3H4Z" }), /* @__PURE__ */ g.createElement("path", { d: "M20 21C20.5523 21 21 20.5523 21 20V15C21 14.4477 20.5523 14 20 14C19.4477 14 19 14.4477 19 15V17.5858L14.7071 13.2929C14.3166 12.9024 13.6834 12.9024 13.2929 13.2929C12.9024 13.6834 12.9024 14.3166 13.2929 14.7071L17.5858 19H15C14.4477 19 14 19.4477 14 20C14 20.5523 14.4477 21 15 21H20Z" })), Si = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12 8C11.4477 8 11 7.55237 11 7.00008C11 6.4478 11.4477 6 12 6L17 6.00008C17.5523 6.00008 18 6.4478 18 7.00008V12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12V8.00008L12 8Z" }), /* @__PURE__ */ g.createElement("path", { d: "M8 12C8 11.4477 7.55229 11 7 11C6.44772 11 6 11.4477 6 12L6 17.0001C6 17.5524 6.44772 18.0001 7 18.0001L12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16L8 16.0001V12Z" })), Ei = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12 7C10.3431 7 9 8.34315 9 10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10C11 9.44772 11.4477 9 12 9C12.5523 9 13 9.44772 13 10C13 10.3788 12.786 10.5981 12.3492 10.9275C12.1644 11.0669 11.9625 11.2026 11.7459 11.3484C11.5763 11.4625 11.3982 11.582 11.2207 11.7121C10.7003 12.0936 10 12.7596 10 14C10 14.5523 10.4477 15 11 15C11.5523 15 12 14.5523 12 14C12 13.7404 12.0497 13.6564 12.2793 13.4879C12.3768 13.416 12.5013 13.3375 12.6541 13.2399C12.8724 13.1007 13.1356 12.9331 13.3883 12.7225C14.214 12.0519 15 10.9712 15 10C15 8.34315 13.6569 7 12 7Z" }), /* @__PURE__ */ g.createElement("path", { d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), Li = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z" }), /* @__PURE__ */ g.createElement("path", { d: "M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), ki = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z" })), Oi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7071 3.46447C13.7545 1.51184 10.5887 1.51184 8.63604 3.46447L6.51472 5.58579C4.5621 7.53841 4.5621 10.7043 6.51472 12.6569C6.90524 13.0474 7.53841 13.0474 7.92893 12.6569C8.31946 12.2664 8.31946 11.6332 7.92893 11.2427C6.75736 10.0711 6.75736 8.17157 7.92893 7L10.0503 4.87868C11.2218 3.70711 13.1213 3.70711 14.2929 4.87868C15.4645 6.05025 15.4645 7.94975 14.2929 9.12132L12.1716 11.2426C11.7811 11.6332 11.7811 12.2663 12.1716 12.6569C12.5621 13.0474 13.1953 13.0474 13.5858 12.6569L15.7071 10.5355C17.6597 8.58291 17.6597 5.41709 15.7071 3.46447ZM17.4853 11.3431C17.0948 10.9526 16.4616 10.9526 16.0711 11.3431C15.6805 11.7337 15.6805 12.3668 16.0711 12.7574C17.2426 13.9289 17.2426 15.8284 16.0711 17L13.9497 19.1213C12.7782 20.2929 10.8787 20.2929 9.70711 19.1213C8.53553 17.9497 8.53553 16.0503 9.70711 14.8787L11.8284 12.7574C12.219 12.3668 12.219 11.7337 11.8284 11.3431C11.4379 10.9526 10.8047 10.9526 10.4142 11.3431L8.29289 13.4645C6.34027 15.4171 6.34027 18.5829 8.29289 20.5355C10.2455 22.4882 13.4113 22.4882 15.364 20.5355L17.4853 18.4142C19.4379 16.4616 19.4379 13.2957 17.4853 11.3431Z" })), Ai = (t) => /* @__PURE__ */ g.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2C5.79086 2 4 3.79086 4 6V6.17071C2.83481 6.58254 2 7.69378 2 9V11C2 12.6569 3.34315 14 5 14H11C12.6569 14 14 12.6569 14 11V9C14 7.69378 13.1652 6.58254 12 6.17071V6C12 3.79086 10.2091 2 8 2ZM10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6H10ZM4 9C4 8.44772 4.44772 8 5 8H11C11.5523 8 12 8.44772 12 9V11C12 11.5523 11.5523 12 11 12H5C4.44772 12 4 11.5523 4 11V9Z" })), Ti = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H5Z" })), Ri = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H16C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11H8Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), Ni = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M14 6C14 7.10457 13.1046 8 12 8C10.8954 8 10 7.10457 10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6Z" }), /* @__PURE__ */ g.createElement("path", { d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z" }), /* @__PURE__ */ g.createElement("path", { d: "M12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20Z" })), Pi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M14.5 10.5L19.5 7.50005L16.5 4.00005L12.5 3.50005V9.00005L14.5 10.5Z", fill: "#F8B0B0" }), /* @__PURE__ */ g.createElement("path", { d: "M9.5 10.5L4.5 7.5L7 4.5L11.5 3.5V9L9.5 10.5Z", fill: "#F8E3B0" }), /* @__PURE__ */ g.createElement("path", { d: "M9 11L4.5 8.5L3 12L4 16L9 13.5V11Z", fill: "#BBF8B0" }), /* @__PURE__ */ g.createElement("path", { d: "M11.5 15.5V20.5L7.5 19.5L4.5 17L9.5 14L11.5 15.5Z", fill: "#B0F8F7" }), /* @__PURE__ */ g.createElement("path", { d: "M12 15.5L12.5 20.5L16.5 19.5L19 16.5L15 14L12 15.5Z", fill: "#B0B8F8" }), /* @__PURE__ */ g.createElement("path", { d: "M15 11L20 8L21 12L19.5 16L15 13V11Z", fill: "#F8B0F5" }), /* @__PURE__ */ g.createElement("path", { d: "M12 3V9M12 15V21M4.20581 7.5L9.40196 10.5M14.5981 13.5L19.7943 16.5M14.5981 10.5L19.7943 7.5M4.20581 16.5L9.40196 13.5", stroke: "#3C3F45", strokeWidth: 2 }), /* @__PURE__ */ g.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "#3C3F45", strokeWidth: 2 }), /* @__PURE__ */ g.createElement("circle", { cx: 12, cy: 12, r: 3, stroke: "#3C3F45", strokeWidth: 2 })), Vi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("g", { clipPath: "url(#clip0_11031_191172)" }, /* @__PURE__ */ g.createElement("g", { clipPath: "url(#clip1_11031_191172)" }, /* @__PURE__ */ g.createElement("path", { d: "M12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5C12.3318 23.5 12.642 23.3354 12.8281 23.0606C13.0141 22.7859 13.0517 22.4367 12.9285 22.1286C12.0483 19.9281 12.2597 16.8353 14.2375 14.6753C15.3157 13.4978 16.502 12.8611 17.79 12.6109C19.0966 12.357 20.5721 12.4892 22.2253 12.9615C22.527 13.0477 22.8517 12.9873 23.1022 12.7983C23.3527 12.6094 23.5 12.3138 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5Z", fill: "#7E9F5A" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.75 16C17.2312 16 16 17.2312 16 18.75C16 20.2688 17.2312 21.5 18.75 21.5C20.2688 21.5 21.5 20.2688 21.5 18.75C21.5 17.2312 20.2688 16 18.75 16ZM14 18.75C14 16.1266 16.1266 14 18.75 14C21.3734 14 23.5 16.1266 23.5 18.75C23.5 21.3734 21.3734 23.5 18.75 23.5C16.1266 23.5 14 21.3734 14 18.75Z", fill: "#2B2B2B", fillOpacity: 0.88 }))), /* @__PURE__ */ g.createElement("defs", null, /* @__PURE__ */ g.createElement("clipPath", { id: "clip0_11031_191172" }, /* @__PURE__ */ g.createElement("rect", { width: 24, height: 24, fill: "white" })), /* @__PURE__ */ g.createElement("clipPath", { id: "clip1_11031_191172" }, /* @__PURE__ */ g.createElement("rect", { width: 24, height: 24, fill: "white" })))), Mi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 3C6 2.44772 6.44772 2 7 2H14C14.2652 2 14.5196 2.10536 14.7071 2.29289L19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V21C20 21.5523 19.5523 22 19 22H17C16.4477 22 16 21.5523 16 21C16 20.4477 16.4477 20 17 20H18V8.41421L13.5858 4H7C6.44772 4 6 3.55228 6 3Z", fill: "currentColor" }), /* @__PURE__ */ g.createElement("path", { d: "M6 9C6 9.55228 6.44772 10 7 10H13C13.5523 10 14 9.55228 14 9C14 8.44772 13.5523 8 13 8H11V7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7V8H8V6C8 5.44772 7.55228 5 7 5C6.44772 5 6 5.44772 6 6V9Z", fill: "currentColor" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 21C6 21.2652 6.10536 21.5196 6.29289 21.7071C6.48043 21.8946 6.73478 22 7 22H13C13.5523 22 14 21.5523 14 21C14 20.4477 13.5523 20 13 20H11V19.5C11 18.1193 9.88071 17 8.5 17C7.11929 17 6 18.1193 6 19.5V21ZM9 19.5V20H8V19.5C8 19.2239 8.22386 19 8.5 19C8.77614 19 9 19.2239 9 19.5Z", fill: "currentColor" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 15C6 15.5523 6.44772 16 7 16H13C13.5523 16 14 15.5523 14 15V14C14 12.3431 12.6569 11 11 11H9C7.34315 11 6 12.3431 6 14V15ZM11 13C11.5523 13 12 13.4477 12 14H8C8 13.4477 8.44772 13 9 13H11Z", fill: "currentColor" })), ji = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" }), /* @__PURE__ */ g.createElement("path", { d: "M16.2426 7.75736C16.6332 8.14789 16.6332 8.78105 16.2426 9.17157L9.17157 16.2426C8.78105 16.6332 8.14789 16.6332 7.75736 16.2426C7.36684 15.8521 7.36684 15.219 7.75736 14.8284L14.8284 7.75736C15.219 7.36684 15.8521 7.36684 16.2426 7.75736Z" })), Fi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5V11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H13V5Z" })), Ii = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M12 7C12.5523 7 13 7.44772 13 8V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V13H8C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11H11V8C11 7.44772 11.4477 7 12 7Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" })), Zi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M20 4C20 3.44772 19.5523 3 19 3C18.4477 3 18 3.44772 18 4V7.126C16.7252 5.20827 14.5104 4 12 4C7.58172 4 4 7.58172 4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 8.68629 8.68629 6 12 6C14.0089 6 15.7849 7.01498 16.8135 8.57463L13 9C12.4477 9.05517 12.0523 9.55228 12.1075 10.1046C12.1626 10.6568 12.6597 11.0523 13.212 10.997L19.1585 10.4026C19.6918 10.3493 20.0937 9.89708 20.0404 9.3638L19.446 3.41421C19.3908 2.86193 18.8937 2.46648 18.3414 2.52165C17.7891 2.57683 17.3937 3.07394 17.4489 3.62622L17.598 5.12132" }), /* @__PURE__ */ g.createElement("path", { d: "M4 20C4 20.5523 4.44772 21 5 21C5.55228 21 6 20.5523 6 20V16.874C7.27484 18.7917 9.48957 20 12 20C16.4183 20 20 16.4183 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 15.3137 15.3137 18 12 18C9.99113 18 8.21507 16.985 7.18652 15.4254L11 15C11.5523 14.9448 11.9477 14.4477 11.8925 13.8954C11.8374 13.3432 11.3403 12.9477 10.788 13.003L4.84149 13.5974C4.30821 13.6507 3.90632 14.1029 3.95962 14.6362L4.55403 20.5858C4.60921 21.1381 5.10632 21.5335 5.65861 21.4784C6.21089 21.4232 6.60634 20.9261 6.55116 20.3738L6.40198 18.8787" })), $i = (t) => /* @__PURE__ */ g.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M8 3.5C9.45238 3.5 10.8058 3.8444 11.8125 4.51367C12.831 5.19093 13.5 6.21043 13.5 7.5C13.5 8.78959 12.831 9.8091 11.8125 10.4863C10.8529 11.1242 9.57821 11.4654 8.20312 11.4961L8.85352 12.1465L8.91797 12.2246C9.04612 12.4187 9.02437 12.6827 8.85352 12.8535C8.68265 13.0244 8.41868 13.0461 8.22461 12.918L8.14648 12.8535L6.64648 11.3535C6.55272 11.2598 6.50001 11.1326 6.5 11C6.5 10.9006 6.52964 10.8042 6.58398 10.7227L6.64648 10.6465L8.14648 9.14648L8.22461 9.08203C8.41869 8.95387 8.68265 8.97562 8.85352 9.14648C9.02437 9.31735 9.04613 9.58132 8.91797 9.77539L8.85352 9.85352L8.21289 10.4932C9.43315 10.4612 10.4997 10.1589 11.2588 9.6543C12.0497 9.12847 12.5 8.39789 12.5 7.5C12.5 6.60214 12.0497 5.87156 11.2588 5.3457C10.4558 4.81188 9.30899 4.5 8 4.5C6.69101 4.5 5.5442 4.81188 4.74121 5.3457C3.95027 5.87156 3.50003 6.60214 3.5 7.5C3.5 7.91017 3.59285 8.27798 3.76172 8.60449L3.83887 8.74121L3.88184 8.83301C3.95982 9.0522 3.87585 9.3028 3.66895 9.42773C3.46227 9.55243 3.20162 9.51045 3.04395 9.33984L2.98242 9.25879L2.87305 9.06152C2.63152 8.59374 2.5 8.06947 2.5 7.5C2.50003 6.21043 3.16899 5.19093 4.1875 4.51367C5.19415 3.8444 6.54762 3.5 8 3.5Z", fill: "#2B2B2B", fillOpacity: 0.88 })), Di = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C11.2958 16 12.4957 15.5892 13.4765 14.8907L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L14.8907 13.4765C15.5892 12.4957 16 11.2958 16 10C16 6.68629 13.3137 4 10 4ZM6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10Z" })), Bi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0C11.2044 0 10.4413 0.316071 9.87868 0.87868C9.31607 1.44129 9 2.20435 9 3V3.1675C8.99921 3.29374 8.96167 3.41704 8.89195 3.52232C8.84498 3.59323 8.78479 3.6539 8.71507 3.70122C8.64693 3.71549 8.58027 3.73687 8.51624 3.76514C8.39742 3.81758 8.26561 3.83322 8.13782 3.81005C8.01142 3.78713 7.89468 3.72728 7.80231 3.6381L7.7475 3.58329C7.46888 3.30436 7.13802 3.08308 6.77382 2.93211C6.40963 2.78113 6.01925 2.70343 5.625 2.70343C5.23075 2.70343 4.84037 2.78113 4.47618 2.93211C4.11216 3.08301 3.78143 3.30415 3.50289 3.58289C3.22415 3.86143 3.00301 4.19216 2.85211 4.55618C2.70113 4.92037 2.62343 5.31075 2.62343 5.705C2.62343 6.09925 2.70113 6.48963 2.85211 6.85382C3.00308 7.21802 3.22436 7.54888 3.50329 7.8275L3.5581 7.88231C3.64728 7.97468 3.70713 8.09142 3.73005 8.21782C3.75322 8.34561 3.73758 8.47742 3.68514 8.59624C3.67663 8.61551 3.66874 8.63505 3.66146 8.65482C3.61644 8.77723 3.53564 8.88326 3.42955 8.95914C3.32591 9.03327 3.20283 9.07526 3.07564 9.08H3C2.20435 9.08 1.44129 9.39607 0.87868 9.95868C0.316071 10.5213 0 11.2844 0 12.08C0 12.8756 0.316071 13.6387 0.87868 14.2013C1.44129 14.7639 2.20435 15.08 3 15.08H3.1675C3.29374 15.0808 3.41704 15.1183 3.52232 15.1881C3.62801 15.258 3.71087 15.3574 3.76081 15.474L3.76514 15.4838C3.81758 15.6026 3.83322 15.7344 3.81005 15.8622C3.78713 15.9886 3.72728 16.1053 3.63811 16.1977L3.58329 16.2525C3.30436 16.5311 3.08308 16.862 2.93211 17.2262C2.78113 17.5904 2.70343 17.9808 2.70343 18.375C2.70343 18.7692 2.78113 19.1596 2.93211 19.5238C3.08308 19.888 3.30436 20.2189 3.58329 20.4975C3.86174 20.7761 4.19233 20.9971 4.55618 21.1479C4.92037 21.2989 5.31075 21.3766 5.705 21.3766C6.09925 21.3766 6.48963 21.2989 6.85382 21.1479C7.21784 20.997 7.54896 20.7755 7.8275 20.4967L7.8823 20.4419C7.97467 20.3527 8.09142 20.2929 8.21782 20.27C8.34561 20.2468 8.47742 20.2624 8.59624 20.3149C8.61551 20.3234 8.63505 20.3313 8.65482 20.3385C8.77723 20.3836 8.88326 20.4644 8.95914 20.5704C9.03327 20.6741 9.07526 20.7972 9.08 20.9244V21C9.08 21.7957 9.39607 22.5587 9.95868 23.1213C10.5213 23.6839 11.2843 24 12.08 24C12.8757 24 13.6387 23.6839 14.2013 23.1213C14.7639 22.5587 15.08 21.7957 15.08 21V20.8325C15.0808 20.7063 15.1183 20.583 15.1881 20.4777C15.258 20.372 15.3574 20.2891 15.474 20.2392L15.4838 20.2349C15.6026 20.1824 15.7344 20.1668 15.8622 20.19C15.9886 20.2129 16.1053 20.2727 16.1977 20.3619L16.2529 20.4171C16.5314 20.6959 16.8622 20.917 17.2262 21.0679C17.5904 21.2189 17.9808 21.2966 18.375 21.2966C18.7692 21.2966 19.1596 21.2189 19.5238 21.0679C19.8878 20.917 20.2186 20.6959 20.4971 20.4171C20.7759 20.1386 20.997 19.8078 21.1479 19.4438C21.2989 19.0796 21.3766 18.6892 21.3766 18.295C21.3766 17.9008 21.2989 17.5104 21.1479 17.1462C20.997 16.7822 20.7755 16.451 20.4967 16.1725L20.4419 16.1177C20.3527 16.0253 20.2929 15.9086 20.27 15.7822C20.2468 15.6544 20.2625 15.5226 20.3149 15.4038L20.3191 15.3939C20.3691 15.2774 20.452 15.178 20.5577 15.1081C20.663 15.0383 20.7863 15.0008 20.9125 15H21C21.7957 15 22.5587 14.6839 23.1213 14.1213C23.6839 13.5587 24 12.7957 24 12C24 11.2043 23.6839 10.4413 23.1213 9.87868C22.5587 9.31607 21.7957 9 21 9H20.8325C20.7063 8.99921 20.583 8.96167 20.4777 8.89195C20.4068 8.84498 20.3461 8.78479 20.2988 8.71507C20.2845 8.64692 20.2631 8.58027 20.2349 8.51624C20.1824 8.39742 20.1668 8.26561 20.19 8.13782C20.2129 8.01142 20.2727 7.89468 20.3619 7.80231L20.4171 7.7471C20.6959 7.46857 20.917 7.13784 21.0679 6.77382C21.2189 6.40963 21.2966 6.01925 21.2966 5.625C21.2966 5.23075 21.2189 4.84037 21.0679 4.47618C20.9171 4.11233 20.6961 3.78174 20.4175 3.50329C20.1389 3.22436 19.808 3.00308 19.4438 2.85211C19.0796 2.70113 18.6892 2.62343 18.295 2.62343C17.9008 2.62343 17.5104 2.70113 17.1462 2.85211C16.782 3.00308 16.4511 3.22436 16.1725 3.50329L16.1177 3.55811C16.0253 3.64728 15.9086 3.70713 15.7822 3.73005C15.6544 3.75322 15.5226 3.73752 15.4038 3.68508L15.3939 3.68086C15.2774 3.63092 15.178 3.54801 15.1081 3.44232C15.0383 3.33704 15.0008 3.21374 15 3.0875V3C15 2.20435 14.6839 1.44129 14.1213 0.87868C13.5587 0.316071 12.7956 0 12 0ZM11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3V3.09L13 3.09399C13.0021 3.6108 13.1552 4.11572 13.4406 4.54661C13.7249 4.97601 14.1282 5.3132 14.6011 5.51701C15.0843 5.72908 15.6198 5.79211 16.139 5.69796C16.66 5.60349 17.1408 5.35516 17.5193 4.98491L17.5875 4.91671C17.6804 4.82374 17.7907 4.74998 17.9121 4.69965C18.0335 4.64933 18.1636 4.62343 18.295 4.62343C18.4264 4.62343 18.5565 4.64933 18.6779 4.69965C18.7993 4.74998 18.9096 4.82374 19.0025 4.91671L19.0033 4.9175C19.0963 5.01037 19.17 5.12066 19.2203 5.24206C19.2707 5.36346 19.2966 5.49359 19.2966 5.625C19.2966 5.75641 19.2707 5.88654 19.2203 6.00794C19.17 6.12934 19.0959 6.24002 19.0029 6.3329L18.9428 6.39285L18.9351 6.40073C18.5649 6.77925 18.3165 7.26 18.222 7.781C18.14 8.23332 18.1773 8.69798 18.3284 9.12961C18.3403 9.22042 18.3646 9.30938 18.4009 9.39393C18.6045 9.86896 18.9425 10.2741 19.3734 10.5594C19.8043 10.8448 20.3092 10.9979 20.826 11L20.83 11H21C21.2652 11 21.5196 11.1054 21.7071 11.2929C21.8946 11.4804 22 11.7348 22 12C22 12.2652 21.8946 12.5196 21.7071 12.7071C21.5196 12.8946 21.2652 13 21 13L20.91 13L20.906 13C20.3892 13.0021 19.8843 13.1552 19.4534 13.4406C19.024 13.725 18.6867 14.1283 18.4829 14.6012C18.2709 15.0843 18.2079 15.6198 18.302 16.139C18.3965 16.66 18.6448 17.1408 19.0151 17.5193L19.0833 17.5875C19.1763 17.6804 19.25 17.7907 19.3003 17.9121C19.3507 18.0335 19.3766 18.1636 19.3766 18.295C19.3766 18.4264 19.3507 18.5565 19.3003 18.6779C19.25 18.7993 19.1763 18.9096 19.0833 19.0025L19.0825 19.0033C18.9896 19.0963 18.8793 19.17 18.7579 19.2203C18.6365 19.2707 18.5064 19.2966 18.375 19.2966C18.2436 19.2966 18.1135 19.2707 17.9921 19.2203C17.8707 19.17 17.76 19.0959 17.6671 19.0029L17.6071 18.9429L17.5993 18.9351C17.2207 18.5649 16.74 18.3165 16.219 18.222C15.6998 18.1279 15.1643 18.1909 14.6812 18.4029C14.2083 18.6067 13.805 18.944 13.5206 19.3734C13.2352 19.8043 13.0821 20.3092 13.08 20.826L13.08 20.83V21C13.08 21.2652 12.9746 21.5196 12.7871 21.7071C12.5996 21.8946 12.3452 22 12.08 22C11.8148 22 11.5604 21.8946 11.3729 21.7071C11.1854 21.5196 11.08 21.2652 11.08 21V20.91L11.0797 20.8866C11.0673 20.355 10.8952 19.8395 10.5859 19.407C10.2827 18.983 9.86132 18.6581 9.37477 18.4725C8.89796 18.2689 8.37163 18.2095 7.861 18.302C7.34 18.3965 6.85921 18.6448 6.48069 19.0151L6.4125 19.0833C6.31963 19.1763 6.20934 19.25 6.08794 19.3003C5.96654 19.3507 5.83641 19.3766 5.705 19.3766C5.57359 19.3766 5.44346 19.3507 5.32206 19.3003C5.20066 19.25 5.09037 19.1763 4.9975 19.0833L4.99671 19.0825C4.90374 18.9896 4.82998 18.8793 4.77965 18.7579C4.72933 18.6365 4.70343 18.5064 4.70343 18.375C4.70343 18.2436 4.72933 18.1135 4.77965 17.9921C4.82998 17.8707 4.90413 17.76 4.9971 17.6671L5.05715 17.6072L5.06486 17.5993C5.43512 17.2207 5.68349 16.74 5.77796 16.219C5.87211 15.6998 5.80908 15.1643 5.59701 14.6811C5.3932 14.2082 5.05601 13.8049 4.62661 13.5206C4.19572 13.2352 3.6908 13.0821 3.17399 13.08H3C2.73478 13.08 2.48043 12.9746 2.29289 12.7871C2.10536 12.5996 2 12.3452 2 12.08C2 11.8148 2.10536 11.5604 2.29289 11.3729C2.48043 11.1854 2.73478 11.08 3 11.08H3.09L3.11338 11.0797C3.64498 11.0673 4.16054 10.8952 4.59305 10.5859C5.01698 10.2827 5.34189 9.86133 5.52745 9.37478C5.73113 8.89797 5.79055 8.37163 5.69796 7.861C5.60349 7.34 5.35516 6.85921 4.98491 6.48069L4.91671 6.4125C4.82374 6.31963 4.74998 6.20934 4.69965 6.08794C4.64933 5.96654 4.62343 5.83642 4.62343 5.705C4.62343 5.57358 4.64933 5.44346 4.69965 5.32206C4.74998 5.20066 4.82374 5.09037 4.91671 4.9975L4.9175 4.99671C5.01037 4.90374 5.12066 4.82998 5.24206 4.77965C5.36346 4.72933 5.49358 4.70343 5.625 4.70343C5.75642 4.70343 5.88654 4.72933 6.00794 4.77965C6.12934 4.82998 6.24002 4.90413 6.33289 4.99711L6.39285 5.05715L6.40073 5.06486C6.77925 5.43512 7.26 5.68349 7.781 5.77796C8.23333 5.85998 8.69798 5.82272 9.12961 5.67157C9.22042 5.65969 9.30938 5.63538 9.39393 5.59914C9.86895 5.39555 10.2741 5.0575 10.5594 4.62661C10.8448 4.19572 10.9979 3.6908 11 3.17399V3C11 2.73478 11.1054 2.48043 11.2929 2.29289Z" })), Hi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M17.3883 0.864973C15.8152 0.851302 14.2995 1.45607 13.1679 2.54902L13.1576 2.55914L11.4376 4.26914C11.0459 4.65852 11.0441 5.29169 11.4335 5.68335C11.8229 6.07501 12.456 6.07685 12.8477 5.68747L14.5623 3.98284C15.3162 3.25721 16.3244 2.8558 17.371 2.8649C18.4197 2.87401 19.423 3.29469 20.1646 4.03632C20.9063 4.77795 21.3269 5.7812 21.336 6.82999C21.3451 7.87604 20.9441 8.88391 20.219 9.63768L17.2255 12.6312C16.82 13.0369 16.3319 13.3507 15.7945 13.5512C15.2571 13.7516 14.6828 13.8342 14.1107 13.7932C13.5386 13.7522 12.982 13.5887 12.4786 13.3137C11.9753 13.0387 11.537 12.6586 11.1934 12.1993C10.8626 11.7571 10.2359 11.6667 9.79366 11.9975C9.35141 12.3283 9.26107 12.955 9.59187 13.3973C10.1072 14.0862 10.7647 14.6563 11.5197 15.0688C12.2748 15.4813 13.1097 15.7266 13.9679 15.7881C14.826 15.8495 15.6874 15.7257 16.4935 15.425C17.2996 15.1243 18.0316 14.6538 18.6399 14.0453L21.6397 11.0454L21.6519 11.033C22.7449 9.9014 23.3496 8.38579 23.336 6.81261C23.3223 5.23943 22.6913 3.73455 21.5788 2.62211C20.4664 1.50966 18.9615 0.878643 17.3883 0.864973Z", fill: "currentColor" }), /* @__PURE__ */ g.createElement("path", { d: "M10.8173 7.80879C9.95915 7.74733 9.09779 7.87115 8.29168 8.17185C7.48563 8.47253 6.75354 8.94316 6.1453 9.55159L3.14543 12.5515L3.13325 12.5639C2.0403 13.6955 1.43553 15.2111 1.4492 16.7843C1.46287 18.3574 2.09389 19.8623 3.20633 20.9748C4.31878 22.0872 5.82366 22.7182 7.39684 22.7319C8.97002 22.7456 10.4856 22.1408 11.6172 21.0479L11.6296 21.0357L13.3396 19.3257C13.7302 18.9351 13.7302 18.302 13.3396 17.9115C12.9491 17.5209 12.316 17.5209 11.9254 17.9115L10.2219 19.615C9.46813 20.34 8.46026 20.7411 7.41422 20.732C6.36543 20.7229 5.36218 20.3022 4.62055 19.5606C3.87892 18.8189 3.45824 17.8157 3.44913 16.7669C3.44004 15.7208 3.84109 14.713 4.56613 13.9592L7.55977 10.9655C7.96528 10.5599 8.45329 10.2462 8.99069 10.0457C9.5281 9.84525 10.1023 9.7627 10.6744 9.80368C11.2466 9.84465 11.8032 10.0082 12.3065 10.2832C12.8099 10.5582 13.2482 10.9382 13.5918 11.3975C13.9226 11.8398 14.5493 11.9301 14.9915 11.5993C15.4338 11.2685 15.5241 10.6418 15.1933 10.1996C14.678 9.51063 14.0205 8.94057 13.2654 8.52806C12.5104 8.11555 11.6755 7.87025 10.8173 7.80879Z", fill: "currentColor" })), Ui = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M9 10C9 9.44771 8.55228 9 8 9C7.44772 9 7 9.44771 7 10C7 11.3261 7.52678 12.5979 8.46447 13.5355C9.40215 14.4732 10.6739 15 12 15C13.3261 15 14.5979 14.4732 15.5355 13.5355C16.4732 12.5979 17 11.3261 17 10C17 9.44771 16.5523 9 16 9C15.4477 9 15 9.44771 15 10C15 10.7956 14.6839 11.5587 14.1213 12.1213C13.5587 12.6839 12.7956 13 12 13C11.2044 13 10.4413 12.6839 9.87868 12.1213C9.31607 11.5587 9 10.7956 9 10Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.2 1.4C5.38885 1.14819 5.68524 1 6 1H18C18.3148 1 18.6111 1.14819 18.8 1.4L21.7939 5.39188C21.9232 5.56038 22 5.77122 22 6V20C22 20.7957 21.6839 21.5587 21.1213 22.1213C20.5587 22.6839 19.7957 23 19 23H5C4.20435 23 3.44129 22.6839 2.87868 22.1213C2.31607 21.5587 2 20.7957 2 20V6C2 5.77123 2.07682 5.56041 2.20606 5.39192L5.2 1.4ZM17.5 3L19 5H5L6.5 3H17.5ZM4 20V7H20V20C20 20.2652 19.8946 20.5196 19.7071 20.7071C19.5196 20.8946 19.2652 21 19 21H5C4.73478 21 4.48043 20.8946 4.29289 20.7071C4.10536 20.5196 4 20.2652 4 20Z" })), qi = (t) => /* @__PURE__ */ g.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: 24, height: 24, ...t }, /* @__PURE__ */ g.createElement("style", null, `
@keyframes a0_t { 0% { transform: translate(12px,12px) rotate(0deg) translate(-6px,-6px); } 25% { transform: translate(12px,12px) rotate(180deg) translate(-6px,-6px); } 50% { transform: translate(12px,12px) rotate(360deg) translate(-6px,-6px); } 100% { transform: translate(12px,12px) rotate(720deg) translate(-6px,-6px); } }
@keyframes a1_t { 0% { transform: translate(6px,2px); } 50% { transform: translate(6px,0px); } 100% { transform: translate(6px,2px); } }
@keyframes a2_t { 0% { transform: translate(2px,6px); } 50% { transform: translate(0px,6px); } 100% { transform: translate(2px,6px); } }
@keyframes a3_t { 0% { transform: translate(6px,10px); } 50% { transform: translate(6px,12px); } 100% { transform: translate(6px,10px); } }
@keyframes a4_t { 0% { transform: translate(10px,6px); } 50% { transform: translate(12px,6px); } 100% { transform: translate(10px,6px); } }
`), /* @__PURE__ */ g.createElement("g", { transform: "translate(12,12) translate(-6,-6)", style: {
  animation: "3s linear infinite both a0_t"
} }, /* @__PURE__ */ g.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(6,2)", style: {
  animation: "3s linear infinite both a1_t"
} }), /* @__PURE__ */ g.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(2,6)", style: {
  animation: "3s linear infinite both a2_t"
} }), /* @__PURE__ */ g.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(6,10)", style: {
  animation: "3s linear infinite both a3_t"
} }), /* @__PURE__ */ g.createElement("ellipse", { rx: 2, ry: 2, transform: "translate(10,6)", style: {
  animation: "3s linear infinite both a4_t"
} }))), zi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1.5L14.9389 8.42229L22.5 9.19577L16.875 14.2777L18.4389 21.75L12 17.9223L5.56107 21.75L7.125 14.2777L1.5 9.19577L9.06107 8.42229L12 1.5ZM12 5.33688L10.0383 9.86771L5.10329 10.3978L8.79075 13.6973L7.73746 18.5515L12 16.0777L16.2625 18.5515L15.2093 13.6973L18.8967 10.3978L13.9617 9.86771L12 5.33688Z" })), Ki = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6H11V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H5Z" })), Wi = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7V9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H9V13C9 13.5523 9.44772 14 10 14C10.5523 14 11 13.5523 11 13V11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H11V7Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C11.2958 16 12.4957 15.5892 13.4765 14.8907L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L14.8907 13.4765C15.5892 12.4957 16 11.2958 16 10C16 6.68629 13.3137 4 10 4ZM6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10Z" })), Ji = (t) => /* @__PURE__ */ g.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ g.createElement("path", { d: "M7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H7Z" }), /* @__PURE__ */ g.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C11.2958 16 12.4957 15.5892 13.4765 14.8907L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L14.8907 13.4765C15.5892 12.4957 16 11.2958 16 10C16 6.68629 13.3137 4 10 4ZM6 10C6 7.79086 7.79086 6 10 6C12.2091 6 14 7.79086 14 10C14 12.2091 12.2091 14 10 14C7.79086 14 6 12.2091 6 10Z" })), ss = {
  ar: ti,
  arrow: ri,
  arrowLeft: ni,
  arrowLeftCircle: si,
  arrowRight: ii,
  arrowRightCircle: ai,
  asset: oi,
  camera: li,
  check: ci,
  chevronDown: ui,
  chevronLeft: di,
  chevronRight: fi,
  chevronUp: hi,
  child: pi,
  close: gi,
  closeCircle: mi,
  closeFab: yi,
  collapse: vi,
  color1: Ci,
  color2: bi,
  color3: _i,
  color5: wi,
  expand: xi,
  expandViewport: Si,
  help: Ei,
  info: Li,
  infoActive: ki,
  link: Oi,
  lock: Ai,
  minus: Ti,
  minusCircle: Ri,
  more: Ni,
  palette: Pi,
  parent: Vi,
  pdf: Mi,
  placeholder: ji,
  plus: Fi,
  plusCircle: Ii,
  refreshCw: Zi,
  rotate: $i,
  search: Di,
  settings: Bi,
  share: Hi,
  shoppingBag: Ui,
  spinner: qi,
  star: zi,
  type24: Ki,
  zoomIn: Wi,
  zoomOut: Ji
}, Xi = ({ type: t, className: e, style: r, colored: n, ...s }) => {
  const i = t ? ss[t] : null;
  return i && /* @__PURE__ */ re("i", { className: de(kr.icon, e), style: r, ...s, children: /* @__PURE__ */ re(i, { className: de(kr.svg, { [kr.colored]: n }) }) });
}, Gi = (t) => Object.prototype.hasOwnProperty.call(ss, t), Yi = "_button_1li5z_1", Qi = "_primary_1li5z_25", ea = "_secondary_1li5z_42", ta = "_ternary_1li5z_60", ra = "_ghost_1li5z_78", na = "_iconOnly_1li5z_95", sa = "_icon_1li5z_95", ia = "_text_1li5z_109", be = {
  button: Yi,
  primary: Qi,
  secondary: ea,
  ternary: ta,
  ghost: ra,
  iconOnly: na,
  icon: sa,
  text: ia
}, gn = (t) => typeof t == "string" && Gi(t) ? /* @__PURE__ */ re(Xi, { type: t }) : t, Or = Ut(
  ({ className: t, variant: e = "primary", disabled: r, selected: n, children: s, onClick: i, iconEnd: a, iconStart: o, ...l }, c) => {
    const u = !s && (o || a);
    return /* @__PURE__ */ xe(
      "button",
      {
        ref: c,
        ...l,
        className: de(
          be.button,
          {
            [be.primary]: e === "primary",
            [be.secondary]: e === "secondary",
            [be.ternary]: e === "ternary",
            [be.ghost]: e === "ghost",
            [be.iconOnly]: u,
            [be.selected]: n
          },
          t
        ),
        onClick: i,
        disabled: r,
        children: [
          o && /* @__PURE__ */ re("span", { className: de(be.icon, be.iconStart), children: gn(o) }),
          s ? /* @__PURE__ */ re("p", { className: de(be.text), children: s }) : void 0,
          a && /* @__PURE__ */ re("span", { className: de(be.icon, be.iconEnd), children: gn(a) })
        ]
      }
    );
  }
);
var Ar, mn;
function aa() {
  return mn || (mn = 1, Ar = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
  }), Ar;
}
var oa = aa();
const la = /* @__PURE__ */ Gr(oa);
var ca = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function yn(t) {
  var e = { type: "tag", name: "", voidElement: !1, attrs: {}, children: [] }, r = t.match(/<\/?([^\s]+?)[/\s>]/);
  if (r && (e.name = r[1], (la[r[1]] || t.charAt(t.length - 2) === "/") && (e.voidElement = !0), e.name.startsWith("!--"))) {
    var n = t.indexOf("-->");
    return { type: "comment", comment: n !== -1 ? t.slice(4, n) : "" };
  }
  for (var s = new RegExp(ca), i = null; (i = s.exec(t)) !== null; ) if (i[0].trim()) if (i[1]) {
    var a = i[1].trim(), o = [a, ""];
    a.indexOf("=") > -1 && (o = a.split("=")), e.attrs[o[0]] = o[1], s.lastIndex--;
  } else i[2] && (e.attrs[i[2]] = i[3].trim().substring(1, i[3].length - 1));
  return e;
}
var ua = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, da = /^\s*$/, fa = /* @__PURE__ */ Object.create(null);
function is(t, e) {
  switch (e.type) {
    case "text":
      return t + e.content;
    case "tag":
      return t += "<" + e.name + (e.attrs ? (function(r) {
        var n = [];
        for (var s in r) n.push(s + '="' + r[s] + '"');
        return n.length ? " " + n.join(" ") : "";
      })(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce(is, "") + "</" + e.name + ">";
    case "comment":
      return t + "<!--" + e.comment + "-->";
  }
}
var ha = { parse: function(t, e) {
  e || (e = {}), e.components || (e.components = fa);
  var r, n = [], s = [], i = -1, a = !1;
  if (t.indexOf("<") !== 0) {
    var o = t.indexOf("<");
    n.push({ type: "text", content: o === -1 ? t : t.substring(0, o) });
  }
  for (var l, c = []; l = ua.exec(t); ) c.push(l);
  return c.forEach(function(u, h) {
    var f = u[0];
    if (f && !f.startsWith("<!--")) {
      for (var C = 0, w = 0, _ = -1, E = null, j = 0; j < f.length; j++) {
        var x = f.charAt(j);
        E ? x === E && (E = null) : x === '"' || x === "'" ? E = x : x === "<" ? ++C == 2 && (_ = j) : x === ">" && w++;
      }
      var Z = _ > -1 && /[a-zA-Z0-9\-!/]/.test(f.charAt(_ + 1));
      if (C > w && Z) {
        var V = f.substring(0, _), $ = f.substring(V.length);
        c[h][0] = $, c[h].index += V.length;
      }
    }
  }), c.forEach(function(u, h) {
    var f = u[0];
    if (f) {
      var C = u.index;
      if (a) {
        if (f !== "</" + r.name + ">") return;
        a = !1;
      }
      var w, _, E = f.charAt(1) !== "/", j = f.startsWith("<!--"), x = C + f.length, Z = t.charAt(x), V = c[h + 1];
      if (Z === "<" && V) {
        var $ = t.substring(x, V.index);
        w = $.split("<").length > $.split(">").length;
      }
      if (j) {
        var D = yn(f);
        if (i < 0) return n.push(D), n;
        (_ = s[i]).children.push(D);
        var A = t.slice(x, V ? V.index : void 0);
        return A.length > 0 && _.children.push({ type: "text", content: A }), n;
      }
      if (E && (i++, (r = yn(f)).type === "tag" && e.components[r.name] && (r.type = "component", a = !0), r.voidElement || a || !Z || Z === "<" || r.children.push({ type: "text", content: t.slice(x, V ? V.index : void 0) }), i === 0 && n.push(r), (_ = s[i - 1]) && _.children.push(r), s[i] = r), (!E || r.voidElement) && (i > -1 && (r.voidElement || r.name === f.slice(2, -1)) && (i--, r = i === -1 ? n : s[i]), !a && (Z !== "<" || w) && Z)) {
        _ = i === -1 ? n : s[i].children;
        var q = V ? V.index : -1, K = t.slice(x, q === -1 ? void 0 : q);
        da.test(K) && (K = " "), (q > -1 && i + _.length >= 0 || K !== " ") && _.push({ type: "text", content: K });
      }
    }
  }), n;
}, stringify: function(t) {
  return t.reduce(function(e, r) {
    return e + is("", r);
  }, "");
} };
const Yt = (t, e, r, n) => {
  var i, a, o, l;
  const s = [r, {
    code: e,
    ...n || {}
  }];
  if ((a = (i = t == null ? void 0 : t.services) == null ? void 0 : i.logger) != null && a.forward)
    return t.services.logger.forward(s, "warn", "react-i18next::", !0);
  Se(s[0]) && (s[0] = `react-i18next:: ${s[0]}`), (l = (o = t == null ? void 0 : t.services) == null ? void 0 : o.logger) != null && l.warn ? t.services.logger.warn(...s) : console != null && console.warn && console.warn(...s);
}, vn = {}, Ot = (t, e, r, n) => {
  Se(r) && vn[r] || (Se(r) && (vn[r] = /* @__PURE__ */ new Date()), Yt(t, e, r, n));
}, as = (t, e) => () => {
  if (t.isInitialized)
    e();
  else {
    const r = () => {
      setTimeout(() => {
        t.off("initialized", r);
      }, 0), e();
    };
    t.on("initialized", r);
  }
}, $r = (t, e, r) => {
  t.loadNamespaces(e, as(t, r));
}, Cn = (t, e, r, n) => {
  if (Se(r) && (r = [r]), t.options.preload && t.options.preload.indexOf(e) > -1) return $r(t, r, n);
  r.forEach((s) => {
    t.options.ns.indexOf(s) < 0 && t.options.ns.push(s);
  }), t.loadLanguages(e, as(t, n));
}, pa = (t, e, r = {}) => !e.languages || !e.languages.length ? (Ot(e, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: e.languages
}), !0) : e.hasLoadedNamespace(t, {
  lng: r.lng,
  precheck: (n, s) => {
    if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !s(n.isLanguageChangingTo, t)) return !1;
  }
}), Se = (t) => typeof t == "string", Ue = (t) => typeof t == "object" && t !== null, ga = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, ma = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, ya = (t) => ma[t], va = (t) => t.replace(ga, ya);
let Dr = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: va
};
const Ca = (t = {}) => {
  Dr = {
    ...Dr,
    ...t
  };
}, os = () => Dr;
let ls;
const ba = (t) => {
  ls = t;
}, Yr = () => ls, Tr = (t, e) => {
  var n;
  if (!t) return !1;
  const r = ((n = t.props) == null ? void 0 : n.children) ?? t.children;
  return e ? r.length > 0 : !!r;
}, Rr = (t) => {
  var r, n;
  if (!t) return [];
  const e = ((r = t.props) == null ? void 0 : r.children) ?? t.children;
  return (n = t.props) != null && n.i18nIsDynamicList ? ut(e) : e;
}, _a = (t) => Array.isArray(t) && t.every(tr), ut = (t) => Array.isArray(t) ? t : [t], wa = (t, e) => {
  const r = {
    ...e
  };
  return r.props = Object.assign(t.props, e.props), r;
}, cs = (t, e, r, n) => {
  if (!t) return "";
  let s = "";
  const i = ut(t), a = e != null && e.transSupportBasicHtmlNodes ? e.transKeepBasicHtmlNodesFor ?? [] : [];
  return i.forEach((o, l) => {
    if (Se(o)) {
      s += `${o}`;
      return;
    }
    if (tr(o)) {
      const {
        props: c,
        type: u
      } = o, h = Object.keys(c).length, f = a.indexOf(u) > -1, C = c.children;
      if (!C && f && !h) {
        s += `<${u}/>`;
        return;
      }
      if (!C && (!f || h) || c.i18nIsDynamicList) {
        s += `<${l}></${l}>`;
        return;
      }
      if (f && h === 1 && Se(C)) {
        s += `<${u}>${C}</${u}>`;
        return;
      }
      const w = cs(C, e, r, n);
      s += `<${l}>${w}</${l}>`;
      return;
    }
    if (o === null) {
      Yt(r, "TRANS_NULL_VALUE", "Passed in a null value as child", {
        i18nKey: n
      });
      return;
    }
    if (Ue(o)) {
      const {
        format: c,
        ...u
      } = o, h = Object.keys(u);
      if (h.length === 1) {
        const f = c ? `${h[0]}, ${c}` : h[0];
        s += `{{${f}}}`;
        return;
      }
      Yt(r, "TRANS_INVALID_OBJ", "Invalid child - Object should only have keys {{ value, format }} (format is optional).", {
        i18nKey: n,
        child: o
      });
      return;
    }
    Yt(r, "TRANS_INVALID_VAR", "Passed in a variable like {number} - pass variables for interpolation as full objects like {{number}}.", {
      i18nKey: n,
      child: o
    });
  }), s;
}, xa = (t, e, r, n, s, i, a) => {
  if (r === "") return [];
  const o = s.transKeepBasicHtmlNodesFor || [], l = r && new RegExp(o.map((j) => `<${j}`).join("|")).test(r);
  if (!t && !e && !l && !a) return [r];
  const c = e ?? {}, u = (j) => {
    ut(j).forEach((Z) => {
      Se(Z) || (Tr(Z) ? u(Rr(Z)) : Ue(Z) && !tr(Z) && Object.assign(c, Z));
    });
  };
  u(t);
  const h = ha.parse(`<0>${r}</0>`), f = {
    ...c,
    ...i
  }, C = (j, x, Z) => {
    var D;
    const V = Rr(j), $ = _(V, x.children, Z);
    return _a(V) && $.length === 0 || (D = j.props) != null && D.i18nIsDynamicList ? V : $;
  }, w = (j, x, Z, V, $) => {
    j.dummy ? (j.children = x, Z.push(es(j, {
      key: V
    }, $ ? void 0 : x))) : Z.push(...zs.map([j], (D) => {
      const A = {
        ...D.props
      };
      return delete A.i18nIsDynamicList, $e(D.type, {
        ...A,
        key: V,
        ref: D.props.ref ?? D.ref
      }, $ ? null : x);
    }));
  }, _ = (j, x, Z) => {
    const V = ut(j);
    return ut(x).reduce((D, A, q) => {
      var te, W;
      const K = ((W = (te = A.children) == null ? void 0 : te[0]) == null ? void 0 : W.content) && n.services.interpolator.interpolate(A.children[0].content, f, n.language);
      if (A.type === "tag") {
        let O = V[parseInt(A.name, 10)];
        !O && e && (O = e[A.name]), Z.length === 1 && !O && (O = Z[0][A.name]), O || (O = {});
        const T = Object.keys(A.attrs).length !== 0 ? wa({
          props: A.attrs
        }, O) : O, G = tr(T), p = G && Tr(A, !0) && !A.voidElement, v = l && Ue(T) && T.dummy && !G, I = Ue(e) && Object.hasOwnProperty.call(e, A.name);
        if (Se(T)) {
          const M = n.services.interpolator.interpolate(T, f, n.language);
          D.push(M);
        } else if (Tr(T) || p) {
          const M = C(T, A, Z);
          w(T, M, D, q);
        } else if (v) {
          const M = _(V, A.children, Z);
          w(T, M, D, q);
        } else if (Number.isNaN(parseFloat(A.name)))
          if (I) {
            const M = C(T, A, Z);
            w(T, M, D, q, A.voidElement);
          } else if (s.transSupportBasicHtmlNodes && o.indexOf(A.name) > -1)
            if (A.voidElement)
              D.push($e(A.name, {
                key: `${A.name}-${q}`
              }));
            else {
              const M = _(V, A.children, Z);
              D.push($e(A.name, {
                key: `${A.name}-${q}`
              }, M));
            }
          else if (A.voidElement)
            D.push(`<${A.name} />`);
          else {
            const M = _(V, A.children, Z);
            D.push(`<${A.name}>${M}</${A.name}>`);
          }
        else if (Ue(T) && !G) {
          const M = A.children[0] ? K : null;
          M && D.push(M);
        } else
          w(T, K, D, q, A.children.length !== 1 || !K);
      } else if (A.type === "text") {
        const O = s.transWrapTextNodes, T = a ? s.unescape(n.services.interpolator.interpolate(A.content, f, n.language)) : n.services.interpolator.interpolate(A.content, f, n.language);
        O ? D.push($e(O, {
          key: `${A.name}-${q}`
        }, T)) : D.push(T);
      }
      return D;
    }, []);
  }, E = _([{
    dummy: !0,
    children: t || []
  }], h, ut(t || []));
  return Rr(E[0]);
}, us = (t, e, r) => {
  const n = t.key || e, s = es(t, {
    key: n
  });
  if (!s.props || !s.props.children || r.indexOf(`${e}/>`) < 0 && r.indexOf(`${e} />`) < 0)
    return s;
  function i() {
    return $e(Ks, null, s);
  }
  return $e(i, {
    key: n
  });
}, Sa = (t, e) => t.map((r, n) => us(r, n, e)), Ea = (t, e) => {
  const r = {};
  return Object.keys(t).forEach((n) => {
    Object.assign(r, {
      [n]: us(t[n], n, e)
    });
  }), r;
}, La = (t, e, r, n) => t ? Array.isArray(t) ? Sa(t, e) : Ue(t) ? Ea(t, e) : (Ot(r, "TRANS_INVALID_COMPONENTS", '<Trans /> "components" prop expects an object or array', {
  i18nKey: n
}), null) : null, ka = (t) => !Ue(t) || Array.isArray(t) ? !1 : Object.keys(t).reduce((e, r) => e && Number.isNaN(Number.parseFloat(r)), !0);
function Oa({
  children: t,
  count: e,
  parent: r,
  i18nKey: n,
  context: s,
  tOptions: i = {},
  values: a,
  defaults: o,
  components: l,
  ns: c,
  i18n: u,
  t: h,
  shouldUnescape: f,
  ...C
}) {
  var G, p, v, I, M, Q;
  const w = u || Yr();
  if (!w)
    return Ot(w, "NO_I18NEXT_INSTANCE", "Trans: You need to pass in an i18next instance using i18nextReactModule", {
      i18nKey: n
    }), t;
  const _ = h || w.t.bind(w) || ((J) => J), E = {
    ...os(),
    ...(G = w.options) == null ? void 0 : G.react
  };
  let j = c || _.ns || ((p = w.options) == null ? void 0 : p.defaultNS);
  j = Se(j) ? [j] : j || ["translation"];
  const x = cs(t, E, w, n), Z = o || x || E.transEmptyNodeValue || n, {
    hashTransKey: V
  } = E, $ = n || (V ? V(x || Z) : x || Z);
  (I = (v = w.options) == null ? void 0 : v.interpolation) != null && I.defaultVariables && (a = a && Object.keys(a).length > 0 ? {
    ...a,
    ...w.options.interpolation.defaultVariables
  } : {
    ...w.options.interpolation.defaultVariables
  });
  const D = a || e !== void 0 && !((Q = (M = w.options) == null ? void 0 : M.interpolation) != null && Q.alwaysFormat) || !t ? i.interpolation : {
    interpolation: {
      ...i.interpolation,
      prefix: "#$?",
      suffix: "?$#"
    }
  }, A = {
    ...i,
    context: s || i.context,
    count: e,
    ...a,
    ...D,
    defaultValue: Z,
    ns: j
  }, q = $ ? _($, A) : Z, K = La(l, q, w, n);
  let te = K || t, W = null;
  ka(K) && (W = K, te = t);
  const O = xa(te, W, q, w, E, A, f), T = r ?? E.defaultTransParent;
  return T ? $e(T, C, O) : O;
}
const Aa = {
  type: "3rdParty",
  init(t) {
    Ca(t.options.react), ba(t);
  }
}, Qr = Ws();
class Ta {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(e) {
    e.forEach((r) => {
      this.usedNamespaces[r] || (this.usedNamespaces[r] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
function bn({
  children: t,
  count: e,
  parent: r,
  i18nKey: n,
  context: s,
  tOptions: i = {},
  values: a,
  defaults: o,
  components: l,
  ns: c,
  i18n: u,
  t: h,
  shouldUnescape: f,
  ...C
}) {
  var x;
  const {
    i18n: w,
    defaultNS: _
  } = ts(Qr) || {}, E = u || w || Yr(), j = h || (E == null ? void 0 : E.t.bind(E));
  return Oa({
    children: t,
    count: e,
    parent: r,
    i18nKey: n,
    context: s,
    tOptions: i,
    values: a,
    defaults: o,
    components: l,
    ns: c || (j == null ? void 0 : j.ns) || _ || ((x = E == null ? void 0 : E.options) == null ? void 0 : x.defaultNS),
    i18n: E,
    t: h,
    shouldUnescape: f,
    ...C
  });
}
const Ra = (t, e) => {
  const r = Xr();
  return ht(() => {
    r.current = t;
  }, [t, e]), r.current;
}, ds = (t, e, r, n) => t.getFixedT(e, r, n), Na = (t, e, r, n) => Zr(ds(t, e, r, n), [t, e, r, n]), yr = (t, e = {}) => {
  var V, $, D, A;
  const {
    i18n: r
  } = e, {
    i18n: n,
    defaultNS: s
  } = ts(Qr) || {}, i = r || n || Yr();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new Ta()), !i) {
    Ot(i, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const q = (te, W) => Se(W) ? W : Ue(W) && Se(W.defaultValue) ? W.defaultValue : Array.isArray(te) ? te[te.length - 1] : te, K = [q, {}, !1];
    return K.t = q, K.i18n = {}, K.ready = !1, K;
  }
  (V = i.options.react) != null && V.wait && Ot(i, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...os(),
    ...i.options.react,
    ...e
  }, {
    useSuspense: o,
    keyPrefix: l
  } = a;
  let c = t || s || (($ = i.options) == null ? void 0 : $.defaultNS);
  c = Se(c) ? [c] : c || ["translation"], (A = (D = i.reportNamespaces).addUsedNamespaces) == null || A.call(D, c);
  const u = (i.isInitialized || i.initializedStoreOnce) && c.every((q) => pa(q, i, a)), h = Na(i, e.lng || null, a.nsMode === "fallback" ? c : c[0], l), f = () => h, C = () => ds(i, e.lng || null, a.nsMode === "fallback" ? c : c[0], l), [w, _] = rs(f);
  let E = c.join();
  e.lng && (E = `${e.lng}${E}`);
  const j = Ra(E), x = Xr(!0);
  ht(() => {
    const {
      bindI18n: q,
      bindI18nStore: K
    } = a;
    x.current = !0, !u && !o && (e.lng ? Cn(i, e.lng, c, () => {
      x.current && _(C);
    }) : $r(i, c, () => {
      x.current && _(C);
    })), u && j && j !== E && x.current && _(C);
    const te = () => {
      x.current && _(C);
    };
    return q && (i == null || i.on(q, te)), K && (i == null || i.store.on(K, te)), () => {
      x.current = !1, i && q && (q == null || q.split(" ").forEach((W) => i.off(W, te))), K && i && K.split(" ").forEach((W) => i.store.off(W, te));
    };
  }, [i, E]), ht(() => {
    x.current && u && _(f);
  }, [i, l, u]);
  const Z = [w, i, u];
  if (Z.t = w, Z.i18n = i, Z.ready = u, u || !u && !o) return Z;
  throw new Promise((q) => {
    e.lng ? Cn(i, e.lng, c, () => q()) : $r(i, c, () => q());
  });
};
function Pa({
  i18n: t,
  defaultNS: e,
  children: r
}) {
  const n = Gt(() => ({
    i18n: t,
    defaultNS: e
  }), [t, e]);
  return $e(Qr.Provider, {
    value: n
  }, r);
}
const Va = "_root_1vqhg_9", Ma = "_variantLabel_1vqhg_13", ja = "_variantH1_1vqhg_16", Fa = "_heading1_1vqhg_19", Ia = "_heading2_1vqhg_25", Za = "_heading3_1vqhg_31", $a = "_heading4_1vqhg_37", Da = "_heading5_1vqhg_43", Ba = "_heading6_1vqhg_49", Ha = "_hint_1vqhg_115", Ua = "_button_1vqhg_121", Ct = {
  root: Va,
  variantLabel: Ma,
  variantH1: ja,
  heading1: Fa,
  heading2: Ia,
  heading3: Za,
  heading4: $a,
  heading5: Da,
  heading6: Ba,
  "title-lg": "_title-lg_1vqhg_55",
  "title-md": "_title-md_1vqhg_61",
  "sub-lg": "_sub-lg_1vqhg_67",
  "sub-md": "_sub-md_1vqhg_73",
  "body-lg": "_body-lg_1vqhg_79",
  "body-md": "_body-md_1vqhg_85",
  "paragraph-lg": "_paragraph-lg_1vqhg_91",
  "paragraph-md": "_paragraph-md_1vqhg_97",
  "paragraph-sm": "_paragraph-sm_1vqhg_103",
  "status-label": "_status-label_1vqhg_109",
  hint: Ha,
  button: Ua,
  "color-light": "_color-light_1vqhg_127",
  "color-base": "_color-base_1vqhg_131",
  "color-description": "_color-description_1vqhg_135",
  "color-disabled": "_color-disabled_1vqhg_139",
  "color-inherit": "_color-inherit_1vqhg_143"
}, qa = {
  heading1: "heading1",
  heading2: "heading2",
  heading3: "heading3",
  heading4: "heading4",
  heading5: "heading5",
  heading6: "heading6",
  "title-lg": "title-lg",
  "title-md": "title-md",
  "sub-lg": "sub-lg",
  "sub-md": "sub-md",
  "body-lg": "body-lg",
  "body-md": "body-md",
  "paragraph-lg": "paragraph-lg",
  "paragraph-md": "paragraph-md",
  "paragraph-sm": "paragraph-sm",
  "status-label": "status-label",
  hint: "hint",
  button: "button"
}, za = {
  light: "color-light",
  base: "color-base",
  description: "color-description",
  disabled: "color-disabled",
  inherit: "color-inherit"
}, pt = ({
  component: t = "p",
  variant: e,
  color: r = "base",
  className: n,
  children: s
}) => /* @__PURE__ */ re(
  t,
  {
    className: de(
      Ct.root,
      // ThemeDefinition.typography.root,
      {
        [Ct.variantLabel]: e === "label",
        // [ThemeDefinition.typography.label]: variant === 'label',
        [Ct.variantH1]: e === "h1",
        // [ThemeDefinition.typography.h1]: variant === 'h1',
        ...Object.fromEntries(
          Object.entries(qa).map(([i, a]) => [Ct[a], e === i])
        ),
        ...Object.fromEntries(Object.entries(za).map(([i, a]) => [Ct[a], r === i]))
      },
      n
    ),
    children: s
  }
), z = (t) => typeof t == "string", bt = () => {
  let t, e;
  const r = new Promise((n, s) => {
    t = n, e = s;
  });
  return r.resolve = t, r.reject = e, r;
}, _n = (t) => t == null ? "" : "" + t, Ka = (t, e, r) => {
  t.forEach((n) => {
    e[n] && (r[n] = e[n]);
  });
}, Wa = /###/g, wn = (t) => t && t.indexOf("###") > -1 ? t.replace(Wa, ".") : t, xn = (t) => !t || z(t), Lt = (t, e, r) => {
  const n = z(e) ? e.split(".") : e;
  let s = 0;
  for (; s < n.length - 1; ) {
    if (xn(t)) return {};
    const i = wn(n[s]);
    !t[i] && r && (t[i] = new r()), Object.prototype.hasOwnProperty.call(t, i) ? t = t[i] : t = {}, ++s;
  }
  return xn(t) ? {} : {
    obj: t,
    k: wn(n[s])
  };
}, Sn = (t, e, r) => {
  const {
    obj: n,
    k: s
  } = Lt(t, e, Object);
  if (n !== void 0 || e.length === 1) {
    n[s] = r;
    return;
  }
  let i = e[e.length - 1], a = e.slice(0, e.length - 1), o = Lt(t, a, Object);
  for (; o.obj === void 0 && a.length; )
    i = `${a[a.length - 1]}.${i}`, a = a.slice(0, a.length - 1), o = Lt(t, a, Object), o && o.obj && typeof o.obj[`${o.k}.${i}`] < "u" && (o.obj = void 0);
  o.obj[`${o.k}.${i}`] = r;
}, Ja = (t, e, r, n) => {
  const {
    obj: s,
    k: i
  } = Lt(t, e, Object);
  s[i] = s[i] || [], s[i].push(r);
}, rr = (t, e) => {
  const {
    obj: r,
    k: n
  } = Lt(t, e);
  if (r)
    return r[n];
}, Xa = (t, e, r) => {
  const n = rr(t, r);
  return n !== void 0 ? n : rr(e, r);
}, fs = (t, e, r) => {
  for (const n in e)
    n !== "__proto__" && n !== "constructor" && (n in t ? z(t[n]) || t[n] instanceof String || z(e[n]) || e[n] instanceof String ? r && (t[n] = e[n]) : fs(t[n], e[n], r) : t[n] = e[n]);
  return t;
}, at = (t) => t.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var Ga = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const Ya = (t) => z(t) ? t.replace(/[&<>"'\/]/g, (e) => Ga[e]) : t;
class Qa {
  constructor(e) {
    this.capacity = e, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(e) {
    const r = this.regExpMap.get(e);
    if (r !== void 0)
      return r;
    const n = new RegExp(e);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(e, n), this.regExpQueue.push(e), n;
  }
}
const eo = [" ", ",", "?", "!", ";"], to = new Qa(20), ro = (t, e, r) => {
  e = e || "", r = r || "";
  const n = eo.filter((a) => e.indexOf(a) < 0 && r.indexOf(a) < 0);
  if (n.length === 0) return !0;
  const s = to.getRegExp(`(${n.map((a) => a === "?" ? "\\?" : a).join("|")})`);
  let i = !s.test(t);
  if (!i) {
    const a = t.indexOf(r);
    a > 0 && !s.test(t.substring(0, a)) && (i = !0);
  }
  return i;
}, Br = function(t, e) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!t) return;
  if (t[e]) return t[e];
  const n = e.split(r);
  let s = t;
  for (let i = 0; i < n.length; ) {
    if (!s || typeof s != "object")
      return;
    let a, o = "";
    for (let l = i; l < n.length; ++l)
      if (l !== i && (o += r), o += n[l], a = s[o], a !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof a) > -1 && l < n.length - 1)
          continue;
        i += l - i + 1;
        break;
      }
    s = a;
  }
  return s;
}, nr = (t) => t && t.replace("_", "-"), no = {
  type: "logger",
  log(t) {
    this.output("log", t);
  },
  warn(t) {
    this.output("warn", t);
  },
  error(t) {
    this.output("error", t);
  },
  output(t, e) {
    console && console[t] && console[t].apply(console, e);
  }
};
class sr {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(e, r);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = r.prefix || "i18next:", this.logger = e || no, this.options = r, this.debug = r.debug;
  }
  log() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "log", "", !0);
  }
  warn() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "", !0);
  }
  error() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "error", "");
  }
  deprecate() {
    for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
      r[n] = arguments[n];
    return this.forward(r, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(e, r, n, s) {
    return s && !this.debug ? null : (z(e[0]) && (e[0] = `${n}${this.prefix} ${e[0]}`), this.logger[r](e));
  }
  create(e) {
    return new sr(this.logger, {
      prefix: `${this.prefix}:${e}:`,
      ...this.options
    });
  }
  clone(e) {
    return e = e || this.options, e.prefix = e.prefix || this.prefix, new sr(this.logger, e);
  }
}
var Ne = new sr();
class vr {
  constructor() {
    this.observers = {};
  }
  on(e, r) {
    return e.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const s = this.observers[n].get(r) || 0;
      this.observers[n].set(r, s + 1);
    }), this;
  }
  off(e, r) {
    if (this.observers[e]) {
      if (!r) {
        delete this.observers[e];
        return;
      }
      this.observers[e].delete(r);
    }
  }
  emit(e) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)
      n[s - 1] = arguments[s];
    this.observers[e] && Array.from(this.observers[e].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o(...n);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach((a) => {
      let [o, l] = a;
      for (let c = 0; c < l; c++)
        o.apply(o, [e, ...n]);
    });
  }
}
class En extends vr {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = e || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(e) {
    this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
  }
  removeNamespaces(e) {
    const r = this.options.ns.indexOf(e);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, a = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let o;
    e.indexOf(".") > -1 ? o = e.split(".") : (o = [e, r], n && (Array.isArray(n) ? o.push(...n) : z(n) && i ? o.push(...n.split(i)) : o.push(n)));
    const l = rr(this.data, o);
    return !l && !r && !n && e.indexOf(".") > -1 && (e = o[0], r = o[1], n = o.slice(2).join(".")), l || !a || !z(n) ? l : Br(this.data && this.data[e] && this.data[e][r], n, i);
  }
  addResource(e, r, n, s) {
    let i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const a = i.keySeparator !== void 0 ? i.keySeparator : this.options.keySeparator;
    let o = [e, r];
    n && (o = o.concat(a ? n.split(a) : n)), e.indexOf(".") > -1 && (o = e.split("."), s = r, r = o[1]), this.addNamespaces(r), Sn(this.data, o, s), i.silent || this.emit("added", e, r, n, s);
  }
  addResources(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const i in n)
      (z(n[i]) || Array.isArray(n[i])) && this.addResource(e, r, i, n[i], {
        silent: !0
      });
    s.silent || this.emit("added", e, r, n);
  }
  addResourceBundle(e, r, n, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1,
      skipCopy: !1
    }, o = [e, r];
    e.indexOf(".") > -1 && (o = e.split("."), s = n, n = r, r = o[1]), this.addNamespaces(r);
    let l = rr(this.data, o) || {};
    a.skipCopy || (n = JSON.parse(JSON.stringify(n))), s ? fs(l, n, i) : l = {
      ...l,
      ...n
    }, Sn(this.data, o, l), a.silent || this.emit("added", e, r, n);
  }
  removeResourceBundle(e, r) {
    this.hasResourceBundle(e, r) && delete this.data[e][r], this.removeNamespaces(r), this.emit("removed", e, r);
  }
  hasResourceBundle(e, r) {
    return this.getResource(e, r) !== void 0;
  }
  getResourceBundle(e, r) {
    return r || (r = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? {
      ...this.getResource(e, r)
    } : this.getResource(e, r);
  }
  getDataByLanguage(e) {
    return this.data[e];
  }
  hasLanguageSomeTranslations(e) {
    const r = this.getDataByLanguage(e);
    return !!(r && Object.keys(r) || []).find((s) => r[s] && Object.keys(r[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var hs = {
  processors: {},
  addPostProcessor(t) {
    this.processors[t.name] = t;
  },
  handle(t, e, r, n, s) {
    return t.forEach((i) => {
      this.processors[i] && (e = this.processors[i].process(e, r, n, s));
    }), e;
  }
};
const Ln = {};
class ir extends vr {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), Ka(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Ne.create("translator");
  }
  changeLanguage(e) {
    e && (this.language = e);
  }
  exists(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (e == null)
      return !1;
    const n = this.resolve(e, r);
    return n && n.res !== void 0;
  }
  extractFromKey(e, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const s = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let i = r.ns || this.options.defaultNS || [];
    const a = n && e.indexOf(n) > -1, o = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !ro(e, n, s);
    if (a && !o) {
      const l = e.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: e,
          namespaces: z(i) ? [i] : i
        };
      const c = e.split(n);
      (n !== s || n === s && this.options.ns.indexOf(c[0]) > -1) && (i = c.shift()), e = c.join(s);
    }
    return {
      key: e,
      namespaces: z(i) ? [i] : i
    };
  }
  translate(e, r, n) {
    if (typeof r != "object" && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), typeof r == "object" && (r = {
      ...r
    }), r || (r = {}), e == null) return "";
    Array.isArray(e) || (e = [String(e)]);
    const s = r.returnDetails !== void 0 ? r.returnDetails : this.options.returnDetails, i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator, {
      key: a,
      namespaces: o
    } = this.extractFromKey(e[e.length - 1], r), l = o[o.length - 1], c = r.lng || this.language, u = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (c && c.toLowerCase() === "cimode") {
      if (u) {
        const V = r.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${V}${a}`,
          usedKey: a,
          exactUsedKey: a,
          usedLng: c,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(r)
        } : `${l}${V}${a}`;
      }
      return s ? {
        res: a,
        usedKey: a,
        exactUsedKey: a,
        usedLng: c,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(r)
      } : a;
    }
    const h = this.resolve(e, r);
    let f = h && h.res;
    const C = h && h.usedKey || a, w = h && h.exactUsedKey || a, _ = Object.prototype.toString.apply(f), E = ["[object Number]", "[object Function]", "[object RegExp]"], j = r.joinArrays !== void 0 ? r.joinArrays : this.options.joinArrays, x = !this.i18nFormat || this.i18nFormat.handleAsObject, Z = !z(f) && typeof f != "boolean" && typeof f != "number";
    if (x && f && Z && E.indexOf(_) < 0 && !(z(j) && Array.isArray(f))) {
      if (!r.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const V = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(C, f, {
          ...r,
          ns: o
        }) : `key '${a} (${this.language})' returned an object instead of string.`;
        return s ? (h.res = V, h.usedParams = this.getUsedParamsDetails(r), h) : V;
      }
      if (i) {
        const V = Array.isArray(f), $ = V ? [] : {}, D = V ? w : C;
        for (const A in f)
          if (Object.prototype.hasOwnProperty.call(f, A)) {
            const q = `${D}${i}${A}`;
            $[A] = this.translate(q, {
              ...r,
              joinArrays: !1,
              ns: o
            }), $[A] === q && ($[A] = f[A]);
          }
        f = $;
      }
    } else if (x && z(j) && Array.isArray(f))
      f = f.join(j), f && (f = this.extendTranslation(f, e, r, n));
    else {
      let V = !1, $ = !1;
      const D = r.count !== void 0 && !z(r.count), A = ir.hasDefaultValue(r), q = D ? this.pluralResolver.getSuffix(c, r.count, r) : "", K = r.ordinal && D ? this.pluralResolver.getSuffix(c, r.count, {
        ordinal: !1
      }) : "", te = D && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), W = te && r[`defaultValue${this.options.pluralSeparator}zero`] || r[`defaultValue${q}`] || r[`defaultValue${K}`] || r.defaultValue;
      !this.isValidLookup(f) && A && (V = !0, f = W), this.isValidLookup(f) || ($ = !0, f = a);
      const T = (r.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && $ ? void 0 : f, G = A && W !== f && this.options.updateMissing;
      if ($ || V || G) {
        if (this.logger.log(G ? "updateKey" : "missingKey", c, l, a, G ? W : f), i) {
          const M = this.resolve(a, {
            ...r,
            keySeparator: !1
          });
          M && M.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let p = [];
        const v = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && v && v[0])
          for (let M = 0; M < v.length; M++)
            p.push(v[M]);
        else this.options.saveMissingTo === "all" ? p = this.languageUtils.toResolveHierarchy(r.lng || this.language) : p.push(r.lng || this.language);
        const I = (M, Q, J) => {
          const Ae = A && J !== f ? J : T;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(M, l, Q, Ae, G, r) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(M, l, Q, Ae, G, r), this.emit("missingKey", M, l, Q, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && D ? p.forEach((M) => {
          const Q = this.pluralResolver.getSuffixes(M, r);
          te && r[`defaultValue${this.options.pluralSeparator}zero`] && Q.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Q.push(`${this.options.pluralSeparator}zero`), Q.forEach((J) => {
            I([M], a + J, r[`defaultValue${J}`] || W);
          });
        }) : I(p, a, W));
      }
      f = this.extendTranslation(f, e, r, h, n), $ && f === a && this.options.appendNamespaceToMissingKey && (f = `${l}:${a}`), ($ || V) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${a}` : a, V ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return s ? (h.res = f, h.usedParams = this.getUsedParamsDetails(r), h) : f;
  }
  extendTranslation(e, r, n, s, i) {
    var a = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      e = this.i18nFormat.parse(e, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const c = z(e) && (n && n.interpolation && n.interpolation.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (c) {
        const f = e.match(this.interpolator.nestingRegexp);
        u = f && f.length;
      }
      let h = n.replace && !z(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (h = {
        ...this.options.interpolation.defaultVariables,
        ...h
      }), e = this.interpolator.interpolate(e, h, n.lng || this.language || s.usedLng, n), c) {
        const f = e.match(this.interpolator.nestingRegexp), C = f && f.length;
        u < C && (n.nest = !1);
      }
      !n.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (n.lng = this.language || s.usedLng), n.nest !== !1 && (e = this.interpolator.nest(e, function() {
        for (var f = arguments.length, C = new Array(f), w = 0; w < f; w++)
          C[w] = arguments[w];
        return i && i[0] === C[0] && !n.context ? (a.logger.warn(`It seems you are nesting recursively key: ${C[0]} in key: ${r[0]}`), null) : a.translate(...C, r);
      }, n)), n.interpolation && this.interpolator.reset();
    }
    const o = n.postProcess || this.options.postProcess, l = z(o) ? [o] : o;
    return e != null && l && l.length && n.applyPostProcessor !== !1 && (e = hs.handle(l, e, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...s,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), e;
  }
  resolve(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n, s, i, a, o;
    return z(e) && (e = [e]), e.forEach((l) => {
      if (this.isValidLookup(n)) return;
      const c = this.extractFromKey(l, r), u = c.key;
      s = u;
      let h = c.namespaces;
      this.options.fallbackNS && (h = h.concat(this.options.fallbackNS));
      const f = r.count !== void 0 && !z(r.count), C = f && !r.ordinal && r.count === 0 && this.pluralResolver.shouldUseIntlApi(), w = r.context !== void 0 && (z(r.context) || typeof r.context == "number") && r.context !== "", _ = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      h.forEach((E) => {
        this.isValidLookup(n) || (o = E, !Ln[`${_[0]}-${E}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(o) && (Ln[`${_[0]}-${E}`] = !0, this.logger.warn(`key "${s}" for languages "${_.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), _.forEach((j) => {
          if (this.isValidLookup(n)) return;
          a = j;
          const x = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(x, u, j, E, r);
          else {
            let V;
            f && (V = this.pluralResolver.getSuffix(j, r.count, r));
            const $ = `${this.options.pluralSeparator}zero`, D = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (x.push(u + V), r.ordinal && V.indexOf(D) === 0 && x.push(u + V.replace(D, this.options.pluralSeparator)), C && x.push(u + $)), w) {
              const A = `${u}${this.options.contextSeparator}${r.context}`;
              x.push(A), f && (x.push(A + V), r.ordinal && V.indexOf(D) === 0 && x.push(A + V.replace(D, this.options.pluralSeparator)), C && x.push(A + $));
            }
          }
          let Z;
          for (; Z = x.pop(); )
            this.isValidLookup(n) || (i = Z, n = this.getResource(j, E, Z, r));
        }));
      });
    }), {
      res: n,
      usedKey: s,
      exactUsedKey: i,
      usedLng: a,
      usedNS: o
    };
  }
  isValidLookup(e) {
    return e !== void 0 && !(!this.options.returnNull && e === null) && !(!this.options.returnEmptyString && e === "");
  }
  getResource(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, r, n, s) : this.resourceStore.getResource(e, r, n, s);
  }
  getUsedParamsDetails() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = e.replace && !z(e.replace);
    let s = n ? e.replace : e;
    if (n && typeof e.count < "u" && (s.count = e.count), this.options.interpolation.defaultVariables && (s = {
      ...this.options.interpolation.defaultVariables,
      ...s
    }), !n) {
      s = {
        ...s
      };
      for (const i of r)
        delete s[i];
    }
    return s;
  }
  static hasDefaultValue(e) {
    const r = "defaultValue";
    for (const n in e)
      if (Object.prototype.hasOwnProperty.call(e, n) && r === n.substring(0, r.length) && e[n] !== void 0)
        return !0;
    return !1;
  }
}
const Nr = (t) => t.charAt(0).toUpperCase() + t.slice(1);
class kn {
  constructor(e) {
    this.options = e, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ne.create("languageUtils");
  }
  getScriptPartFromCode(e) {
    if (e = nr(e), !e || e.indexOf("-") < 0) return null;
    const r = e.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(e) {
    if (e = nr(e), !e || e.indexOf("-") < 0) return e;
    const r = e.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(e) {
    if (z(e) && e.indexOf("-") > -1) {
      if (typeof Intl < "u" && typeof Intl.getCanonicalLocales < "u")
        try {
          let s = Intl.getCanonicalLocales(e)[0];
          if (s && this.options.lowerCaseLng && (s = s.toLowerCase()), s) return s;
        } catch {
        }
      const r = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let n = e.split("-");
      return this.options.lowerCaseLng ? n = n.map((s) => s.toLowerCase()) : n.length === 2 ? (n[0] = n[0].toLowerCase(), n[1] = n[1].toUpperCase(), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = Nr(n[1].toLowerCase()))) : n.length === 3 && (n[0] = n[0].toLowerCase(), n[1].length === 2 && (n[1] = n[1].toUpperCase()), n[0] !== "sgn" && n[2].length === 2 && (n[2] = n[2].toUpperCase()), r.indexOf(n[1].toLowerCase()) > -1 && (n[1] = Nr(n[1].toLowerCase())), r.indexOf(n[2].toLowerCase()) > -1 && (n[2] = Nr(n[2].toLowerCase()))), n.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
  }
  isSupportedCode(e) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
  }
  getBestMatchFromCodes(e) {
    if (!e) return null;
    let r;
    return e.forEach((n) => {
      if (r) return;
      const s = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (r = s);
    }), !r && this.options.supportedLngs && e.forEach((n) => {
      if (r) return;
      const s = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(s)) return r = s;
      r = this.options.supportedLngs.find((i) => {
        if (i === s) return i;
        if (!(i.indexOf("-") < 0 && s.indexOf("-") < 0) && (i.indexOf("-") > 0 && s.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === s || i.indexOf(s) === 0 && s.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(e, r) {
    if (!e) return [];
    if (typeof e == "function" && (e = e(r)), z(e) && (e = [e]), Array.isArray(e)) return e;
    if (!r) return e.default || [];
    let n = e[r];
    return n || (n = e[this.getScriptPartFromCode(r)]), n || (n = e[this.formatLanguageCode(r)]), n || (n = e[this.getLanguagePartFromCode(r)]), n || (n = e.default), n || [];
  }
  toResolveHierarchy(e, r) {
    const n = this.getFallbackCodes(r || this.options.fallbackLng || [], e), s = [], i = (a) => {
      a && (this.isSupportedCode(a) ? s.push(a) : this.logger.warn(`rejecting language code not found in supportedLngs: ${a}`));
    };
    return z(e) && (e.indexOf("-") > -1 || e.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && i(this.formatLanguageCode(e)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && i(this.getScriptPartFromCode(e)), this.options.load !== "currentOnly" && i(this.getLanguagePartFromCode(e))) : z(e) && i(this.formatLanguageCode(e)), n.forEach((a) => {
      s.indexOf(a) < 0 && i(this.formatLanguageCode(a));
    }), s;
  }
}
let so = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], io = {
  1: (t) => +(t > 1),
  2: (t) => +(t != 1),
  3: (t) => 0,
  4: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  5: (t) => t == 0 ? 0 : t == 1 ? 1 : t == 2 ? 2 : t % 100 >= 3 && t % 100 <= 10 ? 3 : t % 100 >= 11 ? 4 : 5,
  6: (t) => t == 1 ? 0 : t >= 2 && t <= 4 ? 1 : 2,
  7: (t) => t == 1 ? 0 : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  8: (t) => t == 1 ? 0 : t == 2 ? 1 : t != 8 && t != 11 ? 2 : 3,
  9: (t) => +(t >= 2),
  10: (t) => t == 1 ? 0 : t == 2 ? 1 : t < 7 ? 2 : t < 11 ? 3 : 4,
  11: (t) => t == 1 || t == 11 ? 0 : t == 2 || t == 12 ? 1 : t > 2 && t < 20 ? 2 : 3,
  12: (t) => +(t % 10 != 1 || t % 100 == 11),
  13: (t) => +(t !== 0),
  14: (t) => t == 1 ? 0 : t == 2 ? 1 : t == 3 ? 2 : 3,
  15: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t % 10 >= 2 && (t % 100 < 10 || t % 100 >= 20) ? 1 : 2,
  16: (t) => t % 10 == 1 && t % 100 != 11 ? 0 : t !== 0 ? 1 : 2,
  17: (t) => t == 1 || t % 10 == 1 && t % 100 != 11 ? 0 : 1,
  18: (t) => t == 0 ? 0 : t == 1 ? 1 : 2,
  19: (t) => t == 1 ? 0 : t == 0 || t % 100 > 1 && t % 100 < 11 ? 1 : t % 100 > 10 && t % 100 < 20 ? 2 : 3,
  20: (t) => t == 1 ? 0 : t == 0 || t % 100 > 0 && t % 100 < 20 ? 1 : 2,
  21: (t) => t % 100 == 1 ? 1 : t % 100 == 2 ? 2 : t % 100 == 3 || t % 100 == 4 ? 3 : 0,
  22: (t) => t == 1 ? 0 : t == 2 ? 1 : (t < 0 || t > 10) && t % 10 == 0 ? 2 : 3
};
const ao = ["v1", "v2", "v3"], oo = ["v4"], On = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, lo = () => {
  const t = {};
  return so.forEach((e) => {
    e.lngs.forEach((r) => {
      t[r] = {
        numbers: e.nr,
        plurals: io[e.fc]
      };
    });
  }), t;
};
class co {
  constructor(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = e, this.options = r, this.logger = Ne.create("pluralResolver"), (!this.options.compatibilityJSON || oo.includes(this.options.compatibilityJSON)) && (typeof Intl > "u" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = lo(), this.pluralRulesCache = {};
  }
  addRule(e, r) {
    this.rules[e] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const n = nr(e === "dev" ? "en" : e), s = r.ordinal ? "ordinal" : "cardinal", i = JSON.stringify({
        cleanedCode: n,
        type: s
      });
      if (i in this.pluralRulesCache)
        return this.pluralRulesCache[i];
      let a;
      try {
        a = new Intl.PluralRules(n, {
          type: s
        });
      } catch {
        if (!e.match(/-|_/)) return;
        const l = this.languageUtils.getLanguagePartFromCode(e);
        a = this.getRule(l, r);
      }
      return this.pluralRulesCache[i] = a, a;
    }
    return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
  }
  needsPlural(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return this.shouldUseIntlApi() ? n && n.resolvedOptions().pluralCategories.length > 1 : n && n.numbers.length > 1;
  }
  getPluralFormsOfKey(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(e, n).map((s) => `${r}${s}`);
  }
  getSuffixes(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const n = this.getRule(e, r);
    return n ? this.shouldUseIntlApi() ? n.resolvedOptions().pluralCategories.sort((s, i) => On[s] - On[i]).map((s) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : n.numbers.map((s) => this.getSuffix(e, s, r)) : [];
  }
  getSuffix(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(e, n);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(r)}` : this.getSuffixRetroCompatible(s, r) : (this.logger.warn(`no plural rule found for: ${e}`), "");
  }
  getSuffixRetroCompatible(e, r) {
    const n = e.noAbs ? e.plurals(r) : e.plurals(Math.abs(r));
    let s = e.numbers[n];
    this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const i = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : i() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && e.numbers.length === 2 && e.numbers[0] === 1 ? i() : this.options.prepend && n.toString() ? this.options.prepend + n.toString() : n.toString();
  }
  shouldUseIntlApi() {
    return !ao.includes(this.options.compatibilityJSON);
  }
}
const An = function(t, e, r) {
  let n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, i = Xa(t, e, r);
  return !i && s && z(r) && (i = Br(t, r, n), i === void 0 && (i = Br(e, r, n))), i;
}, Pr = (t) => t.replace(/\$/g, "$$$$");
class uo {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ne.create("interpolator"), this.options = e, this.format = e.interpolation && e.interpolation.format || ((r) => r), this.init(e);
  }
  init() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    e.interpolation || (e.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: s,
      prefix: i,
      prefixEscaped: a,
      suffix: o,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: h,
      nestingPrefix: f,
      nestingPrefixEscaped: C,
      nestingSuffix: w,
      nestingSuffixEscaped: _,
      nestingOptionsSeparator: E,
      maxReplaces: j,
      alwaysFormat: x
    } = e.interpolation;
    this.escape = r !== void 0 ? r : Ya, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = s !== void 0 ? s : !1, this.prefix = i ? at(i) : a || "{{", this.suffix = o ? at(o) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : h || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = f ? at(f) : C || at("$t("), this.nestingSuffix = w ? at(w) : _ || at(")"), this.nestingOptionsSeparator = E || ",", this.maxReplaces = j || 1e3, this.alwaysFormat = x !== void 0 ? x : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const e = (r, n) => r && r.source === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = e(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = e(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = e(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(e, r, n, s) {
    let i, a, o;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (C) => {
      if (C.indexOf(this.formatSeparator) < 0) {
        const j = An(r, l, C, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(j, void 0, n, {
          ...s,
          ...r,
          interpolationkey: C
        }) : j;
      }
      const w = C.split(this.formatSeparator), _ = w.shift().trim(), E = w.join(this.formatSeparator).trim();
      return this.format(An(r, l, _, this.options.keySeparator, this.options.ignoreJSONStructure), E, n, {
        ...s,
        ...r,
        interpolationkey: _
      });
    };
    this.resetRegExp();
    const u = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, h = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (C) => Pr(C)
    }, {
      regex: this.regexp,
      safeValue: (C) => this.escapeValue ? Pr(this.escape(C)) : Pr(C)
    }].forEach((C) => {
      for (o = 0; i = C.regex.exec(e); ) {
        const w = i[1].trim();
        if (a = c(w), a === void 0)
          if (typeof u == "function") {
            const E = u(e, i, s);
            a = z(E) ? E : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, w))
            a = "";
          else if (h) {
            a = i[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${w} for interpolating ${e}`), a = "";
        else !z(a) && !this.useRawValueToEscape && (a = _n(a));
        const _ = C.safeValue(a);
        if (e = e.replace(i[0], _), h ? (C.regex.lastIndex += a.length, C.regex.lastIndex -= i[0].length) : C.regex.lastIndex = 0, o++, o >= this.maxReplaces)
          break;
      }
    }), e;
  }
  nest(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, i, a;
    const o = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const h = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${h[1]}`;
      l = h[0], f = this.interpolate(f, a);
      const C = f.match(/'/g), w = f.match(/"/g);
      (C && C.length % 2 === 0 && !w || w.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        a = JSON.parse(f), c && (a = {
          ...c,
          ...a
        });
      } catch (_) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, _), `${l}${u}${f}`;
      }
      return a.defaultValue && a.defaultValue.indexOf(this.prefix) > -1 && delete a.defaultValue, l;
    };
    for (; s = this.nestingRegexp.exec(e); ) {
      let l = [];
      a = {
        ...n
      }, a = a.replace && !z(a.replace) ? a.replace : a, a.applyPostProcessor = !1, delete a.defaultValue;
      let c = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const u = s[1].split(this.formatSeparator).map((h) => h.trim());
        s[1] = u.shift(), l = u, c = !0;
      }
      if (i = r(o.call(this, s[1].trim(), a), a), i && s[0] === e && !z(i)) return i;
      z(i) || (i = _n(i)), i || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${e}`), i = ""), c && (i = l.reduce((u, h) => this.format(u, h, n.lng, {
        ...n,
        interpolationkey: s[1].trim()
      }), i.trim())), e = e.replace(s[0], i), this.regexp.lastIndex = 0;
    }
    return e;
  }
}
const fo = (t) => {
  let e = t.toLowerCase().trim();
  const r = {};
  if (t.indexOf("(") > -1) {
    const n = t.split("(");
    e = n[0].toLowerCase().trim();
    const s = n[1].substring(0, n[1].length - 1);
    e === "currency" && s.indexOf(":") < 0 ? r.currency || (r.currency = s.trim()) : e === "relativetime" && s.indexOf(":") < 0 ? r.range || (r.range = s.trim()) : s.split(";").forEach((a) => {
      if (a) {
        const [o, ...l] = a.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = o.trim();
        r[u] || (r[u] = c), c === "false" && (r[u] = !1), c === "true" && (r[u] = !0), isNaN(c) || (r[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: e,
    formatOptions: r
  };
}, ot = (t) => {
  const e = {};
  return (r, n, s) => {
    let i = s;
    s && s.interpolationkey && s.formatParams && s.formatParams[s.interpolationkey] && s[s.interpolationkey] && (i = {
      ...i,
      [s.interpolationkey]: void 0
    });
    const a = n + JSON.stringify(i);
    let o = e[a];
    return o || (o = t(nr(n), s), e[a] = o), o(r);
  };
};
class ho {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = Ne.create("formatter"), this.options = e, this.formats = {
      number: ot((r, n) => {
        const s = new Intl.NumberFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      }),
      currency: ot((r, n) => {
        const s = new Intl.NumberFormat(r, {
          ...n,
          style: "currency"
        });
        return (i) => s.format(i);
      }),
      datetime: ot((r, n) => {
        const s = new Intl.DateTimeFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      }),
      relativetime: ot((r, n) => {
        const s = new Intl.RelativeTimeFormat(r, {
          ...n
        });
        return (i) => s.format(i, n.range || "day");
      }),
      list: ot((r, n) => {
        const s = new Intl.ListFormat(r, {
          ...n
        });
        return (i) => s.format(i);
      })
    }, this.init(e);
  }
  init(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = r.interpolation.formatSeparator || ",";
  }
  add(e, r) {
    this.formats[e.toLowerCase().trim()] = r;
  }
  addCached(e, r) {
    this.formats[e.toLowerCase().trim()] = ot(r);
  }
  format(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const i = r.split(this.formatSeparator);
    if (i.length > 1 && i[0].indexOf("(") > 1 && i[0].indexOf(")") < 0 && i.find((o) => o.indexOf(")") > -1)) {
      const o = i.findIndex((l) => l.indexOf(")") > -1);
      i[0] = [i[0], ...i.splice(1, o)].join(this.formatSeparator);
    }
    return i.reduce((o, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = fo(l);
      if (this.formats[c]) {
        let h = o;
        try {
          const f = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, C = f.locale || f.lng || s.locale || s.lng || n;
          h = this.formats[c](o, C, {
            ...u,
            ...s,
            ...f
          });
        } catch (f) {
          this.logger.warn(f);
        }
        return h;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return o;
    }, e);
  }
}
const po = (t, e) => {
  t.pending[e] !== void 0 && (delete t.pending[e], t.pendingCount--);
};
class go extends vr {
  constructor(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = e, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = s, this.logger = Ne.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(n, s.backend, s);
  }
  queueLoad(e, r, n, s) {
    const i = {}, a = {}, o = {}, l = {};
    return e.forEach((c) => {
      let u = !0;
      r.forEach((h) => {
        const f = `${c}|${h}`;
        !n.reload && this.store.hasResourceBundle(c, h) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? a[f] === void 0 && (a[f] = !0) : (this.state[f] = 1, u = !1, a[f] === void 0 && (a[f] = !0), i[f] === void 0 && (i[f] = !0), l[h] === void 0 && (l[h] = !0)));
      }), u || (o[c] = !0);
    }), (Object.keys(i).length || Object.keys(a).length) && this.queue.push({
      pending: a,
      pendingCount: Object.keys(a).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(i),
      pending: Object.keys(a),
      toLoadLanguages: Object.keys(o),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(e, r, n) {
    const s = e.split("|"), i = s[0], a = s[1];
    r && this.emit("failedLoading", i, a, r), !r && n && this.store.addResourceBundle(i, a, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[e] = r ? -1 : 2, r && n && (this.state[e] = 0);
    const o = {};
    this.queue.forEach((l) => {
      Ja(l.loaded, [i], a), po(l, e), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        o[c] || (o[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((h) => {
          o[c][h] === void 0 && (o[c][h] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", o), this.queue = this.queue.filter((l) => !l.done);
  }
  read(e, r, n) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, a = arguments.length > 5 ? arguments[5] : void 0;
    if (!e.length) return a(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: e,
        ns: r,
        fcName: n,
        tried: s,
        wait: i,
        callback: a
      });
      return;
    }
    this.readingCalls++;
    const o = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const h = this.waitingReads.shift();
        this.read(h.lng, h.ns, h.fcName, h.tried, h.wait, h.callback);
      }
      if (c && u && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, e, r, n, s + 1, i * 2, a);
        }, i);
        return;
      }
      a(c, u);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(e, r);
        c && typeof c.then == "function" ? c.then((u) => o(null, u)).catch(o) : o(null, c);
      } catch (c) {
        o(c);
      }
      return;
    }
    return l(e, r, o);
  }
  prepareLoading(e, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    z(e) && (e = this.languageUtils.toResolveHierarchy(e)), z(r) && (r = [r]);
    const i = this.queueLoad(e, r, n, s);
    if (!i.toLoad.length)
      return i.pending.length || s(), null;
    i.toLoad.forEach((a) => {
      this.loadOne(a);
    });
  }
  load(e, r, n) {
    this.prepareLoading(e, r, {}, n);
  }
  reload(e, r, n) {
    this.prepareLoading(e, r, {
      reload: !0
    }, n);
  }
  loadOne(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const n = e.split("|"), s = n[0], i = n[1];
    this.read(s, i, "read", void 0, void 0, (a, o) => {
      a && this.logger.warn(`${r}loading namespace ${i} for language ${s} failed`, a), !a && o && this.logger.log(`${r}loaded namespace ${i} for language ${s}`, o), this.loaded(e, a, o);
    });
  }
  saveMissing(e, r, n, s, i) {
    let a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(r)) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if (this.backend && this.backend.create) {
        const l = {
          ...a,
          isUpdate: i
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(e, r, n, s, l) : u = c(e, r, n, s), u && typeof u.then == "function" ? u.then((h) => o(null, h)).catch(o) : o(null, u);
          } catch (u) {
            o(u);
          }
        else
          c(e, r, n, s, o, l);
      }
      !e || !e[0] || this.store.addResource(e[0], r, n, s);
    }
  }
}
const Tn = () => ({
  debug: !1,
  initImmediate: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (t) => {
    let e = {};
    if (typeof t[1] == "object" && (e = t[1]), z(t[1]) && (e.defaultValue = t[1]), z(t[2]) && (e.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
      const r = t[3] || t[2];
      Object.keys(r).forEach((n) => {
        e[n] = r[n];
      });
    }
    return e;
  },
  interpolation: {
    escapeValue: !0,
    format: (t) => t,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  }
}), Rn = (t) => (z(t.ns) && (t.ns = [t.ns]), z(t.fallbackLng) && (t.fallbackLng = [t.fallbackLng]), z(t.fallbackNS) && (t.fallbackNS = [t.fallbackNS]), t.supportedLngs && t.supportedLngs.indexOf("cimode") < 0 && (t.supportedLngs = t.supportedLngs.concat(["cimode"])), t), Wt = () => {
}, mo = (t) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach((r) => {
    typeof t[r] == "function" && (t[r] = t[r].bind(t));
  });
};
class At extends vr {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Rn(e), this.services = {}, this.logger = Ne, this.modules = {
      external: []
    }, mo(this), r && !this.isInitialized && !e.isClone) {
      if (!this.options.initImmediate)
        return this.init(e, r), this;
      setTimeout(() => {
        this.init(e, r);
      }, 0);
    }
  }
  init() {
    var e = this;
    let r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = !0, typeof r == "function" && (n = r, r = {}), !r.defaultNS && r.defaultNS !== !1 && r.ns && (z(r.ns) ? r.defaultNS = r.ns : r.ns.indexOf("translation") < 0 && (r.defaultNS = r.ns[0]));
    const s = Tn();
    this.options = {
      ...s,
      ...this.options,
      ...Rn(r)
    }, this.options.compatibilityAPI !== "v1" && (this.options.interpolation = {
      ...s.interpolation,
      ...this.options.interpolation
    }), r.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = r.keySeparator), r.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = r.nsSeparator);
    const i = (u) => u ? typeof u == "function" ? new u() : u : null;
    if (!this.options.isClone) {
      this.modules.logger ? Ne.init(i(this.modules.logger), this.options) : Ne.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl < "u" && (u = ho);
      const h = new kn(this.options);
      this.store = new En(this.options.resources, this.options);
      const f = this.services;
      f.logger = Ne, f.resourceStore = this.store, f.languageUtils = h, f.pluralResolver = new co(h, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (f.formatter = i(u), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new uo(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new go(i(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(C) {
        for (var w = arguments.length, _ = new Array(w > 1 ? w - 1 : 0), E = 1; E < w; E++)
          _[E - 1] = arguments[E];
        e.emit(C, ..._);
      }), this.modules.languageDetector && (f.languageDetector = i(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = i(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new ir(this.services, this.options), this.translator.on("*", function(C) {
        for (var w = arguments.length, _ = new Array(w > 1 ? w - 1 : 0), E = 1; E < w; E++)
          _[E - 1] = arguments[E];
        e.emit(C, ..._);
      }), this.modules.external.forEach((C) => {
        C.init && C.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, n || (n = Wt), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return e.store[u](...arguments), e;
      };
    });
    const l = bt(), c = () => {
      const u = (h, f) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), n(h, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? c() : setTimeout(c, 0), l;
  }
  loadResources(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wt;
    const s = z(e) ? e : this.language;
    if (typeof e == "function" && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return n();
      const i = [], a = (o) => {
        if (!o || o === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(o).forEach((c) => {
          c !== "cimode" && i.indexOf(c) < 0 && i.push(c);
        });
      };
      s ? a(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => a(l)), this.options.preload && this.options.preload.forEach((o) => a(o)), this.services.backendConnector.load(i, this.options.ns, (o) => {
        !o && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(o);
      });
    } else
      n(null);
  }
  reloadResources(e, r, n) {
    const s = bt();
    return typeof e == "function" && (n = e, e = void 0), typeof r == "function" && (n = r, r = void 0), e || (e = this.languages), r || (r = this.options.ns), n || (n = Wt), this.services.backendConnector.reload(e, r, (i) => {
      s.resolve(), n(i);
    }), s;
  }
  use(e) {
    if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return e.type === "backend" && (this.modules.backend = e), (e.type === "logger" || e.log && e.warn && e.error) && (this.modules.logger = e), e.type === "languageDetector" && (this.modules.languageDetector = e), e.type === "i18nFormat" && (this.modules.i18nFormat = e), e.type === "postProcessor" && hs.addPostProcessor(e), e.type === "formatter" && (this.modules.formatter = e), e.type === "3rdParty" && this.modules.external.push(e), this;
  }
  setResolvedLanguage(e) {
    if (!(!e || !this.languages) && !(["cimode", "dev"].indexOf(e) > -1))
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
  }
  changeLanguage(e, r) {
    var n = this;
    this.isLanguageChangingTo = e;
    const s = bt();
    this.emit("languageChanging", e);
    const i = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, a = (l, c) => {
      c ? (i(c), this.translator.changeLanguage(c), this.isLanguageChangingTo = void 0, this.emit("languageChanged", c), this.logger.log("languageChanged", c)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return n.t(...arguments);
      }), r && r(l, function() {
        return n.t(...arguments);
      });
    }, o = (l) => {
      !e && !l && this.services.languageDetector && (l = []);
      const c = z(l) ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      c && (this.language || i(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(c)), this.loadResources(c, (u) => {
        a(u, c);
      });
    };
    return !e && this.services.languageDetector && !this.services.languageDetector.async ? o(this.services.languageDetector.detect()) : !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(o) : this.services.languageDetector.detect(o) : o(e), s;
  }
  getFixedT(e, r, n) {
    var s = this;
    const i = function(a, o) {
      let l;
      if (typeof o != "object") {
        for (var c = arguments.length, u = new Array(c > 2 ? c - 2 : 0), h = 2; h < c; h++)
          u[h - 2] = arguments[h];
        l = s.options.overloadTranslationOptionHandler([a, o].concat(u));
      } else
        l = {
          ...o
        };
      l.lng = l.lng || i.lng, l.lngs = l.lngs || i.lngs, l.ns = l.ns || i.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || i.keyPrefix);
      const f = s.options.keySeparator || ".";
      let C;
      return l.keyPrefix && Array.isArray(a) ? C = a.map((w) => `${l.keyPrefix}${f}${w}`) : C = l.keyPrefix ? `${l.keyPrefix}${f}${a}` : a, s.t(C, l);
    };
    return z(e) ? i.lng = e : i.lngs = e, i.ns = r, i.keyPrefix = n, i;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(e) {
    this.options.defaultNS = e;
  }
  hasLoadedNamespace(e) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, i = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode") return !0;
    const a = (o, l) => {
      const c = this.services.backendConnector.state[`${o}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (r.precheck) {
      const o = r.precheck(this, a);
      if (o !== void 0) return o;
    }
    return !!(this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || a(n, e) && (!s || a(i, e)));
  }
  loadNamespaces(e, r) {
    const n = bt();
    return this.options.ns ? (z(e) && (e = [e]), e.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      n.resolve(), r && r(s);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(e, r) {
    const n = bt();
    z(e) && (e = [e]);
    const s = this.options.preload || [], i = e.filter((a) => s.indexOf(a) < 0 && this.services.languageUtils.isSupportedCode(a));
    return i.length ? (this.options.preload = s.concat(i), this.loadResources((a) => {
      n.resolve(), r && r(a);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(e) {
    if (e || (e = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !e) return "rtl";
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = this.services && this.services.languageUtils || new kn(Tn());
    return r.indexOf(n.getLanguagePartFromCode(e)) > -1 || e.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    return new At(e, r);
  }
  cloneInstance() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Wt;
    const n = e.forkResourceStore;
    n && delete e.forkResourceStore;
    const s = {
      ...this.options,
      ...e,
      isClone: !0
    }, i = new At(s);
    return (e.debug !== void 0 || e.prefix !== void 0) && (i.logger = i.logger.clone(e)), ["store", "services", "language"].forEach((o) => {
      i[o] = this[o];
    }), i.services = {
      ...this.services
    }, i.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, n && (i.store = new En(this.store.data, s), i.services.resourceStore = i.store), i.translator = new ir(i.services, s), i.translator.on("*", function(o) {
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      i.emit(o, ...c);
    }), i.init(s, r), i.translator.options = s, i.translator.backendConnector.services.utils = {
      hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
    }, i;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const fe = At.createInstance();
fe.createInstance = At.createInstance;
fe.createInstance;
fe.dir;
fe.init;
fe.loadResources;
fe.reloadResources;
fe.use;
fe.changeLanguage;
fe.getFixedT;
fe.t;
fe.exists;
fe.setDefaultNamespace;
fe.hasLoadedNamespace;
fe.loadNamespaces;
fe.loadLanguages;
function Hr(t) {
  "@babel/helpers - typeof";
  return Hr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hr(t);
}
function ps() {
  return typeof XMLHttpRequest == "function" || (typeof XMLHttpRequest > "u" ? "undefined" : Hr(XMLHttpRequest)) === "object";
}
function yo(t) {
  return !!t && typeof t.then == "function";
}
function vo(t) {
  return yo(t) ? t : Promise.resolve(t);
}
function Co(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Jt = { exports: {} }, Xt = { exports: {} }, Nn;
function bo() {
  return Nn || (Nn = 1, (function(t, e) {
    var r = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof Et < "u" && Et, n = (function() {
      function i() {
        this.fetch = !1, this.DOMException = r.DOMException;
      }
      return i.prototype = r, new i();
    })();
    (function(i) {
      (function(a) {
        var o = typeof i < "u" && i || typeof self < "u" && self || typeof o < "u" && o, l = {
          searchParams: "URLSearchParams" in o,
          iterable: "Symbol" in o && "iterator" in Symbol,
          blob: "FileReader" in o && "Blob" in o && (function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          })(),
          formData: "FormData" in o,
          arrayBuffer: "ArrayBuffer" in o
        };
        function c(p) {
          return p && DataView.prototype.isPrototypeOf(p);
        }
        if (l.arrayBuffer)
          var u = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], h = ArrayBuffer.isView || function(p) {
            return p && u.indexOf(Object.prototype.toString.call(p)) > -1;
          };
        function f(p) {
          if (typeof p != "string" && (p = String(p)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(p) || p === "")
            throw new TypeError('Invalid character in header field name: "' + p + '"');
          return p.toLowerCase();
        }
        function C(p) {
          return typeof p != "string" && (p = String(p)), p;
        }
        function w(p) {
          var v = {
            next: function() {
              var I = p.shift();
              return { done: I === void 0, value: I };
            }
          };
          return l.iterable && (v[Symbol.iterator] = function() {
            return v;
          }), v;
        }
        function _(p) {
          this.map = {}, p instanceof _ ? p.forEach(function(v, I) {
            this.append(I, v);
          }, this) : Array.isArray(p) ? p.forEach(function(v) {
            this.append(v[0], v[1]);
          }, this) : p && Object.getOwnPropertyNames(p).forEach(function(v) {
            this.append(v, p[v]);
          }, this);
        }
        _.prototype.append = function(p, v) {
          p = f(p), v = C(v);
          var I = this.map[p];
          this.map[p] = I ? I + ", " + v : v;
        }, _.prototype.delete = function(p) {
          delete this.map[f(p)];
        }, _.prototype.get = function(p) {
          return p = f(p), this.has(p) ? this.map[p] : null;
        }, _.prototype.has = function(p) {
          return this.map.hasOwnProperty(f(p));
        }, _.prototype.set = function(p, v) {
          this.map[f(p)] = C(v);
        }, _.prototype.forEach = function(p, v) {
          for (var I in this.map)
            this.map.hasOwnProperty(I) && p.call(v, this.map[I], I, this);
        }, _.prototype.keys = function() {
          var p = [];
          return this.forEach(function(v, I) {
            p.push(I);
          }), w(p);
        }, _.prototype.values = function() {
          var p = [];
          return this.forEach(function(v) {
            p.push(v);
          }), w(p);
        }, _.prototype.entries = function() {
          var p = [];
          return this.forEach(function(v, I) {
            p.push([I, v]);
          }), w(p);
        }, l.iterable && (_.prototype[Symbol.iterator] = _.prototype.entries);
        function E(p) {
          if (p.bodyUsed)
            return Promise.reject(new TypeError("Already read"));
          p.bodyUsed = !0;
        }
        function j(p) {
          return new Promise(function(v, I) {
            p.onload = function() {
              v(p.result);
            }, p.onerror = function() {
              I(p.error);
            };
          });
        }
        function x(p) {
          var v = new FileReader(), I = j(v);
          return v.readAsArrayBuffer(p), I;
        }
        function Z(p) {
          var v = new FileReader(), I = j(v);
          return v.readAsText(p), I;
        }
        function V(p) {
          for (var v = new Uint8Array(p), I = new Array(v.length), M = 0; M < v.length; M++)
            I[M] = String.fromCharCode(v[M]);
          return I.join("");
        }
        function $(p) {
          if (p.slice)
            return p.slice(0);
          var v = new Uint8Array(p.byteLength);
          return v.set(new Uint8Array(p)), v.buffer;
        }
        function D() {
          return this.bodyUsed = !1, this._initBody = function(p) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = p, p ? typeof p == "string" ? this._bodyText = p : l.blob && Blob.prototype.isPrototypeOf(p) ? this._bodyBlob = p : l.formData && FormData.prototype.isPrototypeOf(p) ? this._bodyFormData = p : l.searchParams && URLSearchParams.prototype.isPrototypeOf(p) ? this._bodyText = p.toString() : l.arrayBuffer && l.blob && c(p) ? (this._bodyArrayBuffer = $(p.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : l.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(p) || h(p)) ? this._bodyArrayBuffer = $(p) : this._bodyText = p = Object.prototype.toString.call(p) : this._bodyText = "", this.headers.get("content-type") || (typeof p == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : l.searchParams && URLSearchParams.prototype.isPrototypeOf(p) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, l.blob && (this.blob = function() {
            var p = E(this);
            if (p)
              return p;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }, this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var p = E(this);
              return p || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else
              return this.blob().then(x);
          }), this.text = function() {
            var p = E(this);
            if (p)
              return p;
            if (this._bodyBlob)
              return Z(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(V(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, l.formData && (this.formData = function() {
            return this.text().then(te);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var A = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
        function q(p) {
          var v = p.toUpperCase();
          return A.indexOf(v) > -1 ? v : p;
        }
        function K(p, v) {
          if (!(this instanceof K))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          v = v || {};
          var I = v.body;
          if (p instanceof K) {
            if (p.bodyUsed)
              throw new TypeError("Already read");
            this.url = p.url, this.credentials = p.credentials, v.headers || (this.headers = new _(p.headers)), this.method = p.method, this.mode = p.mode, this.signal = p.signal, !I && p._bodyInit != null && (I = p._bodyInit, p.bodyUsed = !0);
          } else
            this.url = String(p);
          if (this.credentials = v.credentials || this.credentials || "same-origin", (v.headers || !this.headers) && (this.headers = new _(v.headers)), this.method = q(v.method || this.method || "GET"), this.mode = v.mode || this.mode || null, this.signal = v.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && I)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(I), (this.method === "GET" || this.method === "HEAD") && (v.cache === "no-store" || v.cache === "no-cache")) {
            var M = /([?&])_=[^&]*/;
            if (M.test(this.url))
              this.url = this.url.replace(M, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var Q = /\?/;
              this.url += (Q.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        K.prototype.clone = function() {
          return new K(this, { body: this._bodyInit });
        };
        function te(p) {
          var v = new FormData();
          return p.trim().split("&").forEach(function(I) {
            if (I) {
              var M = I.split("="), Q = M.shift().replace(/\+/g, " "), J = M.join("=").replace(/\+/g, " ");
              v.append(decodeURIComponent(Q), decodeURIComponent(J));
            }
          }), v;
        }
        function W(p) {
          var v = new _(), I = p.replace(/\r?\n[\t ]+/g, " ");
          return I.split("\r").map(function(M) {
            return M.indexOf(`
`) === 0 ? M.substr(1, M.length) : M;
          }).forEach(function(M) {
            var Q = M.split(":"), J = Q.shift().trim();
            if (J) {
              var Ae = Q.join(":").trim();
              v.append(J, Ae);
            }
          }), v;
        }
        D.call(K.prototype);
        function O(p, v) {
          if (!(this instanceof O))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          v || (v = {}), this.type = "default", this.status = v.status === void 0 ? 200 : v.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = v.statusText === void 0 ? "" : "" + v.statusText, this.headers = new _(v.headers), this.url = v.url || "", this._initBody(p);
        }
        D.call(O.prototype), O.prototype.clone = function() {
          return new O(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new _(this.headers),
            url: this.url
          });
        }, O.error = function() {
          var p = new O(null, { status: 0, statusText: "" });
          return p.type = "error", p;
        };
        var T = [301, 302, 303, 307, 308];
        O.redirect = function(p, v) {
          if (T.indexOf(v) === -1)
            throw new RangeError("Invalid status code");
          return new O(null, { status: v, headers: { location: p } });
        }, a.DOMException = o.DOMException;
        try {
          new a.DOMException();
        } catch {
          a.DOMException = function(v, I) {
            this.message = v, this.name = I;
            var M = Error(v);
            this.stack = M.stack;
          }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
        }
        function G(p, v) {
          return new Promise(function(I, M) {
            var Q = new K(p, v);
            if (Q.signal && Q.signal.aborted)
              return M(new a.DOMException("Aborted", "AbortError"));
            var J = new XMLHttpRequest();
            function Ae() {
              J.abort();
            }
            J.onload = function() {
              var me = {
                status: J.status,
                statusText: J.statusText,
                headers: W(J.getAllResponseHeaders() || "")
              };
              me.url = "responseURL" in J ? J.responseURL : me.headers.get("X-Request-URL");
              var Ge = "response" in J ? J.response : J.responseText;
              setTimeout(function() {
                I(new O(Ge, me));
              }, 0);
            }, J.onerror = function() {
              setTimeout(function() {
                M(new TypeError("Network request failed"));
              }, 0);
            }, J.ontimeout = function() {
              setTimeout(function() {
                M(new TypeError("Network request failed"));
              }, 0);
            }, J.onabort = function() {
              setTimeout(function() {
                M(new a.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function Kt(me) {
              try {
                return me === "" && o.location.href ? o.location.href : me;
              } catch {
                return me;
              }
            }
            J.open(Q.method, Kt(Q.url), !0), Q.credentials === "include" ? J.withCredentials = !0 : Q.credentials === "omit" && (J.withCredentials = !1), "responseType" in J && (l.blob ? J.responseType = "blob" : l.arrayBuffer && Q.headers.get("Content-Type") && Q.headers.get("Content-Type").indexOf("application/octet-stream") !== -1 && (J.responseType = "arraybuffer")), v && typeof v.headers == "object" && !(v.headers instanceof _) ? Object.getOwnPropertyNames(v.headers).forEach(function(me) {
              J.setRequestHeader(me, C(v.headers[me]));
            }) : Q.headers.forEach(function(me, Ge) {
              J.setRequestHeader(Ge, me);
            }), Q.signal && (Q.signal.addEventListener("abort", Ae), J.onreadystatechange = function() {
              J.readyState === 4 && Q.signal.removeEventListener("abort", Ae);
            }), J.send(typeof Q._bodyInit > "u" ? null : Q._bodyInit);
          });
        }
        return G.polyfill = !0, o.fetch || (o.fetch = G, o.Headers = _, o.Request = K, o.Response = O), a.Headers = _, a.Request = K, a.Response = O, a.fetch = G, a;
      })({});
    })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
    var s = r.fetch ? r : n;
    e = s.fetch, e.default = s.fetch, e.fetch = s.fetch, e.Headers = s.Headers, e.Request = s.Request, e.Response = s.Response, t.exports = e;
  })(Xt, Xt.exports)), Xt.exports;
}
var Pn;
function _o() {
  return Pn || (Pn = 1, (function(t, e) {
    var r = typeof fetch == "function" ? fetch : void 0;
    if (typeof Et < "u" && Et.fetch ? r = Et.fetch : typeof window < "u" && window.fetch && (r = window.fetch), typeof Co < "u" && typeof window > "u") {
      var n = r || bo();
      n.default && (n = n.default), e.default = n, t.exports = e.default;
    }
  })(Jt, Jt.exports)), Jt.exports;
}
var gs = _o();
const ms = /* @__PURE__ */ Gr(gs), Vn = /* @__PURE__ */ Js({
  __proto__: null,
  default: ms
}, [gs]);
function Mn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function jn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mn(Object(r), !0).forEach(function(n) {
      wo(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Mn(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function wo(t, e, r) {
  return (e = xo(e)) in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function xo(t) {
  var e = So(t, "string");
  return rt(e) == "symbol" ? e : e + "";
}
function So(t, e) {
  if (rt(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (rt(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function rt(t) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rt(t);
}
var ze = typeof fetch == "function" ? fetch : void 0;
typeof global < "u" && global.fetch ? ze = global.fetch : typeof window < "u" && window.fetch && (ze = window.fetch);
var Tt;
ps() && (typeof global < "u" && global.XMLHttpRequest ? Tt = global.XMLHttpRequest : typeof window < "u" && window.XMLHttpRequest && (Tt = window.XMLHttpRequest));
var ar;
typeof ActiveXObject == "function" && (typeof global < "u" && global.ActiveXObject ? ar = global.ActiveXObject : typeof window < "u" && window.ActiveXObject && (ar = window.ActiveXObject));
!ze && Vn && !Tt && !ar && (ze = ms || Vn);
typeof ze != "function" && (ze = void 0);
var Ur = function(e, r) {
  if (r && rt(r) === "object") {
    var n = "";
    for (var s in r)
      n += "&" + encodeURIComponent(s) + "=" + encodeURIComponent(r[s]);
    if (!n) return e;
    e = e + (e.indexOf("?") !== -1 ? "&" : "?") + n.slice(1);
  }
  return e;
}, Fn = function(e, r, n, s) {
  var i = function(l) {
    if (!l.ok) return n(l.statusText || "Error", {
      status: l.status
    });
    l.text().then(function(c) {
      n(null, {
        status: l.status,
        data: c
      });
    }).catch(n);
  };
  if (s) {
    var a = s(e, r);
    if (a instanceof Promise) {
      a.then(i).catch(n);
      return;
    }
  }
  typeof fetch == "function" ? fetch(e, r).then(i).catch(n) : ze(e, r).then(i).catch(n);
}, In = !1, Eo = function(e, r, n, s) {
  e.queryStringParams && (r = Ur(r, e.queryStringParams));
  var i = jn({}, typeof e.customHeaders == "function" ? e.customHeaders() : e.customHeaders);
  typeof window > "u" && typeof global < "u" && typeof global.process < "u" && global.process.versions && global.process.versions.node && (i["User-Agent"] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")")), n && (i["Content-Type"] = "application/json");
  var a = typeof e.requestOptions == "function" ? e.requestOptions(n) : e.requestOptions, o = jn({
    method: n ? "POST" : "GET",
    body: n ? e.stringify(n) : void 0,
    headers: i
  }, In ? {} : a), l = typeof e.alternateFetch == "function" && e.alternateFetch.length >= 1 ? e.alternateFetch : void 0;
  try {
    Fn(r, o, s, l);
  } catch (c) {
    if (!a || Object.keys(a).length === 0 || !c.message || c.message.indexOf("not implemented") < 0)
      return s(c);
    try {
      Object.keys(a).forEach(function(u) {
        delete o[u];
      }), Fn(r, o, s, l), In = !0;
    } catch (u) {
      s(u);
    }
  }
}, Lo = function(e, r, n, s) {
  n && rt(n) === "object" && (n = Ur("", n).slice(1)), e.queryStringParams && (r = Ur(r, e.queryStringParams));
  try {
    var i;
    Tt ? i = new Tt() : i = new ar("MSXML2.XMLHTTP.3.0"), i.open(n ? "POST" : "GET", r, 1), e.crossDomain || i.setRequestHeader("X-Requested-With", "XMLHttpRequest"), i.withCredentials = !!e.withCredentials, n && i.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), i.overrideMimeType && i.overrideMimeType("application/json");
    var a = e.customHeaders;
    if (a = typeof a == "function" ? a() : a, a)
      for (var o in a)
        i.setRequestHeader(o, a[o]);
    i.onreadystatechange = function() {
      i.readyState > 3 && s(i.status >= 400 ? i.statusText : null, {
        status: i.status,
        data: i.responseText
      });
    }, i.send(n);
  } catch (l) {
    console && console.log(l);
  }
}, ko = function(e, r, n, s) {
  if (typeof n == "function" && (s = n, n = void 0), s = s || function() {
  }, ze && r.indexOf("file:") !== 0)
    return Eo(e, r, n, s);
  if (ps() || typeof ActiveXObject == "function")
    return Lo(e, r, n, s);
  s(new Error("No fetch and no xhr implementation found!"));
};
function gt(t) {
  "@babel/helpers - typeof";
  return gt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, gt(t);
}
function Zn(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Zn(Object(r), !0).forEach(function(n) {
      ys(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Zn(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Oo(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Ao(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, vs(n.key), n);
  }
}
function To(t, e, r) {
  return e && Ao(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function ys(t, e, r) {
  return (e = vs(e)) in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function vs(t) {
  var e = Ro(t, "string");
  return gt(e) == "symbol" ? e : e + "";
}
function Ro(t, e) {
  if (gt(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (gt(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var No = function() {
  return {
    loadPath: "/locales/{{lng}}/{{ns}}.json",
    addPath: "/locales/add/{{lng}}/{{ns}}",
    parse: function(r) {
      return JSON.parse(r);
    },
    stringify: JSON.stringify,
    parsePayload: function(r, n, s) {
      return ys({}, n, s || "");
    },
    parseLoadPayload: function(r, n) {
    },
    request: ko,
    reloadInterval: typeof window < "u" ? !1 : 3600 * 1e3,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: !1,
    withCredentials: !1,
    overrideMimeType: !1,
    requestOptions: {
      mode: "cors",
      credentials: "same-origin",
      cache: "default"
    }
  };
}, Cs = (function() {
  function t(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    Oo(this, t), this.services = e, this.options = r, this.allOptions = n, this.type = "backend", this.init(e, r, n);
  }
  return To(t, [{
    key: "init",
    value: function(r) {
      var n = this, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (this.services = r, this.options = Vr(Vr(Vr({}, No()), this.options || {}), s), this.allOptions = i, this.services && this.options.reloadInterval) {
        var a = setInterval(function() {
          return n.reload();
        }, this.options.reloadInterval);
        gt(a) === "object" && typeof a.unref == "function" && a.unref();
      }
    }
  }, {
    key: "readMulti",
    value: function(r, n, s) {
      this._readAny(r, r, n, n, s);
    }
  }, {
    key: "read",
    value: function(r, n, s) {
      this._readAny([r], r, [n], n, s);
    }
  }, {
    key: "_readAny",
    value: function(r, n, s, i, a) {
      var o = this, l = this.options.loadPath;
      typeof this.options.loadPath == "function" && (l = this.options.loadPath(r, s)), l = vo(l), l.then(function(c) {
        if (!c) return a(null, {});
        var u = o.services.interpolator.interpolate(c, {
          lng: r.join("+"),
          ns: s.join("+")
        });
        o.loadUrl(u, a, n, i);
      });
    }
  }, {
    key: "loadUrl",
    value: function(r, n, s, i) {
      var a = this, o = typeof s == "string" ? [s] : s, l = typeof i == "string" ? [i] : i, c = this.options.parseLoadPayload(o, l);
      this.options.request(this.options, r, c, function(u, h) {
        if (h && (h.status >= 500 && h.status < 600 || !h.status)) return n("failed loading " + r + "; status code: " + h.status, !0);
        if (h && h.status >= 400 && h.status < 500) return n("failed loading " + r + "; status code: " + h.status, !1);
        if (!h && u && u.message) {
          var f = u.message.toLowerCase(), C = ["failed", "fetch", "network", "load"].find(function(E) {
            return f.indexOf(E) > -1;
          });
          if (C)
            return n("failed loading " + r + ": " + u.message, !0);
        }
        if (u) return n(u, !1);
        var w, _;
        try {
          typeof h.data == "string" ? w = a.options.parse(h.data, s, i) : w = h.data;
        } catch {
          _ = "failed parsing " + r + " to json";
        }
        if (_) return n(_, !1);
        n(null, w);
      });
    }
  }, {
    key: "create",
    value: function(r, n, s, i, a) {
      var o = this;
      if (this.options.addPath) {
        typeof r == "string" && (r = [r]);
        var l = this.options.parsePayload(n, s, i), c = 0, u = [], h = [];
        r.forEach(function(f) {
          var C = o.options.addPath;
          typeof o.options.addPath == "function" && (C = o.options.addPath(f, n));
          var w = o.services.interpolator.interpolate(C, {
            lng: f,
            ns: n
          });
          o.options.request(o.options, w, l, function(_, E) {
            c += 1, u.push(_), h.push(E), c === r.length && typeof a == "function" && a(u, h);
          });
        });
      }
    }
  }, {
    key: "reload",
    value: function() {
      var r = this, n = this.services, s = n.backendConnector, i = n.languageUtils, a = n.logger, o = s.language;
      if (!(o && o.toLowerCase() === "cimode")) {
        var l = [], c = function(h) {
          var f = i.toResolveHierarchy(h);
          f.forEach(function(C) {
            l.indexOf(C) < 0 && l.push(C);
          });
        };
        c(o), this.allOptions.preload && this.allOptions.preload.forEach(function(u) {
          return c(u);
        }), l.forEach(function(u) {
          r.allOptions.ns.forEach(function(h) {
            s.read(u, h, "read", null, null, function(f, C) {
              f && a.warn("loading namespace ".concat(h, " for language ").concat(u, " failed"), f), !f && C && a.log("loaded namespace ".concat(h, " for language ").concat(u), C), s.loaded("".concat(u, "|").concat(h), f, C);
            });
          });
        });
      }
    }
  }]);
})();
Cs.type = "backend";
const Po = { next: "Next", cancel: "Cancel", delete: "Delete", ok: "OK", close: "Close" }, Vo = { delete: { confirmation: { title: "Delete Product", message: "Are you sure you want to delete entity? This action cannot be undone." }, deleting: { title: "Deleting product", message: "Please wait..." }, conflict: { title: "Product in use", message: "This product is used in composite products and will be removed from them.", deleteAnyway: "Delete anyway" }, success: { title: "Product deleted successfully", message: "The product has been deleted." }, error: { title: "Deletion error" } } }, Mo = { msgActionUnavailable: "Action unavailable" }, jo = { field: { required: "Required" }, validation: { required: "This field is required", is_email: "Invalid email" }, "request-quote": { title: { contactDetails: "Contact details" }, submitButton: "Send", pending: { title: "Sending request", text: "Please wait" }, success: { title: "Sent", text: `Request was successfully sent. 
We will contact you soon.` }, error: { title: "Sending error", text: "An unexpected error has occurred, please try requesting later." }, "accept-conditions": { validation: "Please, read and accept privacy policy.", text: "I accept <1>privacy policy</1>" }, label: { firstName: "First name", lastName: "Last name", fullName: "Full name", companyName: "Company name", email: "Email", phone: "Phone", country: "Country", city: "City", street: "Street", buildingNumber: "House No.", zipCode: "ZIP code", notes: "Comments" } } }, Fo = {
  buttons: Po,
  modals: Vo,
  messages: Mo,
  form: jo
}, Io = { next: "Nächste" }, Zo = { field: { required: "Erforderlich" }, validation: { required: "Dieses Feld ist erforderlich", is_email: "Ungültige E-Mail" }, "request-quote": { title: { contactDetails: "Kontaktdetails" }, submitButton: "Senden", pending: { title: "Anfrage senden", text: "Bitte warten" }, success: { title: "Gesendet", text: `Anfrage wurde erfolgreich gesendet. 
Wir werden Sie bald kontaktieren.` }, error: { title: "Fehler beim Senden", text: "Ein unerwarteter Fehler ist aufgetreten, bitte versuchen Sie es später." }, "accept-conditions": { validation: "Bitte lesen und akzeptieren Sie die Datenschutzbestimmungen.", text: "Ich akzeptiere <1>Datenschutzbestimmungen</1>" }, label: { firstName: "Vorname", lastName: "Nachname", fullName: "Vollständiger Name", companyName: "Unternehmen", email: "E-Mail", phone: "Telefon", country: "Land", city: "Stadt", street: "Straße", buildingNumber: "Hausnummer", zipCode: "Postleitzahl", notes: "Kommentare" } } }, $o = {
  buttons: Io,
  form: Zo
}, Do = "locale";
fe.use(Aa).use(Cs).init({
  lng: localStorage.getItem(Do) || "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  },
  ns: ["translation"],
  resources: {
    en: {
      translation: {
        ...Fo
      }
    },
    de: {
      translation: {
        ...$o
      }
    }
  }
});
const Bo = fe, Cr = (t) => Ut((e, r) => /* @__PURE__ */ re(Pa, { i18n: Bo, children: /* @__PURE__ */ re(t, { ...e, ref: r }) })), Ho = "_errors_sgqqp_1", Uo = {
  errors: Ho
}, qo = ({
  className: t,
  error: e
}) => {
  const { t: r } = yr();
  return /* @__PURE__ */ re("div", { className: de(Uo.errors, t), children: /* @__PURE__ */ re(pt, { variant: "paragraph-sm", component: "span", color: "inherit", children: (e == null ? void 0 : e.message) && r(e.message) }) });
}, en = Cr(qo), zo = "_label_dpa61_1", Ko = "_svg_dpa61_6", Wo = "_field_dpa61_12", Jo = "_svgWrapper_dpa61_18", Xo = "_tick_dpa61_38", Go = "_input_dpa61_44", Yo = "_error_dpa61_68", Ye = {
  label: zo,
  svg: Ko,
  field: Wo,
  svgWrapper: Jo,
  tick: Xo,
  input: Go,
  error: Yo
}, Qo = Ut(
  ({ error: t, noErrorPlaceholder: e, label: r, className: n, ...s }, i) => {
    const a = t || !e;
    return /* @__PURE__ */ xe("div", { className: n, children: [
      /* @__PURE__ */ re("label", { className: Ye.label, children: /* @__PURE__ */ xe("div", { className: Ye.field, children: [
        /* @__PURE__ */ re(
          "input",
          {
            ref: i,
            ...s,
            "data-invalid": !!(t != null && t.message),
            "data-visually-hidden": !0,
            className: Ye.input,
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ re("div", { className: Ye.svgWrapper, children: /* @__PURE__ */ re("svg", { className: Ye.svg, viewBox: "0 0 16 16", children: /* @__PURE__ */ re(
          "polyline",
          {
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            stroke: "white",
            strokeWidth: "2",
            points: "5 8 7 10 11 6",
            strokeDasharray: "10",
            className: Ye.tick
          }
        ) }) }),
        r
      ] }) }),
      a && /* @__PURE__ */ re(en, { className: Ye.error, error: t })
    ] });
  }
), e1 = "_label_pqe4y_1", t1 = "_input_pqe4y_8", r1 = "_invalid_pqe4y_43", qe = {
  label: e1,
  input: t1,
  invalid: r1
}, n1 = Ut(function({ label: e, withValidation: r, required: n, error: s, disabled: i, className: a, type: o = "text", requiredLabel: l, ...c }, u) {
  const { t: h } = yr("translation"), f = ns();
  return /* @__PURE__ */ xe("div", { className: de(qe.container, a), children: [
    e && /* @__PURE__ */ xe("label", { htmlFor: f, className: qe.label, children: [
      /* @__PURE__ */ re(pt, { variant: "paragraph-sm", color: i ? "disabled" : "description", component: "span", children: e }),
      n && /* @__PURE__ */ xe(pt, { variant: "paragraph-sm", component: "span", color: "disabled", children: [
        "(",
        l ?? h("form.field.required"),
        ")"
      ] })
    ] }),
    /* @__PURE__ */ re(
      "input",
      {
        ...c,
        ref: u,
        id: f,
        disabled: i,
        className: de(qe.input, { [qe.invalid]: !!s }),
        type: o
      }
    ),
    r && /* @__PURE__ */ re(en, { error: s })
  ] });
}), s1 = Cr(n1), i1 = Ut(function({ label: e, withValidation: r, required: n, error: s, disabled: i, className: a, rows: o = 4, requiredLabel: l, ...c }, u) {
  const { t: h } = yr("translation"), f = ns();
  return /* @__PURE__ */ xe("div", { className: de(qe.container, a), children: [
    e && /* @__PURE__ */ xe("label", { htmlFor: f, className: qe.label, children: [
      /* @__PURE__ */ re(pt, { variant: "paragraph-sm", color: i ? "disabled" : "description", component: "span", children: e }),
      n && /* @__PURE__ */ xe(pt, { variant: "paragraph-sm", component: "span", color: "disabled", children: [
        "(",
        l ?? h("form.field.required"),
        ")"
      ] })
    ] }),
    /* @__PURE__ */ re(
      "textarea",
      {
        ...c,
        rows: o,
        ref: u,
        id: f,
        disabled: i,
        className: de(qe.input, { [qe.invalid]: !!s })
      }
    ),
    r && /* @__PURE__ */ re(en, { error: s })
  ] });
}), a1 = Cr(i1);
var qt = (t) => t.type === "checkbox", Qe = (t) => t instanceof Date, pe = (t) => t == null;
const bs = (t) => typeof t == "object";
var ae = (t) => !pe(t) && !Array.isArray(t) && bs(t) && !Qe(t), o1 = (t) => ae(t) && t.target ? qt(t.target) ? t.target.checked : t.target.value : t, l1 = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, c1 = (t, e) => t.has(l1(e)), u1 = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return ae(e) && e.hasOwnProperty("isPrototypeOf");
}, tn = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function _e(t) {
  let e;
  const r = Array.isArray(t), n = typeof FileList < "u" ? t instanceof FileList : !1;
  if (t instanceof Date)
    e = new Date(t);
  else if (t instanceof Set)
    e = new Set(t);
  else if (!(tn && (t instanceof Blob || n)) && (r || ae(t)))
    if (e = r ? [] : {}, !r && !u1(t))
      e = t;
    else
      for (const s in t)
        t.hasOwnProperty(s) && (e[s] = _e(t[s]));
  else
    return t;
  return e;
}
var br = (t) => Array.isArray(t) ? t.filter(Boolean) : [], oe = (t) => t === void 0, P = (t, e, r) => {
  if (!e || !ae(t))
    return r;
  const n = br(e.split(/[,[\].]+?/)).reduce((s, i) => pe(s) ? s : s[i], t);
  return oe(n) || n === t ? oe(t[e]) ? r : t[e] : n;
}, Te = (t) => typeof t == "boolean", rn = (t) => /^\w*$/.test(t), _s = (t) => br(t.replace(/["|']|\]/g, "").split(/\.|\[/)), se = (t, e, r) => {
  let n = -1;
  const s = rn(e) ? [e] : _s(e), i = s.length, a = i - 1;
  for (; ++n < i; ) {
    const o = s[n];
    let l = r;
    if (n !== a) {
      const c = t[o];
      l = ae(c) || Array.isArray(c) ? c : isNaN(+s[n + 1]) ? {} : [];
    }
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    t[o] = l, t = t[o];
  }
  return t;
};
const $n = {
  BLUR: "blur",
  FOCUS_OUT: "focusout"
}, Ee = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Fe = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
};
we.createContext(null);
var d1 = (t, e, r, n = !0) => {
  const s = {
    defaultValues: e._defaultValues
  };
  for (const i in t)
    Object.defineProperty(s, i, {
      get: () => {
        const a = i;
        return e._proxyFormState[a] !== Ee.all && (e._proxyFormState[a] = !n || Ee.all), t[a];
      }
    });
  return s;
}, ve = (t) => ae(t) && !Object.keys(t).length, f1 = (t, e, r, n) => {
  r(t);
  const { name: s, ...i } = t;
  return ve(i) || Object.keys(i).length >= Object.keys(e).length || Object.keys(i).find((a) => e[a] === Ee.all);
}, Qt = (t) => Array.isArray(t) ? t : [t];
function h1(t) {
  const e = we.useRef(t);
  e.current = t, we.useEffect(() => {
    const r = !t.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [t.disabled]);
}
var Pe = (t) => typeof t == "string", p1 = (t, e, r, n, s) => Pe(t) ? (n && e.watch.add(t), P(r, t, s)) : Array.isArray(t) ? t.map((i) => (n && e.watch.add(i), P(r, i))) : (n && (e.watchAll = !0), r), ws = (t, e, r, n, s) => e ? {
  ...r[t],
  types: {
    ...r[t] && r[t].types ? r[t].types : {},
    [n]: s || !0
  }
} : {}, Dn = (t) => ({
  isOnSubmit: !t || t === Ee.onSubmit,
  isOnBlur: t === Ee.onBlur,
  isOnChange: t === Ee.onChange,
  isOnAll: t === Ee.all,
  isOnTouch: t === Ee.onTouched
}), Bn = (t, e, r) => !r && (e.watchAll || e.watch.has(t) || [...e.watch].some((n) => t.startsWith(n) && /^\.\w+/.test(t.slice(n.length))));
const kt = (t, e, r, n) => {
  for (const s of r || Object.keys(t)) {
    const i = P(t, s);
    if (i) {
      const { _f: a, ...o } = i;
      if (a) {
        if (a.refs && a.refs[0] && e(a.refs[0], s) && !n)
          return !0;
        if (a.ref && e(a.ref, a.name) && !n)
          return !0;
        if (kt(o, e))
          break;
      } else if (ae(o) && kt(o, e))
        break;
    }
  }
};
var g1 = (t, e, r) => {
  const n = Qt(P(t, r));
  return se(n, "root", e[r]), se(t, r, n), t;
}, nn = (t) => t.type === "file", Re = (t) => typeof t == "function", or = (t) => {
  if (!tn)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, er = (t) => Pe(t), sn = (t) => t.type === "radio", lr = (t) => t instanceof RegExp;
const Hn = {
  value: !1,
  isValid: !1
}, Un = { value: !0, isValid: !0 };
var xs = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !oe(t[0].attributes.value) ? oe(t[0].value) || t[0].value === "" ? Un : { value: t[0].value, isValid: !0 } : Un
    ) : Hn;
  }
  return Hn;
};
const qn = {
  isValid: !1,
  value: null
};
var Ss = (t) => Array.isArray(t) ? t.reduce((e, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : e, qn) : qn;
function zn(t, e, r = "validate") {
  if (er(t) || Array.isArray(t) && t.every(er) || Te(t) && !t)
    return {
      type: r,
      message: er(t) ? t : "",
      ref: e
    };
}
var lt = (t) => ae(t) && !lr(t) ? t : {
  value: t,
  message: ""
}, Kn = async (t, e, r, n, s, i) => {
  const { ref: a, refs: o, required: l, maxLength: c, minLength: u, min: h, max: f, pattern: C, validate: w, name: _, valueAsNumber: E, mount: j } = t._f, x = P(r, _);
  if (!j || e.has(_))
    return {};
  const Z = o ? o[0] : a, V = (O) => {
    s && Z.reportValidity && (Z.setCustomValidity(Te(O) ? "" : O || ""), Z.reportValidity());
  }, $ = {}, D = sn(a), A = qt(a), q = D || A, K = (E || nn(a)) && oe(a.value) && oe(x) || or(a) && a.value === "" || x === "" || Array.isArray(x) && !x.length, te = ws.bind(null, _, n, $), W = (O, T, G, p = Fe.maxLength, v = Fe.minLength) => {
    const I = O ? T : G;
    $[_] = {
      type: O ? p : v,
      message: I,
      ref: a,
      ...te(O ? p : v, I)
    };
  };
  if (i ? !Array.isArray(x) || !x.length : l && (!q && (K || pe(x)) || Te(x) && !x || A && !xs(o).isValid || D && !Ss(o).isValid)) {
    const { value: O, message: T } = er(l) ? { value: !!l, message: l } : lt(l);
    if (O && ($[_] = {
      type: Fe.required,
      message: T,
      ref: Z,
      ...te(Fe.required, T)
    }, !n))
      return V(T), $;
  }
  if (!K && (!pe(h) || !pe(f))) {
    let O, T;
    const G = lt(f), p = lt(h);
    if (!pe(x) && !isNaN(x)) {
      const v = a.valueAsNumber || x && +x;
      pe(G.value) || (O = v > G.value), pe(p.value) || (T = v < p.value);
    } else {
      const v = a.valueAsDate || new Date(x), I = (J) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + J), M = a.type == "time", Q = a.type == "week";
      Pe(G.value) && x && (O = M ? I(x) > I(G.value) : Q ? x > G.value : v > new Date(G.value)), Pe(p.value) && x && (T = M ? I(x) < I(p.value) : Q ? x < p.value : v < new Date(p.value));
    }
    if ((O || T) && (W(!!O, G.message, p.message, Fe.max, Fe.min), !n))
      return V($[_].message), $;
  }
  if ((c || u) && !K && (Pe(x) || i && Array.isArray(x))) {
    const O = lt(c), T = lt(u), G = !pe(O.value) && x.length > +O.value, p = !pe(T.value) && x.length < +T.value;
    if ((G || p) && (W(G, O.message, T.message), !n))
      return V($[_].message), $;
  }
  if (C && !K && Pe(x)) {
    const { value: O, message: T } = lt(C);
    if (lr(O) && !x.match(O) && ($[_] = {
      type: Fe.pattern,
      message: T,
      ref: a,
      ...te(Fe.pattern, T)
    }, !n))
      return V(T), $;
  }
  if (w) {
    if (Re(w)) {
      const O = await w(x, r), T = zn(O, Z);
      if (T && ($[_] = {
        ...T,
        ...te(Fe.validate, T.message)
      }, !n))
        return V(T.message), $;
    } else if (ae(w)) {
      let O = {};
      for (const T in w) {
        if (!ve(O) && !n)
          break;
        const G = zn(await w[T](x, r), Z, T);
        G && (O = {
          ...G,
          ...te(T, G.message)
        }, V(G.message), n && ($[_] = O));
      }
      if (!ve(O) && ($[_] = {
        ref: Z,
        ...O
      }, !n))
        return $;
    }
  }
  return V(!0), $;
};
function m1(t, e) {
  const r = e.slice(0, -1).length;
  let n = 0;
  for (; n < r; )
    t = oe(t) ? n++ : t[e[n++]];
  return t;
}
function y1(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !oe(t[e]))
      return !1;
  return !0;
}
function le(t, e) {
  const r = Array.isArray(e) ? e : rn(e) ? [e] : _s(e), n = r.length === 1 ? t : m1(t, r), s = r.length - 1, i = r[s];
  return n && delete n[i], s !== 0 && (ae(n) && ve(n) || Array.isArray(n) && y1(n)) && le(t, r.slice(0, -1)), t;
}
var Mr = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (s) => {
      for (const i of t)
        i.next && i.next(s);
    },
    subscribe: (s) => (t.push(s), {
      unsubscribe: () => {
        t = t.filter((i) => i !== s);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, qr = (t) => pe(t) || !bs(t);
function He(t, e) {
  if (qr(t) || qr(e))
    return t === e;
  if (Qe(t) && Qe(e))
    return t.getTime() === e.getTime();
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length)
    return !1;
  for (const s of r) {
    const i = t[s];
    if (!n.includes(s))
      return !1;
    if (s !== "ref") {
      const a = e[s];
      if (Qe(i) && Qe(a) || ae(i) && ae(a) || Array.isArray(i) && Array.isArray(a) ? !He(i, a) : i !== a)
        return !1;
    }
  }
  return !0;
}
var Es = (t) => t.type === "select-multiple", v1 = (t) => sn(t) || qt(t), jr = (t) => or(t) && t.isConnected, Ls = (t) => {
  for (const e in t)
    if (Re(t[e]))
      return !0;
  return !1;
};
function cr(t, e = {}) {
  const r = Array.isArray(t);
  if (ae(t) || r)
    for (const n in t)
      Array.isArray(t[n]) || ae(t[n]) && !Ls(t[n]) ? (e[n] = Array.isArray(t[n]) ? [] : {}, cr(t[n], e[n])) : pe(t[n]) || (e[n] = !0);
  return e;
}
function ks(t, e, r) {
  const n = Array.isArray(t);
  if (ae(t) || n)
    for (const s in t)
      Array.isArray(t[s]) || ae(t[s]) && !Ls(t[s]) ? oe(e) || qr(r[s]) ? r[s] = Array.isArray(t[s]) ? cr(t[s], []) : { ...cr(t[s]) } : ks(t[s], pe(e) ? {} : e[s], r[s]) : r[s] = !He(t[s], e[s]);
  return r;
}
var _t = (t, e) => ks(t, e, cr(e)), Os = (t, { valueAsNumber: e, valueAsDate: r, setValueAs: n }) => oe(t) ? t : e ? t === "" ? NaN : t && +t : r && Pe(t) ? new Date(t) : n ? n(t) : t;
function Fr(t) {
  const e = t.ref;
  return nn(e) ? e.files : sn(e) ? Ss(t.refs).value : Es(e) ? [...e.selectedOptions].map(({ value: r }) => r) : qt(e) ? xs(t.refs).value : Os(oe(e.value) ? t.ref.value : e.value, t);
}
var C1 = (t, e, r, n) => {
  const s = {};
  for (const i of t) {
    const a = P(e, i);
    a && se(s, i, a._f);
  }
  return {
    criteriaMode: r,
    names: [...t],
    fields: s,
    shouldUseNativeValidation: n
  };
}, wt = (t) => oe(t) ? t : lr(t) ? t.source : ae(t) ? lr(t.value) ? t.value.source : t.value : t;
const Wn = "AsyncFunction";
var b1 = (t) => !!t && !!t.validate && !!(Re(t.validate) && t.validate.constructor.name === Wn || ae(t.validate) && Object.values(t.validate).find((e) => e.constructor.name === Wn)), _1 = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate);
function Jn(t, e, r) {
  const n = P(t, r);
  if (n || rn(r))
    return {
      error: n,
      name: r
    };
  const s = r.split(".");
  for (; s.length; ) {
    const i = s.join("."), a = P(e, i), o = P(t, i);
    if (a && !Array.isArray(a) && r !== i)
      return { name: r };
    if (o && o.type)
      return {
        name: i,
        error: o
      };
    s.pop();
  }
  return {
    name: r
  };
}
var w1 = (t, e, r, n, s) => s.isOnAll ? !1 : !r && s.isOnTouch ? !(e || t) : (r ? n.isOnBlur : s.isOnBlur) ? !t : (r ? n.isOnChange : s.isOnChange) ? t : !0, x1 = (t, e) => !br(P(t, e)).length && le(t, e);
const S1 = {
  mode: Ee.onSubmit,
  reValidateMode: Ee.onChange,
  shouldFocusError: !0
};
function E1(t = {}) {
  let e = {
    ...S1,
    ...t
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Re(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, n = {}, s = ae(e.defaultValues) || ae(e.values) ? _e(e.defaultValues || e.values) || {} : {}, i = e.shouldUnregister ? {} : _e(s), a = {
    action: !1,
    mount: !1,
    watch: !1
  }, o = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, h = {
    values: Mr(),
    array: Mr(),
    state: Mr()
  }, f = Dn(e.mode), C = Dn(e.reValidateMode), w = e.criteriaMode === Ee.all, _ = (d) => (m) => {
    clearTimeout(c), c = setTimeout(d, m);
  }, E = async (d) => {
    if (!e.disabled && (u.isValid || d)) {
      const m = e.resolver ? ve((await q()).errors) : await te(n, !0);
      m !== r.isValid && h.state.next({
        isValid: m
      });
    }
  }, j = (d, m) => {
    !e.disabled && (u.isValidating || u.validatingFields) && ((d || Array.from(o.mount)).forEach((y) => {
      y && (m ? se(r.validatingFields, y, m) : le(r.validatingFields, y));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !ve(r.validatingFields)
    }));
  }, x = (d, m = [], y, R, L = !0, S = !0) => {
    if (R && y && !e.disabled) {
      if (a.action = !0, S && Array.isArray(P(n, d))) {
        const B = y(P(n, d), R.argA, R.argB);
        L && se(n, d, B);
      }
      if (S && Array.isArray(P(r.errors, d))) {
        const B = y(P(r.errors, d), R.argA, R.argB);
        L && se(r.errors, d, B), x1(r.errors, d);
      }
      if (u.touchedFields && S && Array.isArray(P(r.touchedFields, d))) {
        const B = y(P(r.touchedFields, d), R.argA, R.argB);
        L && se(r.touchedFields, d, B);
      }
      u.dirtyFields && (r.dirtyFields = _t(s, i)), h.state.next({
        name: d,
        isDirty: O(d, m),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      se(i, d, m);
  }, Z = (d, m) => {
    se(r.errors, d, m), h.state.next({
      errors: r.errors
    });
  }, V = (d) => {
    r.errors = d, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, $ = (d, m, y, R) => {
    const L = P(n, d);
    if (L) {
      const S = P(i, d, oe(y) ? P(s, d) : y);
      oe(S) || R && R.defaultChecked || m ? se(i, d, m ? S : Fr(L._f)) : p(d, S), a.mount && E();
    }
  }, D = (d, m, y, R, L) => {
    let S = !1, B = !1;
    const ee = {
      name: d
    };
    if (!e.disabled) {
      const ce = !!(P(n, d) && P(n, d)._f && P(n, d)._f.disabled);
      if (!y || R) {
        u.isDirty && (B = r.isDirty, r.isDirty = ee.isDirty = O(), S = B !== ee.isDirty);
        const ue = ce || He(P(s, d), m);
        B = !!(!ce && P(r.dirtyFields, d)), ue || ce ? le(r.dirtyFields, d) : se(r.dirtyFields, d, !0), ee.dirtyFields = r.dirtyFields, S = S || u.dirtyFields && B !== !ue;
      }
      if (y) {
        const ue = P(r.touchedFields, d);
        ue || (se(r.touchedFields, d, y), ee.touchedFields = r.touchedFields, S = S || u.touchedFields && ue !== y);
      }
      S && L && h.state.next(ee);
    }
    return S ? ee : {};
  }, A = (d, m, y, R) => {
    const L = P(r.errors, d), S = u.isValid && Te(m) && r.isValid !== m;
    if (e.delayError && y ? (l = _(() => Z(d, y)), l(e.delayError)) : (clearTimeout(c), l = null, y ? se(r.errors, d, y) : le(r.errors, d)), (y ? !He(L, y) : L) || !ve(R) || S) {
      const B = {
        ...R,
        ...S && Te(m) ? { isValid: m } : {},
        errors: r.errors,
        name: d
      };
      r = {
        ...r,
        ...B
      }, h.state.next(B);
    }
  }, q = async (d) => {
    j(d, !0);
    const m = await e.resolver(i, e.context, C1(d || o.mount, n, e.criteriaMode, e.shouldUseNativeValidation));
    return j(d), m;
  }, K = async (d) => {
    const { errors: m } = await q(d);
    if (d)
      for (const y of d) {
        const R = P(m, y);
        R ? se(r.errors, y, R) : le(r.errors, y);
      }
    else
      r.errors = m;
    return m;
  }, te = async (d, m, y = {
    valid: !0
  }) => {
    for (const R in d) {
      const L = d[R];
      if (L) {
        const { _f: S, ...B } = L;
        if (S) {
          const ee = o.array.has(S.name), ce = L._f && b1(L._f);
          ce && u.validatingFields && j([R], !0);
          const ue = await Kn(L, o.disabled, i, w, e.shouldUseNativeValidation && !m, ee);
          if (ce && u.validatingFields && j([R]), ue[S.name] && (y.valid = !1, m))
            break;
          !m && (P(ue, S.name) ? ee ? g1(r.errors, ue, S.name) : se(r.errors, S.name, ue[S.name]) : le(r.errors, S.name));
        }
        !ve(B) && await te(B, m, y);
      }
    }
    return y.valid;
  }, W = () => {
    for (const d of o.unMount) {
      const m = P(n, d);
      m && (m._f.refs ? m._f.refs.every((y) => !jr(y)) : !jr(m._f.ref)) && wr(d);
    }
    o.unMount = /* @__PURE__ */ new Set();
  }, O = (d, m) => !e.disabled && (d && m && se(i, d, m), !He(Ae(), s)), T = (d, m, y) => p1(d, o, {
    ...a.mount ? i : oe(m) ? s : Pe(d) ? { [d]: m } : m
  }, y, m), G = (d) => br(P(a.mount ? i : s, d, e.shouldUnregister ? P(s, d, []) : [])), p = (d, m, y = {}) => {
    const R = P(n, d);
    let L = m;
    if (R) {
      const S = R._f;
      S && (!S.disabled && se(i, d, Os(m, S)), L = or(S.ref) && pe(m) ? "" : m, Es(S.ref) ? [...S.ref.options].forEach((B) => B.selected = L.includes(B.value)) : S.refs ? qt(S.ref) ? S.refs.length > 1 ? S.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(L) ? !!L.find((ee) => ee === B.value) : L === B.value)) : S.refs[0] && (S.refs[0].checked = !!L) : S.refs.forEach((B) => B.checked = B.value === L) : nn(S.ref) ? S.ref.value = "" : (S.ref.value = L, S.ref.type || h.values.next({
        name: d,
        values: { ...i }
      })));
    }
    (y.shouldDirty || y.shouldTouch) && D(d, L, y.shouldTouch, y.shouldDirty, !0), y.shouldValidate && J(d);
  }, v = (d, m, y) => {
    for (const R in m) {
      const L = m[R], S = `${d}.${R}`, B = P(n, S);
      (o.array.has(d) || ae(L) || B && !B._f) && !Qe(L) ? v(S, L, y) : p(S, L, y);
    }
  }, I = (d, m, y = {}) => {
    const R = P(n, d), L = o.array.has(d), S = _e(m);
    se(i, d, S), L ? (h.array.next({
      name: d,
      values: { ...i }
    }), (u.isDirty || u.dirtyFields) && y.shouldDirty && h.state.next({
      name: d,
      dirtyFields: _t(s, i),
      isDirty: O(d, S)
    })) : R && !R._f && !pe(S) ? v(d, S, y) : p(d, S, y), Bn(d, o) && h.state.next({ ...r }), h.values.next({
      name: a.mount ? d : void 0,
      values: { ...i }
    });
  }, M = async (d) => {
    a.mount = !0;
    const m = d.target;
    let y = m.name, R = !0;
    const L = P(n, y), S = () => m.type ? Fr(L._f) : o1(d), B = (ee) => {
      R = Number.isNaN(ee) || Qe(ee) && isNaN(ee.getTime()) || He(ee, P(i, y, ee));
    };
    if (L) {
      let ee, ce;
      const ue = S(), Be = d.type === $n.BLUR || d.type === $n.FOCUS_OUT, Hs = !_1(L._f) && !e.resolver && !P(r.errors, y) && !L._f.deps || w1(Be, P(r.touchedFields, y), r.isSubmitted, C, f), Sr = Bn(y, o, Be);
      se(i, y, ue), Be ? (L._f.onBlur && L._f.onBlur(d), l && l(0)) : L._f.onChange && L._f.onChange(d);
      const Er = D(y, ue, Be, !1), Us = !ve(Er) || Sr;
      if (!Be && h.values.next({
        name: y,
        type: d.type,
        values: { ...i }
      }), Hs)
        return u.isValid && (e.mode === "onBlur" && Be ? E() : Be || E()), Us && h.state.next({ name: y, ...Sr ? {} : Er });
      if (!Be && Sr && h.state.next({ ...r }), e.resolver) {
        const { errors: fn } = await q([y]);
        if (B(ue), R) {
          const qs = Jn(r.errors, n, y), hn = Jn(fn, n, qs.name || y);
          ee = hn.error, y = hn.name, ce = ve(fn);
        }
      } else
        j([y], !0), ee = (await Kn(L, o.disabled, i, w, e.shouldUseNativeValidation))[y], j([y]), B(ue), R && (ee ? ce = !1 : u.isValid && (ce = await te(n, !0)));
      R && (L._f.deps && J(L._f.deps), A(y, ce, ee, Er));
    }
  }, Q = (d, m) => {
    if (P(r.errors, m) && d.focus)
      return d.focus(), 1;
  }, J = async (d, m = {}) => {
    let y, R;
    const L = Qt(d);
    if (e.resolver) {
      const S = await K(oe(d) ? d : L);
      y = ve(S), R = d ? !L.some((B) => P(S, B)) : y;
    } else d ? (R = (await Promise.all(L.map(async (S) => {
      const B = P(n, S);
      return await te(B && B._f ? { [S]: B } : B);
    }))).every(Boolean), !(!R && !r.isValid) && E()) : R = y = await te(n);
    return h.state.next({
      ...!Pe(d) || u.isValid && y !== r.isValid ? {} : { name: d },
      ...e.resolver || !d ? { isValid: y } : {},
      errors: r.errors
    }), m.shouldFocus && !R && kt(n, Q, d ? L : o.mount), R;
  }, Ae = (d) => {
    const m = {
      ...a.mount ? i : s
    };
    return oe(d) ? m : Pe(d) ? P(m, d) : d.map((y) => P(m, y));
  }, Kt = (d, m) => ({
    invalid: !!P((m || r).errors, d),
    isDirty: !!P((m || r).dirtyFields, d),
    error: P((m || r).errors, d),
    isValidating: !!P(r.validatingFields, d),
    isTouched: !!P((m || r).touchedFields, d)
  }), me = (d) => {
    d && Qt(d).forEach((m) => le(r.errors, m)), h.state.next({
      errors: d ? r.errors : {}
    });
  }, Ge = (d, m, y) => {
    const R = (P(n, d, { _f: {} })._f || {}).ref, L = P(r.errors, d) || {}, { ref: S, message: B, type: ee, ...ce } = L;
    se(r.errors, d, {
      ...ce,
      ...m,
      ref: R
    }), h.state.next({
      name: d,
      errors: r.errors,
      isValid: !1
    }), y && y.shouldFocus && R && R.focus && R.focus();
  }, $s = (d, m) => Re(d) ? h.values.subscribe({
    next: (y) => d(T(void 0, m), y)
  }) : T(d, m, !0), wr = (d, m = {}) => {
    for (const y of d ? Qt(d) : o.mount)
      o.mount.delete(y), o.array.delete(y), m.keepValue || (le(n, y), le(i, y)), !m.keepError && le(r.errors, y), !m.keepDirty && le(r.dirtyFields, y), !m.keepTouched && le(r.touchedFields, y), !m.keepIsValidating && le(r.validatingFields, y), !e.shouldUnregister && !m.keepDefaultValue && le(s, y);
    h.values.next({
      values: { ...i }
    }), h.state.next({
      ...r,
      ...m.keepDirty ? { isDirty: O() } : {}
    }), !m.keepIsValid && E();
  }, on = ({ disabled: d, name: m, field: y, fields: R }) => {
    (Te(d) && a.mount || d || o.disabled.has(m)) && (d ? o.disabled.add(m) : o.disabled.delete(m), D(m, Fr(y ? y._f : P(R, m)._f), !1, !1, !0));
  }, xr = (d, m = {}) => {
    let y = P(n, d);
    const R = Te(m.disabled) || Te(e.disabled);
    return se(n, d, {
      ...y || {},
      _f: {
        ...y && y._f ? y._f : { ref: { name: d } },
        name: d,
        mount: !0,
        ...m
      }
    }), o.mount.add(d), y ? on({
      field: y,
      disabled: Te(m.disabled) ? m.disabled : e.disabled,
      name: d
    }) : $(d, !0, m.value), {
      ...R ? { disabled: m.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!m.required,
        min: wt(m.min),
        max: wt(m.max),
        minLength: wt(m.minLength),
        maxLength: wt(m.maxLength),
        pattern: wt(m.pattern)
      } : {},
      name: d,
      onChange: M,
      onBlur: M,
      ref: (L) => {
        if (L) {
          xr(d, m), y = P(n, d);
          const S = oe(L.value) && L.querySelectorAll && L.querySelectorAll("input,select,textarea")[0] || L, B = v1(S), ee = y._f.refs || [];
          if (B ? ee.find((ce) => ce === S) : S === y._f.ref)
            return;
          se(n, d, {
            _f: {
              ...y._f,
              ...B ? {
                refs: [
                  ...ee.filter(jr),
                  S,
                  ...Array.isArray(P(s, d)) ? [{}] : []
                ],
                ref: { type: S.type, name: d }
              } : { ref: S }
            }
          }), $(d, !1, void 0, S);
        } else
          y = P(n, d, {}), y._f && (y._f.mount = !1), (e.shouldUnregister || m.shouldUnregister) && !(c1(o.array, d) && a.action) && o.unMount.add(d);
      }
    };
  }, ln = () => e.shouldFocusError && kt(n, Q, o.mount), Ds = (d) => {
    Te(d) && (h.state.next({ disabled: d }), kt(n, (m, y) => {
      const R = P(n, y);
      R && (m.disabled = R._f.disabled || d, Array.isArray(R._f.refs) && R._f.refs.forEach((L) => {
        L.disabled = R._f.disabled || d;
      }));
    }, 0, !1));
  }, cn = (d, m) => async (y) => {
    let R;
    y && (y.preventDefault && y.preventDefault(), y.persist && y.persist());
    let L = _e(i);
    if (o.disabled.size)
      for (const S of o.disabled)
        se(L, S, void 0);
    if (h.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: S, values: B } = await q();
      r.errors = S, L = B;
    } else
      await te(n);
    if (le(r.errors, "root"), ve(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await d(L, y);
      } catch (S) {
        R = S;
      }
    } else
      m && await m({ ...r.errors }, y), ln(), setTimeout(ln);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ve(r.errors) && !R,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), R)
      throw R;
  }, Bs = (d, m = {}) => {
    P(n, d) && (oe(m.defaultValue) ? I(d, _e(P(s, d))) : (I(d, m.defaultValue), se(s, d, _e(m.defaultValue))), m.keepTouched || le(r.touchedFields, d), m.keepDirty || (le(r.dirtyFields, d), r.isDirty = m.defaultValue ? O(d, _e(P(s, d))) : O()), m.keepError || (le(r.errors, d), u.isValid && E()), h.state.next({ ...r }));
  }, un = (d, m = {}) => {
    const y = d ? _e(d) : s, R = _e(y), L = ve(d), S = L ? s : R;
    if (m.keepDefaultValues || (s = y), !m.keepValues) {
      if (m.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...o.mount,
          ...Object.keys(_t(s, i))
        ]);
        for (const ee of Array.from(B))
          P(r.dirtyFields, ee) ? se(S, ee, P(i, ee)) : I(ee, P(S, ee));
      } else {
        if (tn && oe(d))
          for (const B of o.mount) {
            const ee = P(n, B);
            if (ee && ee._f) {
              const ce = Array.isArray(ee._f.refs) ? ee._f.refs[0] : ee._f.ref;
              if (or(ce)) {
                const ue = ce.closest("form");
                if (ue) {
                  ue.reset();
                  break;
                }
              }
            }
          }
        n = {};
      }
      i = e.shouldUnregister ? m.keepDefaultValues ? _e(s) : {} : _e(S), h.array.next({
        values: { ...S }
      }), h.values.next({
        values: { ...S }
      });
    }
    o = {
      mount: m.keepDirtyValues ? o.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !u.isValid || !!m.keepIsValid || !!m.keepDirtyValues, a.watch = !!e.shouldUnregister, h.state.next({
      submitCount: m.keepSubmitCount ? r.submitCount : 0,
      isDirty: L ? !1 : m.keepDirty ? r.isDirty : !!(m.keepDefaultValues && !He(d, s)),
      isSubmitted: m.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: L ? {} : m.keepDirtyValues ? m.keepDefaultValues && i ? _t(s, i) : r.dirtyFields : m.keepDefaultValues && d ? _t(s, d) : m.keepDirty ? r.dirtyFields : {},
      touchedFields: m.keepTouched ? r.touchedFields : {},
      errors: m.keepErrors ? r.errors : {},
      isSubmitSuccessful: m.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, dn = (d, m) => un(Re(d) ? d(i) : d, m);
  return {
    control: {
      register: xr,
      unregister: wr,
      getFieldState: Kt,
      handleSubmit: cn,
      setError: Ge,
      _executeSchema: q,
      _getWatch: T,
      _getDirty: O,
      _updateValid: E,
      _removeUnmounted: W,
      _updateFieldArray: x,
      _updateDisabledField: on,
      _getFieldArray: G,
      _reset: un,
      _resetDefaultValues: () => Re(e.defaultValues) && e.defaultValues().then((d) => {
        dn(d, e.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (d) => {
        r = {
          ...r,
          ...d
        };
      },
      _disableForm: Ds,
      _subjects: h,
      _proxyFormState: u,
      _setErrors: V,
      get _fields() {
        return n;
      },
      get _formValues() {
        return i;
      },
      get _state() {
        return a;
      },
      set _state(d) {
        a = d;
      },
      get _defaultValues() {
        return s;
      },
      get _names() {
        return o;
      },
      set _names(d) {
        o = d;
      },
      get _formState() {
        return r;
      },
      set _formState(d) {
        r = d;
      },
      get _options() {
        return e;
      },
      set _options(d) {
        e = {
          ...e,
          ...d
        };
      }
    },
    trigger: J,
    register: xr,
    handleSubmit: cn,
    watch: $s,
    setValue: I,
    getValues: Ae,
    reset: dn,
    resetField: Bs,
    clearErrors: me,
    unregister: wr,
    setError: Ge,
    setFocus: (d, m = {}) => {
      const y = P(n, d), R = y && y._f;
      if (R) {
        const L = R.refs ? R.refs[0] : R.ref;
        L.focus && (L.focus(), m.shouldSelect && Re(L.select) && L.select());
      }
    },
    getFieldState: Kt
  };
}
function L1(t = {}) {
  const e = we.useRef(void 0), r = we.useRef(void 0), [n, s] = we.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Re(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    defaultValues: Re(t.defaultValues) ? void 0 : t.defaultValues
  });
  e.current || (e.current = {
    ...E1(t),
    formState: n
  });
  const i = e.current.control;
  return i._options = t, h1({
    subject: i._subjects.state,
    next: (a) => {
      f1(a, i._proxyFormState, i._updateFormState) && s({ ...i._formState });
    }
  }), we.useEffect(() => i._disableForm(t.disabled), [i, t.disabled]), we.useEffect(() => {
    if (i._proxyFormState.isDirty) {
      const a = i._getDirty();
      a !== n.isDirty && i._subjects.state.next({
        isDirty: a
      });
    }
  }, [i, n.isDirty]), we.useEffect(() => {
    t.values && !He(t.values, r.current) ? (i._reset(t.values, i._options.resetOptions), r.current = t.values, s((a) => ({ ...a }))) : i._resetDefaultValues();
  }, [t.values, i]), we.useEffect(() => {
    t.errors && i._setErrors(t.errors);
  }, [t.errors, i]), we.useEffect(() => {
    i._state.mount || (i._updateValid(), i._state.mount = !0), i._state.watch && (i._state.watch = !1, i._subjects.state.next({ ...i._formState })), i._removeUnmounted();
  }), we.useEffect(() => {
    t.shouldUnregister && i._subjects.values.next({
      values: i._getWatch()
    });
  }, [t.shouldUnregister, i]), e.current.formState = d1(n, i), e.current;
}
const Xn = (t, e, r) => {
  if (t && "reportValidity" in t) {
    const n = P(r, e);
    t.setCustomValidity(n && n.message || ""), t.reportValidity();
  }
}, As = (t, e) => {
  for (const r in e.fields) {
    const n = e.fields[r];
    n && n.ref && "reportValidity" in n.ref ? Xn(n.ref, r, t) : n.refs && n.refs.forEach((s) => Xn(s, r, t));
  }
}, k1 = (t, e) => {
  e.shouldUseNativeValidation && As(t, e);
  const r = {};
  for (const n in t) {
    const s = P(e.fields, n), i = Object.assign(t[n] || {}, { ref: s && s.ref });
    if (O1(e.names || Object.keys(t), n)) {
      const a = Object.assign({}, P(r, n));
      se(a, "root", i), se(r, n, a);
    } else se(r, n, i);
  }
  return r;
}, O1 = (t, e) => t.some((r) => r.startsWith(e + "."));
var A1 = function(t, e) {
  for (var r = {}; t.length; ) {
    var n = t[0], s = n.code, i = n.message, a = n.path.join(".");
    if (!r[a]) if ("unionErrors" in n) {
      var o = n.unionErrors[0].errors[0];
      r[a] = { message: o.message, type: o.code };
    } else r[a] = { message: i, type: s };
    if ("unionErrors" in n && n.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(h) {
        return t.push(h);
      });
    }), e) {
      var l = r[a].types, c = l && l[n.code];
      r[a] = ws(a, e, r, s, c ? [].concat(c, n.message) : n.message);
    }
    t.shift();
  }
  return r;
}, T1 = function(t, e, r) {
  return r === void 0 && (r = {}), function(n, s, i) {
    try {
      return Promise.resolve((function(a, o) {
        try {
          var l = Promise.resolve(t[r.mode === "sync" ? "parse" : "parseAsync"](n, e)).then(function(c) {
            return i.shouldUseNativeValidation && As({}, i), { errors: {}, values: r.raw ? n : c };
          });
        } catch (c) {
          return o(c);
        }
        return l && l.then ? l.then(void 0, o) : l;
      })(0, function(a) {
        if ((function(o) {
          return Array.isArray(o == null ? void 0 : o.errors);
        })(a)) return { values: {}, errors: k1(A1(a.errors, !i.shouldUseNativeValidation && i.criteriaMode === "all"), i) };
        throw a;
      }));
    } catch (a) {
      return Promise.reject(a);
    }
  };
};
const R1 = "_form_b8oxs_1", N1 = "_body_b8oxs_7", P1 = "_isPreview_b8oxs_18", V1 = "_policyCheckbox_b8oxs_23", M1 = "_fieldset_b8oxs_29", j1 = "_field_b8oxs_29", F1 = "_isShort_b8oxs_39", I1 = "_footer_b8oxs_43", Z1 = "_nonSticky_b8oxs_54", $1 = "_footerActions_b8oxs_59", D1 = "_backButton_b8oxs_64", B1 = "_proceedButton_b8oxs_68", ye = {
  form: R1,
  body: N1,
  isPreview: P1,
  policyCheckbox: V1,
  fieldset: M1,
  field: j1,
  isShort: F1,
  footer: I1,
  nonSticky: Z1,
  footerActions: $1,
  backButton: D1,
  proceedButton: B1
};
var ne;
(function(t) {
  t.assertEqual = (s) => s;
  function e(s) {
  }
  t.assertIs = e;
  function r(s) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (s) => {
    const i = {};
    for (const a of s)
      i[a] = a;
    return i;
  }, t.getValidEnumValues = (s) => {
    const i = t.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), a = {};
    for (const o of i)
      a[o] = s[o];
    return t.objectValues(a);
  }, t.objectValues = (s) => t.objectKeys(s).map(function(i) {
    return s[i];
  }), t.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const i = [];
    for (const a in s)
      Object.prototype.hasOwnProperty.call(s, a) && i.push(a);
    return i;
  }, t.find = (s, i) => {
    for (const a of s)
      if (i(a))
        return a;
  }, t.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function n(s, i = " | ") {
    return s.map((a) => typeof a == "string" ? `'${a}'` : a).join(i);
  }
  t.joinValues = n, t.jsonStringifyReplacer = (s, i) => typeof i == "bigint" ? i.toString() : i;
})(ne || (ne = {}));
var zr;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(zr || (zr = {}));
const N = ne.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), Ze = (t) => {
  switch (typeof t) {
    case "undefined":
      return N.undefined;
    case "string":
      return N.string;
    case "number":
      return isNaN(t) ? N.nan : N.number;
    case "boolean":
      return N.boolean;
    case "function":
      return N.function;
    case "bigint":
      return N.bigint;
    case "symbol":
      return N.symbol;
    case "object":
      return Array.isArray(t) ? N.array : t === null ? N.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? N.promise : typeof Map < "u" && t instanceof Map ? N.map : typeof Set < "u" && t instanceof Set ? N.set : typeof Date < "u" && t instanceof Date ? N.date : N.object;
    default:
      return N.unknown;
  }
}, b = ne.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), H1 = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
class Ce extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (n) => {
      this.issues = [...this.issues, n];
    }, this.addIssues = (n = []) => {
      this.issues = [...this.issues, ...n];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(i) {
      return i.message;
    }, n = { _errors: [] }, s = (i) => {
      for (const a of i.issues)
        if (a.code === "invalid_union")
          a.unionErrors.map(s);
        else if (a.code === "invalid_return_type")
          s(a.returnTypeError);
        else if (a.code === "invalid_arguments")
          s(a.argumentsError);
        else if (a.path.length === 0)
          n._errors.push(r(a));
        else {
          let o = n, l = 0;
          for (; l < a.path.length; ) {
            const c = a.path[l];
            l === a.path.length - 1 ? (o[c] = o[c] || { _errors: [] }, o[c]._errors.push(r(a))) : o[c] = o[c] || { _errors: [] }, o = o[c], l++;
          }
        }
    };
    return s(this), n;
  }
  static assert(e) {
    if (!(e instanceof Ce))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ne.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, n = [];
    for (const s of this.issues)
      s.path.length > 0 ? (r[s.path[0]] = r[s.path[0]] || [], r[s.path[0]].push(e(s))) : n.push(e(s));
    return { formErrors: n, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ce.create = (t) => new Ce(t);
const mt = (t, e) => {
  let r;
  switch (t.code) {
    case b.invalid_type:
      t.received === N.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case b.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, ne.jsonStringifyReplacer)}`;
      break;
    case b.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${ne.joinValues(t.keys, ", ")}`;
      break;
    case b.invalid_union:
      r = "Invalid input";
      break;
    case b.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${ne.joinValues(t.options)}`;
      break;
    case b.invalid_enum_value:
      r = `Invalid enum value. Expected ${ne.joinValues(t.options)}, received '${t.received}'`;
      break;
    case b.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case b.invalid_return_type:
      r = "Invalid function return type";
      break;
    case b.invalid_date:
      r = "Invalid date";
      break;
    case b.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : ne.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case b.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case b.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case b.custom:
      r = "Invalid input";
      break;
    case b.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case b.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case b.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, ne.assertNever(t);
  }
  return { message: r };
};
let Ts = mt;
function U1(t) {
  Ts = t;
}
function ur() {
  return Ts;
}
const dr = (t) => {
  const { data: e, path: r, errorMaps: n, issueData: s } = t, i = [...r, ...s.path || []], a = {
    ...s,
    path: i
  };
  if (s.message !== void 0)
    return {
      ...s,
      path: i,
      message: s.message
    };
  let o = "";
  const l = n.filter((c) => !!c).slice().reverse();
  for (const c of l)
    o = c(a, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: i,
    message: o
  };
}, q1 = [];
function k(t, e) {
  const r = ur(), n = dr({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === mt ? void 0 : mt
      // then global default map
    ].filter((s) => !!s)
  });
  t.common.issues.push(n);
}
class he {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const n = [];
    for (const s of r) {
      if (s.status === "aborted")
        return U;
      s.status === "dirty" && e.dirty(), n.push(s.value);
    }
    return { status: e.value, value: n };
  }
  static async mergeObjectAsync(e, r) {
    const n = [];
    for (const s of r) {
      const i = await s.key, a = await s.value;
      n.push({
        key: i,
        value: a
      });
    }
    return he.mergeObjectSync(e, n);
  }
  static mergeObjectSync(e, r) {
    const n = {};
    for (const s of r) {
      const { key: i, value: a } = s;
      if (i.status === "aborted" || a.status === "aborted")
        return U;
      i.status === "dirty" && e.dirty(), a.status === "dirty" && e.dirty(), i.value !== "__proto__" && (typeof a.value < "u" || s.alwaysSet) && (n[i.value] = a.value);
    }
    return { status: e.value, value: n };
  }
}
const U = Object.freeze({
  status: "aborted"
}), dt = (t) => ({ status: "dirty", value: t }), ge = (t) => ({ status: "valid", value: t }), Kr = (t) => t.status === "aborted", Wr = (t) => t.status === "dirty", nt = (t) => t.status === "valid", Rt = (t) => typeof Promise < "u" && t instanceof Promise;
function fr(t, e, r, n) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return e.get(t);
}
function Rs(t, e, r, n, s) {
  if (typeof e == "function" ? t !== e || !0 : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return e.set(t, r), r;
}
var F;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(F || (F = {}));
var xt, St;
class Me {
  constructor(e, r, n, s) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = n, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Gn = (t, e) => {
  if (nt(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Ce(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function X(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: n, description: s } = t;
  if (e && (r || n))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (a, o) => {
    var l, c;
    const { message: u } = t;
    return a.code === "invalid_enum_value" ? { message: u ?? o.defaultError } : typeof o.data > "u" ? { message: (l = u ?? n) !== null && l !== void 0 ? l : o.defaultError } : a.code !== "invalid_type" ? { message: o.defaultError } : { message: (c = u ?? r) !== null && c !== void 0 ? c : o.defaultError };
  }, description: s };
}
class Y {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Ze(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: Ze(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new he(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: Ze(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (Rt(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const n = this.safeParse(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  safeParse(e, r) {
    var n;
    const s = {
      common: {
        issues: [],
        async: (n = r == null ? void 0 : r.async) !== null && n !== void 0 ? n : !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ze(e)
    }, i = this._parseSync({ data: e, path: s.path, parent: s });
    return Gn(s, i);
  }
  "~validate"(e) {
    var r, n;
    const s = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ze(e)
    };
    if (!this["~standard"].async)
      try {
        const i = this._parseSync({ data: e, path: [], parent: s });
        return nt(i) ? {
          value: i.value
        } : {
          issues: s.common.issues
        };
      } catch (i) {
        !((n = (r = i == null ? void 0 : i.message) === null || r === void 0 ? void 0 : r.toLowerCase()) === null || n === void 0) && n.includes("encountered") && (this["~standard"].async = !0), s.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: s }).then((i) => nt(i) ? {
      value: i.value
    } : {
      issues: s.common.issues
    });
  }
  async parseAsync(e, r) {
    const n = await this.safeParseAsync(e, r);
    if (n.success)
      return n.data;
    throw n.error;
  }
  async safeParseAsync(e, r) {
    const n = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: Ze(e)
    }, s = this._parse({ data: e, path: n.path, parent: n }), i = await (Rt(s) ? s : Promise.resolve(s));
    return Gn(n, i);
  }
  refine(e, r) {
    const n = (s) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(s) : r;
    return this._refinement((s, i) => {
      const a = e(s), o = () => i.addIssue({
        code: b.custom,
        ...n(s)
      });
      return typeof Promise < "u" && a instanceof Promise ? a.then((l) => l ? !0 : (o(), !1)) : a ? !0 : (o(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((n, s) => e(n) ? !0 : (s.addIssue(typeof r == "function" ? r(n, s) : r), !1));
  }
  _refinement(e) {
    return new Oe({
      schema: this,
      typeName: H.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return Ve.create(this, this._def);
  }
  nullable() {
    return Xe.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ke.create(this);
  }
  promise() {
    return vt.create(this, this._def);
  }
  or(e) {
    return Mt.create([this, e], this._def);
  }
  and(e) {
    return jt.create(this, e, this._def);
  }
  transform(e) {
    return new Oe({
      ...X(this._def),
      schema: this,
      typeName: H.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Dt({
      ...X(this._def),
      innerType: this,
      defaultValue: r,
      typeName: H.ZodDefault
    });
  }
  brand() {
    return new an({
      typeName: H.ZodBranded,
      type: this,
      ...X(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Bt({
      ...X(this._def),
      innerType: this,
      catchValue: r,
      typeName: H.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return zt.create(this, e);
  }
  readonly() {
    return Ht.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const z1 = /^c[^\s-]{8,}$/i, K1 = /^[0-9a-z]+$/, W1 = /^[0-9A-HJKMNP-TV-Z]{26}$/i, J1 = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, X1 = /^[a-z0-9_-]{21}$/i, G1 = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Y1 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Q1 = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, el = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Ir;
const tl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, rl = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, nl = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, sl = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, il = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, al = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ns = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", ol = new RegExp(`^${Ns}$`);
function Ps(t) {
  let e = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), e;
}
function ll(t) {
  return new RegExp(`^${Ps(t)}$`);
}
function Vs(t) {
  let e = `${Ns}T${Ps(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function cl(t, e) {
  return !!((e === "v4" || !e) && tl.test(t) || (e === "v6" || !e) && nl.test(t));
}
function ul(t, e) {
  if (!G1.test(t))
    return !1;
  try {
    const [r] = t.split("."), n = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), s = JSON.parse(atob(n));
    return !(typeof s != "object" || s === null || !s.typ || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function dl(t, e) {
  return !!((e === "v4" || !e) && rl.test(t) || (e === "v6" || !e) && sl.test(t));
}
class Le extends Y {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== N.string) {
      const i = this._getOrReturnCtx(e);
      return k(i, {
        code: b.invalid_type,
        expected: N.string,
        received: i.parsedType
      }), U;
    }
    const n = new he();
    let s;
    for (const i of this._def.checks)
      if (i.kind === "min")
        e.data.length < i.value && (s = this._getOrReturnCtx(e, s), k(s, {
          code: b.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "max")
        e.data.length > i.value && (s = this._getOrReturnCtx(e, s), k(s, {
          code: b.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: i.message
        }), n.dirty());
      else if (i.kind === "length") {
        const a = e.data.length > i.value, o = e.data.length < i.value;
        (a || o) && (s = this._getOrReturnCtx(e, s), a ? k(s, {
          code: b.too_big,
          maximum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }) : o && k(s, {
          code: b.too_small,
          minimum: i.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: i.message
        }), n.dirty());
      } else if (i.kind === "email")
        Q1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "email",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "emoji")
        Ir || (Ir = new RegExp(el, "u")), Ir.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "emoji",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "uuid")
        J1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "uuid",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "nanoid")
        X1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "nanoid",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid")
        z1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "cuid",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "cuid2")
        K1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "cuid2",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "ulid")
        W1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
          validation: "ulid",
          code: b.invalid_string,
          message: i.message
        }), n.dirty());
      else if (i.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), k(s, {
            validation: "url",
            code: b.invalid_string,
            message: i.message
          }), n.dirty();
        }
      else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "regex",
        code: b.invalid_string,
        message: i.message
      }), n.dirty())) : i.kind === "trim" ? e.data = e.data.trim() : i.kind === "includes" ? e.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.invalid_string,
        validation: { includes: i.value, position: i.position },
        message: i.message
      }), n.dirty()) : i.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : i.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : i.kind === "startsWith" ? e.data.startsWith(i.value) || (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.invalid_string,
        validation: { startsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "endsWith" ? e.data.endsWith(i.value) || (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.invalid_string,
        validation: { endsWith: i.value },
        message: i.message
      }), n.dirty()) : i.kind === "datetime" ? Vs(i).test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.invalid_string,
        validation: "datetime",
        message: i.message
      }), n.dirty()) : i.kind === "date" ? ol.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.invalid_string,
        validation: "date",
        message: i.message
      }), n.dirty()) : i.kind === "time" ? ll(i).test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.invalid_string,
        validation: "time",
        message: i.message
      }), n.dirty()) : i.kind === "duration" ? Y1.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "duration",
        code: b.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "ip" ? cl(e.data, i.version) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "ip",
        code: b.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "jwt" ? ul(e.data, i.alg) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "jwt",
        code: b.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "cidr" ? dl(e.data, i.version) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "cidr",
        code: b.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64" ? il.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "base64",
        code: b.invalid_string,
        message: i.message
      }), n.dirty()) : i.kind === "base64url" ? al.test(e.data) || (s = this._getOrReturnCtx(e, s), k(s, {
        validation: "base64url",
        code: b.invalid_string,
        message: i.message
      }), n.dirty()) : ne.assertNever(i);
    return { status: n.value, value: e.data };
  }
  _regex(e, r, n) {
    return this.refinement((s) => e.test(s), {
      validation: r,
      code: b.invalid_string,
      ...F.errToObj(n)
    });
  }
  _addCheck(e) {
    return new Le({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...F.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...F.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...F.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...F.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...F.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...F.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...F.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...F.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...F.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...F.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...F.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...F.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...F.errToObj(e) });
  }
  datetime(e) {
    var r, n;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (r = e == null ? void 0 : e.offset) !== null && r !== void 0 ? r : !1,
      local: (n = e == null ? void 0 : e.local) !== null && n !== void 0 ? n : !1,
      ...F.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...F.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...F.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...F.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...F.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...F.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...F.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...F.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...F.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...F.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, F.errToObj(e));
  }
  trim() {
    return new Le({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Le({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Le({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
Le.create = (t) => {
  var e;
  return new Le({
    checks: [],
    typeName: H.ZodString,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...X(t)
  });
};
function fl(t, e) {
  const r = (t.toString().split(".")[1] || "").length, n = (e.toString().split(".")[1] || "").length, s = r > n ? r : n, i = parseInt(t.toFixed(s).replace(".", "")), a = parseInt(e.toFixed(s).replace(".", ""));
  return i % a / Math.pow(10, s);
}
class Ke extends Y {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== N.number) {
      const i = this._getOrReturnCtx(e);
      return k(i, {
        code: b.invalid_type,
        expected: N.number,
        received: i.parsedType
      }), U;
    }
    let n;
    const s = new he();
    for (const i of this._def.checks)
      i.kind === "int" ? ne.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.invalid_type,
        expected: "integer",
        received: "float",
        message: i.message
      }), s.dirty()) : i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.too_small,
        minimum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.too_big,
        maximum: i.value,
        type: "number",
        inclusive: i.inclusive,
        exact: !1,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? fl(e.data, i.value) !== 0 && (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : i.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.not_finite,
        message: i.message
      }), s.dirty()) : ne.assertNever(i);
    return { status: s.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, F.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, F.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, F.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, F.toString(r));
  }
  setLimit(e, r, n, s) {
    return new Ke({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: F.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new Ke({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: F.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: F.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: F.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: F.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: F.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: F.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: F.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: F.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: F.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ne.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const n of this._def.checks) {
      if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf")
        return !0;
      n.kind === "min" ? (r === null || n.value > r) && (r = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
Ke.create = (t) => new Ke({
  checks: [],
  typeName: H.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...X(t)
});
class We extends Y {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== N.bigint)
      return this._getInvalidInput(e);
    let n;
    const s = new he();
    for (const i of this._def.checks)
      i.kind === "min" ? (i.inclusive ? e.data < i.value : e.data <= i.value) && (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.too_small,
        type: "bigint",
        minimum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "max" ? (i.inclusive ? e.data > i.value : e.data >= i.value) && (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.too_big,
        type: "bigint",
        maximum: i.value,
        inclusive: i.inclusive,
        message: i.message
      }), s.dirty()) : i.kind === "multipleOf" ? e.data % i.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), k(n, {
        code: b.not_multiple_of,
        multipleOf: i.value,
        message: i.message
      }), s.dirty()) : ne.assertNever(i);
    return { status: s.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return k(r, {
      code: b.invalid_type,
      expected: N.bigint,
      received: r.parsedType
    }), U;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, F.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, F.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, F.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, F.toString(r));
  }
  setLimit(e, r, n, s) {
    return new We({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: n,
          message: F.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new We({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: F.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: F.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: F.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: F.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: F.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
We.create = (t) => {
  var e;
  return new We({
    checks: [],
    typeName: H.ZodBigInt,
    coerce: (e = t == null ? void 0 : t.coerce) !== null && e !== void 0 ? e : !1,
    ...X(t)
  });
};
class Nt extends Y {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== N.boolean) {
      const n = this._getOrReturnCtx(e);
      return k(n, {
        code: b.invalid_type,
        expected: N.boolean,
        received: n.parsedType
      }), U;
    }
    return ge(e.data);
  }
}
Nt.create = (t) => new Nt({
  typeName: H.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...X(t)
});
class st extends Y {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== N.date) {
      const i = this._getOrReturnCtx(e);
      return k(i, {
        code: b.invalid_type,
        expected: N.date,
        received: i.parsedType
      }), U;
    }
    if (isNaN(e.data.getTime())) {
      const i = this._getOrReturnCtx(e);
      return k(i, {
        code: b.invalid_date
      }), U;
    }
    const n = new he();
    let s;
    for (const i of this._def.checks)
      i.kind === "min" ? e.data.getTime() < i.value && (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.too_small,
        message: i.message,
        inclusive: !0,
        exact: !1,
        minimum: i.value,
        type: "date"
      }), n.dirty()) : i.kind === "max" ? e.data.getTime() > i.value && (s = this._getOrReturnCtx(e, s), k(s, {
        code: b.too_big,
        message: i.message,
        inclusive: !0,
        exact: !1,
        maximum: i.value,
        type: "date"
      }), n.dirty()) : ne.assertNever(i);
    return {
      status: n.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new st({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: F.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: F.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
st.create = (t) => new st({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: H.ZodDate,
  ...X(t)
});
class hr extends Y {
  _parse(e) {
    if (this._getType(e) !== N.symbol) {
      const n = this._getOrReturnCtx(e);
      return k(n, {
        code: b.invalid_type,
        expected: N.symbol,
        received: n.parsedType
      }), U;
    }
    return ge(e.data);
  }
}
hr.create = (t) => new hr({
  typeName: H.ZodSymbol,
  ...X(t)
});
class Pt extends Y {
  _parse(e) {
    if (this._getType(e) !== N.undefined) {
      const n = this._getOrReturnCtx(e);
      return k(n, {
        code: b.invalid_type,
        expected: N.undefined,
        received: n.parsedType
      }), U;
    }
    return ge(e.data);
  }
}
Pt.create = (t) => new Pt({
  typeName: H.ZodUndefined,
  ...X(t)
});
class Vt extends Y {
  _parse(e) {
    if (this._getType(e) !== N.null) {
      const n = this._getOrReturnCtx(e);
      return k(n, {
        code: b.invalid_type,
        expected: N.null,
        received: n.parsedType
      }), U;
    }
    return ge(e.data);
  }
}
Vt.create = (t) => new Vt({
  typeName: H.ZodNull,
  ...X(t)
});
class yt extends Y {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return ge(e.data);
  }
}
yt.create = (t) => new yt({
  typeName: H.ZodAny,
  ...X(t)
});
class et extends Y {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return ge(e.data);
  }
}
et.create = (t) => new et({
  typeName: H.ZodUnknown,
  ...X(t)
});
class De extends Y {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return k(r, {
      code: b.invalid_type,
      expected: N.never,
      received: r.parsedType
    }), U;
  }
}
De.create = (t) => new De({
  typeName: H.ZodNever,
  ...X(t)
});
class pr extends Y {
  _parse(e) {
    if (this._getType(e) !== N.undefined) {
      const n = this._getOrReturnCtx(e);
      return k(n, {
        code: b.invalid_type,
        expected: N.void,
        received: n.parsedType
      }), U;
    }
    return ge(e.data);
  }
}
pr.create = (t) => new pr({
  typeName: H.ZodVoid,
  ...X(t)
});
class ke extends Y {
  _parse(e) {
    const { ctx: r, status: n } = this._processInputParams(e), s = this._def;
    if (r.parsedType !== N.array)
      return k(r, {
        code: b.invalid_type,
        expected: N.array,
        received: r.parsedType
      }), U;
    if (s.exactLength !== null) {
      const a = r.data.length > s.exactLength.value, o = r.data.length < s.exactLength.value;
      (a || o) && (k(r, {
        code: a ? b.too_big : b.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: a ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), n.dirty());
    }
    if (s.minLength !== null && r.data.length < s.minLength.value && (k(r, {
      code: b.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), n.dirty()), s.maxLength !== null && r.data.length > s.maxLength.value && (k(r, {
      code: b.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), n.dirty()), r.common.async)
      return Promise.all([...r.data].map((a, o) => s.type._parseAsync(new Me(r, a, r.path, o)))).then((a) => he.mergeArray(n, a));
    const i = [...r.data].map((a, o) => s.type._parseSync(new Me(r, a, r.path, o)));
    return he.mergeArray(n, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new ke({
      ...this._def,
      minLength: { value: e, message: F.toString(r) }
    });
  }
  max(e, r) {
    return new ke({
      ...this._def,
      maxLength: { value: e, message: F.toString(r) }
    });
  }
  length(e, r) {
    return new ke({
      ...this._def,
      exactLength: { value: e, message: F.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
ke.create = (t, e) => new ke({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: H.ZodArray,
  ...X(e)
});
function ct(t) {
  if (t instanceof ie) {
    const e = {};
    for (const r in t.shape) {
      const n = t.shape[r];
      e[r] = Ve.create(ct(n));
    }
    return new ie({
      ...t._def,
      shape: () => e
    });
  } else return t instanceof ke ? new ke({
    ...t._def,
    type: ct(t.element)
  }) : t instanceof Ve ? Ve.create(ct(t.unwrap())) : t instanceof Xe ? Xe.create(ct(t.unwrap())) : t instanceof je ? je.create(t.items.map((e) => ct(e))) : t;
}
class ie extends Y {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = ne.objectKeys(e);
    return this._cached = { shape: e, keys: r };
  }
  _parse(e) {
    if (this._getType(e) !== N.object) {
      const c = this._getOrReturnCtx(e);
      return k(c, {
        code: b.invalid_type,
        expected: N.object,
        received: c.parsedType
      }), U;
    }
    const { status: n, ctx: s } = this._processInputParams(e), { shape: i, keys: a } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof De && this._def.unknownKeys === "strip"))
      for (const c in s.data)
        a.includes(c) || o.push(c);
    const l = [];
    for (const c of a) {
      const u = i[c], h = s.data[c];
      l.push({
        key: { status: "valid", value: c },
        value: u._parse(new Me(s, h, s.path, c)),
        alwaysSet: c in s.data
      });
    }
    if (this._def.catchall instanceof De) {
      const c = this._def.unknownKeys;
      if (c === "passthrough")
        for (const u of o)
          l.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: s.data[u] }
          });
      else if (c === "strict")
        o.length > 0 && (k(s, {
          code: b.unrecognized_keys,
          keys: o
        }), n.dirty());
      else if (c !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const c = this._def.catchall;
      for (const u of o) {
        const h = s.data[u];
        l.push({
          key: { status: "valid", value: u },
          value: c._parse(
            new Me(s, h, s.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const c = [];
      for (const u of l) {
        const h = await u.key, f = await u.value;
        c.push({
          key: h,
          value: f,
          alwaysSet: u.alwaysSet
        });
      }
      return c;
    }).then((c) => he.mergeObjectSync(n, c)) : he.mergeObjectSync(n, l);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return F.errToObj, new ie({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, n) => {
          var s, i, a, o;
          const l = (a = (i = (s = this._def).errorMap) === null || i === void 0 ? void 0 : i.call(s, r, n).message) !== null && a !== void 0 ? a : n.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: (o = F.errToObj(e).message) !== null && o !== void 0 ? o : l
          } : {
            message: l
          };
        }
      } : {}
    });
  }
  strip() {
    return new ie({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ie({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new ie({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new ie({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: H.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new ie({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    return ne.objectKeys(e).forEach((n) => {
      e[n] && this.shape[n] && (r[n] = this.shape[n]);
    }), new ie({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    return ne.objectKeys(this.shape).forEach((n) => {
      e[n] || (r[n] = this.shape[n]);
    }), new ie({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ct(this);
  }
  partial(e) {
    const r = {};
    return ne.objectKeys(this.shape).forEach((n) => {
      const s = this.shape[n];
      e && !e[n] ? r[n] = s : r[n] = s.optional();
    }), new ie({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    return ne.objectKeys(this.shape).forEach((n) => {
      if (e && !e[n])
        r[n] = this.shape[n];
      else {
        let i = this.shape[n];
        for (; i instanceof Ve; )
          i = i._def.innerType;
        r[n] = i;
      }
    }), new ie({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return Ms(ne.objectKeys(this.shape));
  }
}
ie.create = (t, e) => new ie({
  shape: () => t,
  unknownKeys: "strip",
  catchall: De.create(),
  typeName: H.ZodObject,
  ...X(e)
});
ie.strictCreate = (t, e) => new ie({
  shape: () => t,
  unknownKeys: "strict",
  catchall: De.create(),
  typeName: H.ZodObject,
  ...X(e)
});
ie.lazycreate = (t, e) => new ie({
  shape: t,
  unknownKeys: "strip",
  catchall: De.create(),
  typeName: H.ZodObject,
  ...X(e)
});
class Mt extends Y {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = this._def.options;
    function s(i) {
      for (const o of i)
        if (o.result.status === "valid")
          return o.result;
      for (const o of i)
        if (o.result.status === "dirty")
          return r.common.issues.push(...o.ctx.common.issues), o.result;
      const a = i.map((o) => new Ce(o.ctx.common.issues));
      return k(r, {
        code: b.invalid_union,
        unionErrors: a
      }), U;
    }
    if (r.common.async)
      return Promise.all(n.map(async (i) => {
        const a = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await i._parseAsync({
            data: r.data,
            path: r.path,
            parent: a
          }),
          ctx: a
        };
      })).then(s);
    {
      let i;
      const a = [];
      for (const l of n) {
        const c = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, u = l._parseSync({
          data: r.data,
          path: r.path,
          parent: c
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !i && (i = { result: u, ctx: c }), c.common.issues.length && a.push(c.common.issues);
      }
      if (i)
        return r.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((l) => new Ce(l));
      return k(r, {
        code: b.invalid_union,
        unionErrors: o
      }), U;
    }
  }
  get options() {
    return this._def.options;
  }
}
Mt.create = (t, e) => new Mt({
  options: t,
  typeName: H.ZodUnion,
  ...X(e)
});
const Ie = (t) => t instanceof It ? Ie(t.schema) : t instanceof Oe ? Ie(t.innerType()) : t instanceof Zt ? [t.value] : t instanceof Je ? t.options : t instanceof $t ? ne.objectValues(t.enum) : t instanceof Dt ? Ie(t._def.innerType) : t instanceof Pt ? [void 0] : t instanceof Vt ? [null] : t instanceof Ve ? [void 0, ...Ie(t.unwrap())] : t instanceof Xe ? [null, ...Ie(t.unwrap())] : t instanceof an || t instanceof Ht ? Ie(t.unwrap()) : t instanceof Bt ? Ie(t._def.innerType) : [];
class _r extends Y {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.object)
      return k(r, {
        code: b.invalid_type,
        expected: N.object,
        received: r.parsedType
      }), U;
    const n = this.discriminator, s = r.data[n], i = this.optionsMap.get(s);
    return i ? r.common.async ? i._parseAsync({
      data: r.data,
      path: r.path,
      parent: r
    }) : i._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }) : (k(r, {
      code: b.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [n]
    }), U);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, r, n) {
    const s = /* @__PURE__ */ new Map();
    for (const i of r) {
      const a = Ie(i.shape[e]);
      if (!a.length)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of a) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, i);
      }
    }
    return new _r({
      typeName: H.ZodDiscriminatedUnion,
      discriminator: e,
      options: r,
      optionsMap: s,
      ...X(n)
    });
  }
}
function Jr(t, e) {
  const r = Ze(t), n = Ze(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === N.object && n === N.object) {
    const s = ne.objectKeys(e), i = ne.objectKeys(t).filter((o) => s.indexOf(o) !== -1), a = { ...t, ...e };
    for (const o of i) {
      const l = Jr(t[o], e[o]);
      if (!l.valid)
        return { valid: !1 };
      a[o] = l.data;
    }
    return { valid: !0, data: a };
  } else if (r === N.array && n === N.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const a = t[i], o = e[i], l = Jr(a, o);
      if (!l.valid)
        return { valid: !1 };
      s.push(l.data);
    }
    return { valid: !0, data: s };
  } else return r === N.date && n === N.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class jt extends Y {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = (i, a) => {
      if (Kr(i) || Kr(a))
        return U;
      const o = Jr(i.value, a.value);
      return o.valid ? ((Wr(i) || Wr(a)) && r.dirty(), { status: r.value, value: o.data }) : (k(n, {
        code: b.invalid_intersection_types
      }), U);
    };
    return n.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      }),
      this._def.right._parseAsync({
        data: n.data,
        path: n.path,
        parent: n
      })
    ]).then(([i, a]) => s(i, a)) : s(this._def.left._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }), this._def.right._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }));
  }
}
jt.create = (t, e, r) => new jt({
  left: t,
  right: e,
  typeName: H.ZodIntersection,
  ...X(r)
});
class je extends Y {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.array)
      return k(n, {
        code: b.invalid_type,
        expected: N.array,
        received: n.parsedType
      }), U;
    if (n.data.length < this._def.items.length)
      return k(n, {
        code: b.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), U;
    !this._def.rest && n.data.length > this._def.items.length && (k(n, {
      code: b.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const i = [...n.data].map((a, o) => {
      const l = this._def.items[o] || this._def.rest;
      return l ? l._parse(new Me(n, a, n.path, o)) : null;
    }).filter((a) => !!a);
    return n.common.async ? Promise.all(i).then((a) => he.mergeArray(r, a)) : he.mergeArray(r, i);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new je({
      ...this._def,
      rest: e
    });
  }
}
je.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new je({
    items: t,
    typeName: H.ZodTuple,
    rest: null,
    ...X(e)
  });
};
class Ft extends Y {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.object)
      return k(n, {
        code: b.invalid_type,
        expected: N.object,
        received: n.parsedType
      }), U;
    const s = [], i = this._def.keyType, a = this._def.valueType;
    for (const o in n.data)
      s.push({
        key: i._parse(new Me(n, o, n.path, o)),
        value: a._parse(new Me(n, n.data[o], n.path, o)),
        alwaysSet: o in n.data
      });
    return n.common.async ? he.mergeObjectAsync(r, s) : he.mergeObjectSync(r, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, n) {
    return r instanceof Y ? new Ft({
      keyType: e,
      valueType: r,
      typeName: H.ZodRecord,
      ...X(n)
    }) : new Ft({
      keyType: Le.create(),
      valueType: e,
      typeName: H.ZodRecord,
      ...X(r)
    });
  }
}
class gr extends Y {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.map)
      return k(n, {
        code: b.invalid_type,
        expected: N.map,
        received: n.parsedType
      }), U;
    const s = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([o, l], c) => ({
      key: s._parse(new Me(n, o, n.path, [c, "key"])),
      value: i._parse(new Me(n, l, n.path, [c, "value"]))
    }));
    if (n.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const l of a) {
          const c = await l.key, u = await l.value;
          if (c.status === "aborted" || u.status === "aborted")
            return U;
          (c.status === "dirty" || u.status === "dirty") && r.dirty(), o.set(c.value, u.value);
        }
        return { status: r.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const l of a) {
        const c = l.key, u = l.value;
        if (c.status === "aborted" || u.status === "aborted")
          return U;
        (c.status === "dirty" || u.status === "dirty") && r.dirty(), o.set(c.value, u.value);
      }
      return { status: r.value, value: o };
    }
  }
}
gr.create = (t, e, r) => new gr({
  valueType: e,
  keyType: t,
  typeName: H.ZodMap,
  ...X(r)
});
class it extends Y {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.parsedType !== N.set)
      return k(n, {
        code: b.invalid_type,
        expected: N.set,
        received: n.parsedType
      }), U;
    const s = this._def;
    s.minSize !== null && n.data.size < s.minSize.value && (k(n, {
      code: b.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), r.dirty()), s.maxSize !== null && n.data.size > s.maxSize.value && (k(n, {
      code: b.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), r.dirty());
    const i = this._def.valueType;
    function a(l) {
      const c = /* @__PURE__ */ new Set();
      for (const u of l) {
        if (u.status === "aborted")
          return U;
        u.status === "dirty" && r.dirty(), c.add(u.value);
      }
      return { status: r.value, value: c };
    }
    const o = [...n.data.values()].map((l, c) => i._parse(new Me(n, l, n.path, c)));
    return n.common.async ? Promise.all(o).then((l) => a(l)) : a(o);
  }
  min(e, r) {
    return new it({
      ...this._def,
      minSize: { value: e, message: F.toString(r) }
    });
  }
  max(e, r) {
    return new it({
      ...this._def,
      maxSize: { value: e, message: F.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
it.create = (t, e) => new it({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: H.ZodSet,
  ...X(e)
});
class ft extends Y {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.function)
      return k(r, {
        code: b.invalid_type,
        expected: N.function,
        received: r.parsedType
      }), U;
    function n(o, l) {
      return dr({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          ur(),
          mt
        ].filter((c) => !!c),
        issueData: {
          code: b.invalid_arguments,
          argumentsError: l
        }
      });
    }
    function s(o, l) {
      return dr({
        data: o,
        path: r.path,
        errorMaps: [
          r.common.contextualErrorMap,
          r.schemaErrorMap,
          ur(),
          mt
        ].filter((c) => !!c),
        issueData: {
          code: b.invalid_return_type,
          returnTypeError: l
        }
      });
    }
    const i = { errorMap: r.common.contextualErrorMap }, a = r.data;
    if (this._def.returns instanceof vt) {
      const o = this;
      return ge(async function(...l) {
        const c = new Ce([]), u = await o._def.args.parseAsync(l, i).catch((C) => {
          throw c.addIssue(n(l, C)), c;
        }), h = await Reflect.apply(a, this, u);
        return await o._def.returns._def.type.parseAsync(h, i).catch((C) => {
          throw c.addIssue(s(h, C)), c;
        });
      });
    } else {
      const o = this;
      return ge(function(...l) {
        const c = o._def.args.safeParse(l, i);
        if (!c.success)
          throw new Ce([n(l, c.error)]);
        const u = Reflect.apply(a, this, c.data), h = o._def.returns.safeParse(u, i);
        if (!h.success)
          throw new Ce([s(u, h.error)]);
        return h.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new ft({
      ...this._def,
      args: je.create(e).rest(et.create())
    });
  }
  returns(e) {
    return new ft({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, r, n) {
    return new ft({
      args: e || je.create([]).rest(et.create()),
      returns: r || et.create(),
      typeName: H.ZodFunction,
      ...X(n)
    });
  }
}
class It extends Y {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
It.create = (t, e) => new It({
  getter: t,
  typeName: H.ZodLazy,
  ...X(e)
});
class Zt extends Y {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return k(r, {
        received: r.data,
        code: b.invalid_literal,
        expected: this._def.value
      }), U;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
Zt.create = (t, e) => new Zt({
  value: t,
  typeName: H.ZodLiteral,
  ...X(e)
});
function Ms(t, e) {
  return new Je({
    values: t,
    typeName: H.ZodEnum,
    ...X(e)
  });
}
class Je extends Y {
  constructor() {
    super(...arguments), xt.set(this, void 0);
  }
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return k(r, {
        expected: ne.joinValues(n),
        received: r.parsedType,
        code: b.invalid_type
      }), U;
    }
    if (fr(this, xt) || Rs(this, xt, new Set(this._def.values)), !fr(this, xt).has(e.data)) {
      const r = this._getOrReturnCtx(e), n = this._def.values;
      return k(r, {
        received: r.data,
        code: b.invalid_enum_value,
        options: n
      }), U;
    }
    return ge(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return Je.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return Je.create(this.options.filter((n) => !e.includes(n)), {
      ...this._def,
      ...r
    });
  }
}
xt = /* @__PURE__ */ new WeakMap();
Je.create = Ms;
class $t extends Y {
  constructor() {
    super(...arguments), St.set(this, void 0);
  }
  _parse(e) {
    const r = ne.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
    if (n.parsedType !== N.string && n.parsedType !== N.number) {
      const s = ne.objectValues(r);
      return k(n, {
        expected: ne.joinValues(s),
        received: n.parsedType,
        code: b.invalid_type
      }), U;
    }
    if (fr(this, St) || Rs(this, St, new Set(ne.getValidEnumValues(this._def.values))), !fr(this, St).has(e.data)) {
      const s = ne.objectValues(r);
      return k(n, {
        received: n.data,
        code: b.invalid_enum_value,
        options: s
      }), U;
    }
    return ge(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
St = /* @__PURE__ */ new WeakMap();
$t.create = (t, e) => new $t({
  values: t,
  typeName: H.ZodNativeEnum,
  ...X(e)
});
class vt extends Y {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== N.promise && r.common.async === !1)
      return k(r, {
        code: b.invalid_type,
        expected: N.promise,
        received: r.parsedType
      }), U;
    const n = r.parsedType === N.promise ? r.data : Promise.resolve(r.data);
    return ge(n.then((s) => this._def.type.parseAsync(s, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
vt.create = (t, e) => new vt({
  type: t,
  typeName: H.ZodPromise,
  ...X(e)
});
class Oe extends Y {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === H.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e), s = this._def.effect || null, i = {
      addIssue: (a) => {
        k(n, a), a.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return n.path;
      }
    };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const a = s.transform(n.data, i);
      if (n.common.async)
        return Promise.resolve(a).then(async (o) => {
          if (r.value === "aborted")
            return U;
          const l = await this._def.schema._parseAsync({
            data: o,
            path: n.path,
            parent: n
          });
          return l.status === "aborted" ? U : l.status === "dirty" || r.value === "dirty" ? dt(l.value) : l;
        });
      {
        if (r.value === "aborted")
          return U;
        const o = this._def.schema._parseSync({
          data: a,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? U : o.status === "dirty" || r.value === "dirty" ? dt(o.value) : o;
      }
    }
    if (s.type === "refinement") {
      const a = (o) => {
        const l = s.refinement(o, i);
        if (n.common.async)
          return Promise.resolve(l);
        if (l instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (n.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return o.status === "aborted" ? U : (o.status === "dirty" && r.dirty(), a(o.value), { status: r.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((o) => o.status === "aborted" ? U : (o.status === "dirty" && r.dirty(), a(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (n.common.async === !1) {
        const a = this._def.schema._parseSync({
          data: n.data,
          path: n.path,
          parent: n
        });
        if (!nt(a))
          return a;
        const o = s.transform(a.value, i);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: n.data, path: n.path, parent: n }).then((a) => nt(a) ? Promise.resolve(s.transform(a.value, i)).then((o) => ({ status: r.value, value: o })) : a);
    ne.assertNever(s);
  }
}
Oe.create = (t, e, r) => new Oe({
  schema: t,
  typeName: H.ZodEffects,
  effect: e,
  ...X(r)
});
Oe.createWithPreprocess = (t, e, r) => new Oe({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: H.ZodEffects,
  ...X(r)
});
class Ve extends Y {
  _parse(e) {
    return this._getType(e) === N.undefined ? ge(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ve.create = (t, e) => new Ve({
  innerType: t,
  typeName: H.ZodOptional,
  ...X(e)
});
class Xe extends Y {
  _parse(e) {
    return this._getType(e) === N.null ? ge(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Xe.create = (t, e) => new Xe({
  innerType: t,
  typeName: H.ZodNullable,
  ...X(e)
});
class Dt extends Y {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let n = r.data;
    return r.parsedType === N.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Dt.create = (t, e) => new Dt({
  innerType: t,
  typeName: H.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...X(e)
});
class Bt extends Y {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: n.data,
      path: n.path,
      parent: {
        ...n
      }
    });
    return Rt(s) ? s.then((i) => ({
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new Ce(n.common.issues);
        },
        input: n.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new Ce(n.common.issues);
        },
        input: n.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Bt.create = (t, e) => new Bt({
  innerType: t,
  typeName: H.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...X(e)
});
class mr extends Y {
  _parse(e) {
    if (this._getType(e) !== N.nan) {
      const n = this._getOrReturnCtx(e);
      return k(n, {
        code: b.invalid_type,
        expected: N.nan,
        received: n.parsedType
      }), U;
    }
    return { status: "valid", value: e.data };
  }
}
mr.create = (t) => new mr({
  typeName: H.ZodNaN,
  ...X(t)
});
const hl = Symbol("zod_brand");
class an extends Y {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), n = r.data;
    return this._def.type._parse({
      data: n,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class zt extends Y {
  _parse(e) {
    const { status: r, ctx: n } = this._processInputParams(e);
    if (n.common.async)
      return (async () => {
        const i = await this._def.in._parseAsync({
          data: n.data,
          path: n.path,
          parent: n
        });
        return i.status === "aborted" ? U : i.status === "dirty" ? (r.dirty(), dt(i.value)) : this._def.out._parseAsync({
          data: i.value,
          path: n.path,
          parent: n
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: n.data,
        path: n.path,
        parent: n
      });
      return s.status === "aborted" ? U : s.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: n.path,
        parent: n
      });
    }
  }
  static create(e, r) {
    return new zt({
      in: e,
      out: r,
      typeName: H.ZodPipeline
    });
  }
}
class Ht extends Y {
  _parse(e) {
    const r = this._def.innerType._parse(e), n = (s) => (nt(s) && (s.value = Object.freeze(s.value)), s);
    return Rt(r) ? r.then((s) => n(s)) : n(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ht.create = (t, e) => new Ht({
  innerType: t,
  typeName: H.ZodReadonly,
  ...X(e)
});
function js(t, e = {}, r) {
  return t ? yt.create().superRefine((n, s) => {
    var i, a;
    if (!t(n)) {
      const o = typeof e == "function" ? e(n) : typeof e == "string" ? { message: e } : e, l = (a = (i = o.fatal) !== null && i !== void 0 ? i : r) !== null && a !== void 0 ? a : !0, c = typeof o == "string" ? { message: o } : o;
      s.addIssue({ code: "custom", ...c, fatal: l });
    }
  }) : yt.create();
}
const pl = {
  object: ie.lazycreate
};
var H;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(H || (H = {}));
const gl = (t, e = {
  message: `Input not instance of ${t.name}`
}) => js((r) => r instanceof t, e), Fs = Le.create, Is = Ke.create, ml = mr.create, yl = We.create, Zs = Nt.create, vl = st.create, Cl = hr.create, bl = Pt.create, _l = Vt.create, wl = yt.create, xl = et.create, Sl = De.create, El = pr.create, Ll = ke.create, kl = ie.create, Ol = ie.strictCreate, Al = Mt.create, Tl = _r.create, Rl = jt.create, Nl = je.create, Pl = Ft.create, Vl = gr.create, Ml = it.create, jl = ft.create, Fl = It.create, Il = Zt.create, Zl = Je.create, $l = $t.create, Dl = vt.create, Yn = Oe.create, Bl = Ve.create, Hl = Xe.create, Ul = Oe.createWithPreprocess, ql = zt.create, zl = () => Fs().optional(), Kl = () => Is().optional(), Wl = () => Zs().optional(), Jl = {
  string: ((t) => Le.create({ ...t, coerce: !0 })),
  number: ((t) => Ke.create({ ...t, coerce: !0 })),
  boolean: ((t) => Nt.create({
    ...t,
    coerce: !0
  })),
  bigint: ((t) => We.create({ ...t, coerce: !0 })),
  date: ((t) => st.create({ ...t, coerce: !0 }))
}, Xl = U;
var tt = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: mt,
  setErrorMap: U1,
  getErrorMap: ur,
  makeIssue: dr,
  EMPTY_PATH: q1,
  addIssueToContext: k,
  ParseStatus: he,
  INVALID: U,
  DIRTY: dt,
  OK: ge,
  isAborted: Kr,
  isDirty: Wr,
  isValid: nt,
  isAsync: Rt,
  get util() {
    return ne;
  },
  get objectUtil() {
    return zr;
  },
  ZodParsedType: N,
  getParsedType: Ze,
  ZodType: Y,
  datetimeRegex: Vs,
  ZodString: Le,
  ZodNumber: Ke,
  ZodBigInt: We,
  ZodBoolean: Nt,
  ZodDate: st,
  ZodSymbol: hr,
  ZodUndefined: Pt,
  ZodNull: Vt,
  ZodAny: yt,
  ZodUnknown: et,
  ZodNever: De,
  ZodVoid: pr,
  ZodArray: ke,
  ZodObject: ie,
  ZodUnion: Mt,
  ZodDiscriminatedUnion: _r,
  ZodIntersection: jt,
  ZodTuple: je,
  ZodRecord: Ft,
  ZodMap: gr,
  ZodSet: it,
  ZodFunction: ft,
  ZodLazy: It,
  ZodLiteral: Zt,
  ZodEnum: Je,
  ZodNativeEnum: $t,
  ZodPromise: vt,
  ZodEffects: Oe,
  ZodTransformer: Oe,
  ZodOptional: Ve,
  ZodNullable: Xe,
  ZodDefault: Dt,
  ZodCatch: Bt,
  ZodNaN: mr,
  BRAND: hl,
  ZodBranded: an,
  ZodPipeline: zt,
  ZodReadonly: Ht,
  custom: js,
  Schema: Y,
  ZodSchema: Y,
  late: pl,
  get ZodFirstPartyTypeKind() {
    return H;
  },
  coerce: Jl,
  any: wl,
  array: Ll,
  bigint: yl,
  boolean: Zs,
  date: vl,
  discriminatedUnion: Tl,
  effect: Yn,
  enum: Zl,
  function: jl,
  instanceof: gl,
  intersection: Rl,
  lazy: Fl,
  literal: Il,
  map: Vl,
  nan: ml,
  nativeEnum: $l,
  never: Sl,
  null: _l,
  nullable: Hl,
  number: Is,
  object: kl,
  oboolean: Wl,
  onumber: Kl,
  optional: Bl,
  ostring: zl,
  pipeline: ql,
  preprocess: Ul,
  promise: Dl,
  record: Pl,
  set: Ml,
  strictObject: Ol,
  string: Fs,
  symbol: Cl,
  transformer: Yn,
  tuple: Nl,
  undefined: bl,
  union: Al,
  unknown: xl,
  void: El,
  NEVER: Xl,
  ZodIssueCode: b,
  quotelessJson: H1,
  ZodError: Ce
});
const Gl = (t) => t.filter((e) => !e.fields.every((r) => r.hidden)).length, Qn = (t, e) => `group-${t}.${e}`, Yl = (t) => t.name === "email" ? {
  setValueAs: (e) => e.trim()
} : {}, Ql = (t, e = {}) => {
  let r = tt.string().email({
    message: e.validationEmail ?? "form.validation.is_email"
  });
  if (t.required)
    r = r.min(1, { message: e.validationRequired ?? "form.validation.required" });
  else
    return tt.union([tt.literal(""), r]);
  return r;
}, ec = (t, e = {}) => {
  const r = t.reduce((n, s) => {
    if (s.hidden)
      return n;
    if (s.name === "email")
      return n[s.name] = Ql(s, e), n;
    let i = tt.string();
    return s.required && (i = i.min(1, e.validationRequired ?? "form.validation.required")), n[s.name] = i, n;
  }, {});
  return tt.object(r);
}, tc = (t, e = {}) => {
  const r = t.reduce((n, s, i) => (n[`group-${i}`] = ec(s.fields, e), n), {});
  return r.privacyConditions = tt.boolean().refine((n) => n, {
    message: e.acceptValidation ?? "form.request-quote.accept-conditions.validation"
  }), tt.object(r);
};
function rc(t, e) {
  const { privacyConditionsLink: r, privacyConditionsLinks: n, regionSpecificLinksEnabled: s } = t, i = s ? n ?? {} : {};
  return e && i[e] ? i[e] : r || (Object.values(i).find((o) => o && o.length > 0) ?? "");
}
const nc = ({
  schema: t,
  onSubmit: e,
  shouldAutoFocus: r = !0,
  mode: n = "default",
  lang: s,
  fieldLabels: i,
  overrides: a
}) => {
  const o = n === "preview", l = Xr(null), { t: c } = yr("translation"), [u, h] = rs(0), f = Gt(() => (t == null ? void 0 : t.configuration.fieldGroups.filter((W) => W.fields.some((O) => !O.hidden))) ?? [], [t]), C = Gl(f), w = Math.min(u, Math.max(0, C - 1)), _ = Gt(
    () => tc(f, {
      validationRequired: a == null ? void 0 : a.validationRequired,
      validationEmail: a == null ? void 0 : a.validationEmail,
      acceptValidation: a == null ? void 0 : a.acceptValidation
    }),
    [f, a == null ? void 0 : a.validationRequired, a == null ? void 0 : a.validationEmail, a == null ? void 0 : a.acceptValidation]
  ), E = Gt(
    () => t ? rc(t.configuration, s) : "",
    [t, s]
  ), j = a != null && a.acceptText ? /* @__PURE__ */ re(
    bn,
    {
      defaults: a.acceptText,
      components: { lnk: /* @__PURE__ */ re("a", { href: E, target: "_blank", rel: "noopener noreferrer" }) }
    }
  ) : /* @__PURE__ */ re(
    bn,
    {
      i18nKey: "form.request-quote.accept-conditions.text",
      components: {
        1: /* @__PURE__ */ re("a", { href: E, target: "_blank", rel: "noopener noreferrer" })
      }
    }
  ), {
    register: x,
    handleSubmit: Z,
    setFocus: V,
    formState: { errors: $ },
    trigger: D
  } = L1({
    mode: "onTouched",
    // @ts-expect-error zodResolver resolves a second zod copy (packages/clp-api-types/node_modules/zod),
    // so the schema's ParseInput is nominally incompatible with this package's. Dedupe zod to remove.
    resolver: o ? void 0 : T1(_)
  }), A = Zr(async () => {
    !o && !await D(`group-${w}`, { shouldFocus: !0 }) || h((W) => W + 1);
  }, [w, o, D]), q = Zr(() => {
    h((W) => W - 1);
  }, []);
  ht(() => {
    if (!(f.length === 0 || !l.current) && r) {
      const W = l.current.querySelector(
        `input[name="${Qn(w, f[w].fields[0].name)}"]`
      );
      W == null || W.focus({ preventScroll: !0 });
    }
  }, [w, f, V, r]);
  const K = w + 1 === C, te = w === 0;
  return /* @__PURE__ */ xe(
    "form",
    {
      ref: l,
      onSubmit: Z(async (W) => {
        const O = Object.values(W).reduce((T, G) => (typeof G == "object" && (T = Object.assign(T, G)), T), {});
        await e(O);
      }),
      name: "contact-us",
      className: de(ye.form),
      children: [
        /* @__PURE__ */ re(
          "div",
          {
            className: de(ye.body, { [ye.isPreview]: o }),
            inert: o ? "" : void 0,
            children: f == null ? void 0 : f.map((W, O) => /* @__PURE__ */ re("fieldset", { className: ye.fieldset, hidden: w !== O, children: W.fields.filter((T) => !T.hidden).map((T, G) => {
              const p = $[`group-${O}`], v = T.inputElementType === "textarea" ? a1 : s1;
              return /* @__PURE__ */ $e(
                v,
                {
                  ...x(Qn(O, T.name), Yl(T)),
                  label: (i == null ? void 0 : i[T.name]) ?? c(`form.request-quote.label.${T.name}`),
                  key: G,
                  required: T.required,
                  error: p && p[T.name],
                  className: de(ye.field, { [ye.isShort]: T.short }),
                  requiredLabel: a == null ? void 0 : a.requiredHint,
                  withValidation: !0,
                  maxLength: T.inputElementType === "textarea" ? void 0 : 255
                }
              );
            }) }, O))
          }
        ),
        /* @__PURE__ */ xe("div", { className: de(ye.footer, { [ye.nonSticky]: o }), children: [
          K && /* @__PURE__ */ re(
            Qo,
            {
              ...x("privacyConditions"),
              error: $.privacyConditions,
              noErrorPlaceholder: !0,
              className: de(ye.policyCheckbox, { [ye.isPreview]: o }),
              label: /* @__PURE__ */ re(pt, { variant: "hint", component: "div", children: j })
            }
          ),
          /* @__PURE__ */ xe("div", { className: ye.footerActions, children: [
            !te && /* @__PURE__ */ re(Or, { className: ye.backButton, variant: "secondary", iconStart: "arrow", onClick: q }),
            K && /* @__PURE__ */ re(Or, { variant: "primary", className: ye.proceedButton, children: (a == null ? void 0 : a.sendButton) ?? c("form.request-quote.submitButton") }),
            !K && /* @__PURE__ */ re(Or, { type: "button", onClick: A, variant: "primary", className: ye.proceedButton, children: (a == null ? void 0 : a.nextButton) ?? c("buttons.next") })
          ] })
        ] })
      ]
    }
  );
}, vc = Cr(nc), Cc = ({ path: t, themeConfig: e }) => {
  ht(() => (r(t), () => {
    n(t);
  }), [t]), ht(() => ((e == null ? void 0 : e.mode) === "dark" ? document.documentElement.classList.add("dark") : document.documentElement.classList.remove("dark"), () => {
    document.documentElement.classList.remove("dark");
  }), [e == null ? void 0 : e.mode]);
  const r = async (s) => {
    if (!s)
      return;
    const i = document.createElement("link");
    i.onload = () => {
      setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
    }, i.setAttribute("rel", "stylesheet"), i.setAttribute("href", s), document.head.appendChild(i);
  }, n = (s) => {
    if (!s)
      return;
    const i = document.querySelector(`link[href='${s}']`);
    if (!i) {
      console.warn("Unable to perform theme cleanup");
      return;
    }
    document.head.removeChild(i);
  };
  return null;
}, sc = /([A-Z]{1,3})(?=[$£¥€])/;
function bc(t, e, r) {
  return t == null ? "" : new Intl.NumberFormat(r, {
    style: "currency",
    currency: e,
    currencyDisplay: "narrowSymbol"
  }).format(t).replace(/ /g, " ").replace(sc, "");
}
const ic = {
  AU: "en-AU",
  CA: "en-CA",
  GB: "en-GB",
  US: "en-US"
};
function ac(t) {
  const e = t.toUpperCase();
  return ic[e] ?? e;
}
function oc(t, e) {
  return new Intl.DateTimeFormat(ac(e), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(t);
}
const lc = /* @__PURE__ */ new Set(["US", "GB", "LR", "MM"]);
function _c(t, e) {
  if (cc(e) === "imperial") {
    const n = t / 25.4;
    return `${uc(n.toFixed(2))}"`;
  }
  return `${Math.round(t)} mm`;
}
function cc({ unitSystem: t, region: e }) {
  return t === "imperial" ? "imperial" : t === "metric" ? "metric" : lc.has(e.toUpperCase()) ? "imperial" : "metric";
}
function uc(t) {
  return t.includes(".") ? t.replace(/\.?0+$/, "") : t;
}
const dc = 1234.56, fc = new Date(Date.UTC(2026, 11, 31, 12, 0, 0));
function wc(t) {
  const e = new Intl.NumberFormat(t, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(dc), r = oc(fc, t);
  return `${e} | ${r}`;
}
export {
  Or as Button,
  Qo as Checkbox,
  en as FormFieldError,
  Xi as Icon,
  s1 as Input,
  Do as LOCALE_STORAGE_KEY,
  vc as RequestQuoteForm,
  a1 as TextArea,
  Cc as Theme,
  pt as Typography,
  oc as formatDate,
  _c as formatDimension,
  bc as formatPrice,
  wc as getRegionPreview,
  Bo as i18next,
  Gi as isIconType,
  rc as resolvePrivacyConditionsLink
};
